import { t as __exportAll } from "../rolldown-runtime-CNktS9qV.mjs";
import axios from "axios";
import { stringify } from "qs";
//#region src/external-api/gen/models/AssetRentRoll.ts
const AssetRentRollRentableUnitState = { Vacant: "Vacant" };
const AssetRentRollRentableUnitState2 = { Occupied: "Occupied" };
const AssetRentRollRentableUnitState3 = { OwnerOccupied: "OwnerOccupied" };
const AssetRentRollRentableUnitState4 = { PartiallyOccupied: "PartiallyOccupied" };
const AssetRentRollRentableUnitState5 = { BlockedByPm: "BlockedByPm" };
const AssetRentRollRentableUnitState6 = { BlockedByRenovation: "BlockedByRenovation" };
//#endregion
//#region src/external-api/gen/models/Attendee.ts
const AttendeeResponseStatus = { needsAction: "needsAction" };
const AttendeeResponseStatus2 = { declined: "declined" };
const AttendeeResponseStatus3 = { tentative: "tentative" };
const AttendeeResponseStatus4 = { accepted: "accepted" };
//#endregion
//#region src/external-api/gen/models/AttendeeArray.ts
const AttendeeArrayResponseStatus = { needsAction: "needsAction" };
const AttendeeArrayResponseStatus2 = { declined: "declined" };
const AttendeeArrayResponseStatus3 = { tentative: "tentative" };
const AttendeeArrayResponseStatus4 = { accepted: "accepted" };
//#endregion
//#region src/external-api/gen/models/BaseCompany.ts
const BaseCompanySellingPartner = {
	"G&B": "G&B",
	HIH: "HIH",
	Tecis: "Tecis",
	PlanetHome: "PlanetHome",
	NoPartner: "NoPartner"
};
const BaseCompanyType = { Bank: "Bank" };
const BaseCompanyType2 = { Realtor: "Realtor" };
const BaseCompanyType3 = { DistributionPartner: "DistributionPartner" };
const BaseCompanyType4 = { Notary: "Notary" };
const BaseCompanyType5 = { PurchasingEntity: "PurchasingEntity" };
const BaseCompanyType6 = { General: "General" };
const BaseCompanyType7 = { KitchenSupplier: "KitchenSupplier" };
const BaseCompanyType8 = { MeasurementsProvider: "MeasurementsProvider" };
const BaseCompanyType9 = { ContractorGeneral: "ContractorGeneral" };
const BaseCompanyType10 = { ContractorCleaning: "ContractorCleaning" };
const BaseCompanyType11 = { ContractorElectricity: "ContractorElectricity" };
const BaseCompanyType12 = { GeneralPropertyManagement: "GeneralPropertyManagement" };
const BaseCompanyType13 = { IndividualPropertyManager: "IndividualPropertyManager" };
const BaseCompanyType14 = { DistrictCourt: "DistrictCourt" };
const BaseCompanyType15 = { ConstructionAuthority: "ConstructionAuthority" };
const BaseCompanyType16 = { WaterProvier: "WaterProvier" };
const BaseCompanyType17 = { ElectricityProvider: "ElectricityProvider" };
const BaseCompanyType18 = { GasProvider: "GasProvider" };
const BaseCompanyType19 = { FacilityManagement: "FacilityManagement" };
const BaseCompanyType20 = { ServiceProvider: "ServiceProvider" };
const BaseCompanyType21 = { SellingNotary: "SellingNotary" };
const BaseCompanyType22 = { MaterialSupplier: "MaterialSupplier" };
const BaseCompanyType23 = { TaxOffice: "TaxOffice" };
const BaseCompanyType24 = { AssetManagement: "AssetManagement" };
const BaseCompanyType25 = { HrCompany: "HrCompany" };
const BaseCompanyType26 = { OfficeSupplier: "OfficeSupplier" };
const BaseCompanyType27 = { TravelProvider: "TravelProvider" };
const BaseCompanyType28 = { RentalCarCompany: "RentalCarCompany" };
const BaseCompanyType29 = { MarketingCompany: "MarketingCompany" };
const BaseCompanyType30 = { HardwareProvider: "HardwareProvider" };
const BaseCompanyType31 = { SoftwareCompany: "SoftwareCompany" };
const BaseCompanyType32 = { Seller: "Seller" };
const BaseCompanyType33 = { Buyer: "Buyer" };
const BaseCompanyType34 = { AssetPartner: "AssetPartner" };
const BaseCompanyType35 = { Tenant: "Tenant" };
const BaseCompanyType36 = { RentingLead: "RentingLead" };
const BaseCompanyType37 = { AuditingFirm: "AuditingFirm" };
const BaseCompanyType38 = { Planning: "Planning" };
const BaseCompanyType39 = { PlanningAndConstructions: "PlanningAndConstructions" };
const BaseCompanyType40 = { Proptech: "Proptech" };
//#endregion
//#region src/external-api/gen/models/BaseInvoiceSchema.ts
const BaseInvoiceSchemaVatClass = {
	StandardRate: "StandardRate",
	LuxembourgStandardRate: "LuxembourgStandardRate",
	ReducedRate: "ReducedRate",
	ReverseCharge: "ReverseCharge",
	ImportTax: "ImportTax",
	ThirdCountriesOutsideEU: "ThirdCountriesOutsideEU",
	TaxFreeEEUPurchases: "TaxFreeEEUPurchases",
	EUPurchases: "EUPurchases",
	Exempt: "Exempt",
	VATZero: "VATZero"
};
const BaseInvoiceSchemaInvoiceType = {
	Normal: "Normal",
	PaymentReminder: "PaymentReminder",
	CreditNote: "CreditNote",
	RenovationGuarantee: "RenovationGuarantee",
	RecurrentPayment: "RecurrentPayment",
	MasterTemplate: "MasterTemplate",
	Consolidated: "Consolidated",
	Other: "Other"
};
const BaseInvoiceSchemaCostType = {
	Notary: "Notary",
	LandTransferTaxes: "LandTransferTaxes",
	AgencyFee: "AgencyFee",
	PropertyRegistration: "PropertyRegistration",
	ReferralFee: "ReferralFee",
	OtherAncillaryCost: "OtherAncillaryCost",
	AgencyFeeSelling: "AgencyFeeSelling",
	OtherAncillaryCostSelling: "OtherAncillaryCostSelling",
	GeneralRenovationCost: "GeneralRenovationCost",
	KitchenCost: "KitchenCost",
	OtherRenovationCost: "OtherRenovationCost",
	HomeOwnersFee: "HomeOwnersFee",
	Utilities: "Utilities",
	PropertyTax: "PropertyTax",
	Internal: "Internal",
	HomeSpecialFee: "HomeSpecialFee",
	PropertyRelatedExpenses: "PropertyRelatedExpenses",
	PropertyValuation: "PropertyValuation",
	RecruitingExpenses: "RecruitingExpenses",
	OfficeExpenses: "OfficeExpenses",
	MarketingExpenses: "MarketingExpenses",
	EquipmentExpensesAndDA: "EquipmentExpensesAndDA",
	TechnologyAndAnalytics: "TechnologyAndAnalytics",
	TravelExpenses: "TravelExpenses",
	OtherAdministrativeCosts: "OtherAdministrativeCosts",
	ExternalLabourCosts: "ExternalLabourCosts",
	Training: "Training",
	TeamEvent: "TeamEvent",
	OtherLabourRelatedCosts: "OtherLabourRelatedCosts",
	OfficeRent: "OfficeRent",
	CarAndLeasingCosts: "CarAndLeasingCosts",
	LegalCosts: "LegalCosts",
	ConsultancyCosts: "ConsultancyCosts",
	AdvertisingCosts: "AdvertisingCosts",
	SplitInvoice: "SplitInvoice",
	CarRelatedCosts: "CarRelatedCosts",
	AuditAndTax: "AuditAndTax",
	Payroll: "Payroll",
	VoluntarySocialExpenses: "VoluntarySocialExpenses",
	RepairAndMaintenance: "RepairAndMaintenance",
	RepairAndMaintenanceRecoverable: "RepairAndMaintenanceRecoverable",
	RentReduction: "RentReduction",
	DepositRefund: "DepositRefund",
	UtilitiesRefund: "UtilitiesRefund",
	UtilitiesAdditionalPayment: "UtilitiesAdditionalPayment",
	RepairCosts: "RepairCosts",
	RentGuarantee: "RentGuarantee",
	Livings: "Livings",
	LivingsEquipment: "LivingsEquipment",
	LivingsCleaningCosts: "LivingsCleaningCosts",
	LivingsTelephoneCosts: "LivingsTelephoneCosts",
	LivingsUtilities: "LivingsUtilities",
	LivingsOther: "LivingsOther",
	NonRecsMaintenance: "NonRecsMaintenance",
	RenovationCostsEnergyEfficiency: "RenovationCostsEnergyEfficiency",
	RenovationCostsInteriorResidential: "RenovationCostsInteriorResidential",
	RenovationCostsInteriorCommercial: "RenovationCostsInteriorCommercial",
	RenovationCostsGeneralCapex: "RenovationCostsGeneralCapex",
	RenovationCostsExpansion: "RenovationCostsExpansion",
	RenovationCostsRoofConversionCapex: "RenovationCostsRoofConversionCapex",
	RenovationCostsRoofExtensionCapex: "RenovationCostsRoofExtensionCapex",
	RenovationCostsSeparateNewBuildingCapex: "RenovationCostsSeparateNewBuildingCapex",
	LettingFees: "LettingFees",
	OperatingPartnerFee: "OperatingPartnerFee",
	OperatingPartnerFeeAcquisition: "OperatingPartnerFeeAcquisition",
	OperatingPartnerFeeCapexTIManagement: "OperatingPartnerFeeCapexTIManagement",
	OperatingPartnerFeePropertyManagement: "OperatingPartnerFeePropertyManagement",
	OperatingPartnerFeeAssetManagement: "OperatingPartnerFeeAssetManagement",
	OperatingPartnerFeeDisposition: "OperatingPartnerFeeDisposition",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	OperationalRecs: "OperationalRecs",
	ExternalServiceProvider: "ExternalServiceProvider",
	ExternalServiceProviderReneo: "ExternalServiceProviderReneo",
	EnergyConsultancyCosts: "EnergyConsultancyCosts",
	PlanningCosts: "PlanningCosts",
	InstiLandTransferTaxes: "InstiLandTransferTaxes",
	InstiNotary: "InstiNotary",
	InstiPropertyRegistration: "InstiPropertyRegistration",
	InstiAgencyFeePurchasing: "InstiAgencyFeePurchasing",
	InstiAgencyFeeSelling: "InstiAgencyFeeSelling",
	InstiOtherCostSelling: "InstiOtherCostSelling",
	OutsourcedPropertyManagementCost: "OutsourcedPropertyManagementCost",
	OutsourcedPlanningCosts: "OutsourcedPlanningCosts",
	DueDiligenceCosts: "DueDiligenceCosts",
	GERAccountingFees: "GERAccountingFees",
	GERLegalFees: "GERLegalFees",
	GERTaxAdvisoryFees: "GERTaxAdvisoryFees",
	GEROtherStructureCosts: "GEROtherStructureCosts",
	GEROtherExtraordinaryIncome: "GEROtherExtraordinaryIncome",
	GEROtherExtraordinaryExpenses: "GEROtherExtraordinaryExpenses",
	LUXAccountingFees: "LUXAccountingFees",
	LUXLegalFees: "LUXLegalFees",
	LUXTaxAdvisoryFees: "LUXTaxAdvisoryFees",
	LUXPeaksideFees: "LUXPeaksideFees",
	LUXAuditFees: "LUXAuditFees",
	LUXOtherStructureCosts: "LUXOtherStructureCosts",
	LUXOtherExtraordinaryIncome: "LUXOtherExtraordinaryIncome",
	LUXOtherExtraordinaryExpenses: "LUXOtherExtraordinaryExpenses"
};
const BaseInvoiceSchemaState = {
	New: "New",
	Assigned: "Assigned",
	WaitingForAuthorization: "WaitingForAuthorization",
	ManualReview: "ManualReview",
	Approved: "Approved",
	ReadyForPayment: "ReadyForPayment",
	FailedToExport: "FailedToExport",
	Paid: "Paid",
	PartiallyPaid: "PartiallyPaid",
	ManuallyPaid: "ManuallyPaid",
	ReadyForDrawdown: "ReadyForDrawdown",
	DrawdownCompleted: "DrawdownCompleted",
	InDispute: "InDispute",
	Rejected: "Rejected",
	Reimbursed: "Reimbursed",
	Duplicated: "Duplicated",
	ReadyForBooking: "ReadyForBooking",
	Authorized: "Authorized",
	WaitingForDrawdown: "WaitingForDrawdown",
	WaitingForExternalReview: "WaitingForExternalReview"
};
const BaseInvoiceSchemaSource = {
	Upload: "Upload",
	Email: "Email"
};
//#endregion
//#region src/external-api/gen/models/BaseReviewProcess.ts
const BaseReviewProcessReviewProcessState = {
	Requested: "Requested",
	Cancelled: "Cancelled",
	Approved: "Approved",
	Rejected: "Rejected"
};
//#endregion
//#region src/external-api/gen/models/CompanyEmploymentRelation.ts
const CompanyEmploymentRelationCompanyRole = {
	Employee: "Employee",
	ManagingDirector: "ManagingDirector"
};
//#endregion
//#region src/external-api/gen/models/ContactPerson.ts
const ContactPersonContactType = {
	User: "User",
	PurchasingEntityDirector: "PurchasingEntityDirector",
	Seller: "Seller",
	Buyer: "Buyer",
	RealEstateAgent: "RealEstateAgent",
	Banker: "Banker",
	Notary: "Notary",
	GeneralContractor: "GeneralContractor",
	KitchenSupplier: "KitchenSupplier",
	MeasurementProvider: "MeasurementProvider",
	WEGVerwaltung: "WEGVerwaltung",
	IndividualPropertyManagement: "IndividualPropertyManagement",
	Tenant: "Tenant",
	RentingLead: "RentingLead",
	Generic: "Generic",
	Neighbor: "Neighbor",
	Craftsman: "Craftsman",
	SellingNotary: "SellingNotary",
	SalesRepresentative: "SalesRepresentative",
	BankAccountOwner: "BankAccountOwner",
	MaterialSupplier: "MaterialSupplier",
	EnergyEfficiencyConsultant: "EnergyEfficiencyConsultant",
	TechnicalDDExpert: "TechnicalDDExpert",
	LegalDDExpert: "LegalDDExpert",
	RentingPartner: "RentingPartner",
	AssetPartner: "AssetPartner",
	TaxDDConsultant: "TaxDDConsultant",
	ExternalAuditor: "ExternalAuditor"
};
//#endregion
//#region src/external-api/gen/models/ContactRelation.ts
const ContactRelationRelationName = { Seller: "Seller" };
const ContactRelationRelationName2 = { Realtor: "Realtor" };
const ContactRelationRelationName3 = { Notary: "Notary" };
const ContactRelationRelationName4 = { Bank: "Bank" };
const ContactRelationRelationName5 = { DistrictCourt: "DistrictCourt" };
const ContactRelationRelationName6 = { ConstructionAuthority: "ConstructionAuthority" };
const ContactRelationRelationName7 = { ExecutionNotary: "ExecutionNotary" };
const ContactRelationRelationName8 = { DocumentingNotary: "DocumentingNotary" };
const ContactRelationRelationName9 = { MeasurementProvider: "MeasurementProvider" };
const ContactRelationRelationName10 = { GeneralContractor: "GeneralContractor" };
const ContactRelationRelationName11 = { KitchenSupplier: "KitchenSupplier" };
const ContactRelationRelationName12 = { DistributionPartner: "DistributionPartner" };
const ContactRelationRelationName13 = { SellingNotary: "SellingNotary" };
const ContactRelationRelationName14 = { Buyer: "Buyer" };
const ContactRelationRelationName15 = { SellingExecutionNotary: "SellingExecutionNotary" };
const ContactRelationRelationName16 = { SellingDocumentingNotary: "SellingDocumentingNotary" };
const ContactRelationRelationName17 = { ServiceProvider: "ServiceProvider" };
const ContactRelationRelationName18 = { FacilityManagement: "FacilityManagement" };
const ContactRelationRelationName19 = { GasProvider: "GasProvider" };
const ContactRelationRelationName20 = { ElectricityProvider: "ElectricityProvider" };
const ContactRelationRelationName21 = { WaterProvider: "WaterProvider" };
const ContactRelationRelationName22 = { GeneralPropertyManagement: "GeneralPropertyManagement" };
const ContactRelationRelationName23 = { Tenant: "Tenant" };
const ContactRelationRelationName24 = { SalesRepresentative: "SalesRepresentative" };
const ContactRelationRelationName25 = { FinancingAdvisor: "FinancingAdvisor" };
const ContactRelationRelationName26 = { Craftsman: "Craftsman" };
const ContactRelationRelationName27 = { Neighbor: "Neighbor" };
const ContactRelationRelationName28 = { EnergyEfficiencyConsultant: "EnergyEfficiencyConsultant" };
const ContactRelationRelationName29 = { TechnicalDDExpert: "TechnicalDDExpert" };
const ContactRelationRelationName30 = { LegalDDExpert: "LegalDDExpert" };
const ContactRelationRelationName31 = { RentingPartner: "RentingPartner" };
const ContactRelationRelationName32 = { TaxDDConsultant: "TaxDDConsultant" };
const ContactRelationRelationName33 = { AssetPartner: "AssetPartner" };
const ContactRelationRelationName34 = { CandidateAssetPartner: "CandidateAssetPartner" };
const ContactRelationRelationName35 = { TechnicalProjectLead: "TechnicalProjectLead" };
const ContactRelationRelationName36 = { PurchasingEntity: "PurchasingEntity" };
const ContactRelationRelationName37 = { General: "General" };
const ContactRelationRelationName38 = { ContractorGeneral: "ContractorGeneral" };
const ContactRelationRelationName39 = { ContractorCleaning: "ContractorCleaning" };
const ContactRelationRelationName40 = { ContractorElectricity: "ContractorElectricity" };
const ContactRelationRelationName41 = { IndividualPropertyManager: "IndividualPropertyManager" };
const ContactRelationRelationName42 = { MaterialSupplier: "MaterialSupplier" };
const ContactRelationRelationName43 = { TaxOffice: "TaxOffice" };
const ContactRelationRelationName44 = { AssetManagement: "AssetManagement" };
const ContactRelationRelationName45 = { HrCompany: "HrCompany" };
const ContactRelationRelationName46 = { OfficeSupplier: "OfficeSupplier" };
const ContactRelationRelationName47 = { TravelProvider: "TravelProvider" };
const ContactRelationRelationName48 = { RentalCarCompany: "RentalCarCompany" };
const ContactRelationRelationName49 = { MarketingCompany: "MarketingCompany" };
const ContactRelationRelationName50 = { HardwareProvider: "HardwareProvider" };
const ContactRelationRelationName51 = { SoftwareCompany: "SoftwareCompany" };
const ContactRelationRelationName52 = { RentingLead: "RentingLead" };
const ContactRelationRelationName53 = { AuditingFirm: "AuditingFirm" };
const ContactRelationRelationName54 = { Planning: "Planning" };
const ContactRelationRelationName55 = { PlanningAndConstructions: "PlanningAndConstructions" };
const ContactRelationRelationName56 = { Proptech: "Proptech" };
//#endregion
//#region src/external-api/gen/models/DocumentApproval.ts
const DocumentApprovalStatus = { Pending: "Pending" };
const DocumentApprovalStatus2 = { Approved: "Approved" };
const DocumentApprovalStatus3 = { Rejected: "Rejected" };
//#endregion
//#region src/external-api/gen/models/DocumentSchema.ts
const DocumentSchemaDocumentCategory = {
	General: "General",
	Sourcing: "Sourcing",
	Purchasing: "Purchasing",
	Renovation: "Renovation",
	Marketing: "Marketing",
	PortfolioManagement: "PortfolioManagement",
	PropertyManagement: "PropertyManagement",
	Accounting: "Accounting",
	PostRenovation: "PostRenovation",
	Renting: "Renting",
	Selling: "Selling",
	Orientation: "Orientation",
	Livings: "Livings",
	SalesPackage: "SalesPackage",
	SellingRegion: "SellingRegion",
	Land: "Land",
	Building: "Building",
	RentalContract: "RentalContract",
	ObjectManagement: "ObjectManagement",
	PurchasingContract: "PurchasingContract",
	DueDiligence: "DueDiligence",
	MfhOther: "MfhOther",
	Taxes: "Taxes",
	GeneralCompany: "GeneralCompany",
	ShareholderAndStatutes: "ShareholderAndStatutes",
	CompanyContracts: "CompanyContracts",
	Financing: "Financing",
	KYC: "KYC"
};
const DocumentSchemaDocumentType = {
	EbicsAuthorizationLetter: "EbicsAuthorizationLetter",
	PaymentOrder: "PaymentOrder",
	LoanOfferTermSheet: "LoanOfferTermSheet",
	LoanContract: "LoanContract",
	PortfolioInvestmentPlan: "PortfolioInvestmentPlan",
	PurchasingDrawdownRequest: "PurchasingDrawdownRequest",
	InvoicesDrawdownRequest: "InvoicesDrawdownRequest",
	RenovationAcceptanceReport: "RenovationAcceptanceReport",
	ConstructionSiteReport: "ConstructionSiteReport",
	GeneratedInvoiceSubscriptionInvoice: "GeneratedInvoiceSubscriptionInvoice",
	InvoiceApprovalSlip: "InvoiceApprovalSlip",
	InvoiceInXML: "InvoiceInXML",
	InvoiceInPDF: "InvoiceInPDF",
	InvoiceOutPDF: "InvoiceOutPDF",
	Invoice: "Invoice",
	SubscriptionContract: "SubscriptionContract",
	ProtocolArchived: "ProtocolArchived",
	Protocol2024: "Protocol2024",
	Protocol2025: "Protocol2025",
	Protocol2026: "Protocol2026",
	ArchiveOfResolutions: "ArchiveOfResolutions",
	InvitationETV: "InvitationETV",
	AnnualStatement: "AnnualStatement",
	EconomicPlan: "EconomicPlan",
	HomeOwnerFeeStatement: "HomeOwnerFeeStatement",
	BuildingInsurance: "BuildingInsurance",
	EnergyCertificate: "EnergyCertificate",
	PropertyTaxNotice: "PropertyTaxNotice",
	ConstructionBurdenStatement: "ConstructionBurdenStatement",
	AbstractOfTitle: "AbstractOfTitle",
	DeclarationOfCondominium: "DeclarationOfCondominium",
	AmendmentToDeclarationOfDivision: "AmendmentToDeclarationOfDivision",
	AllowanceOfEntrySectionII: "AllowanceOfEntrySectionII",
	SeparationDeclaration: "SeparationDeclaration",
	PartitionPlan: "PartitionPlan",
	Floorplans: "Floorplans",
	ViewsAndSections: "ViewsAndSections",
	LivingSpaceCalculation: "LivingSpaceCalculation",
	ConstructionDescriptionBuilding: "ConstructionDescriptionBuilding",
	HouseRules: "HouseRules",
	LandRegisterMap: "LandRegisterMap",
	ManagementAgreement: "ManagementAgreement",
	SpecialAssessments: "SpecialAssessments",
	Other: "Other",
	EstateMedia: "EstateMedia",
	BuildingPermit: "BuildingPermit",
	Expose: "Expose",
	ExposeExternal: "ExposeExternal",
	ContractDraft: "ContractDraft",
	ContractNotarized: "ContractNotarized",
	LandCharge: "LandCharge",
	PaymentNotice: "PaymentNotice",
	RegistrationNotice: "RegistrationNotice",
	NotaryCorrespondence: "NotaryCorrespondence",
	AdministrationCorrespondence: "AdministrationCorrespondence",
	NotaryRegistrationReservation: "NotaryRegistrationReservation",
	SEPAMandateHomeOwnersFee: "SEPAMandateHomeOwnersFee",
	PurchasingHandoverProtocol: "PurchasingHandoverProtocol",
	ProofOfPayment: "ProofOfPayment",
	SellingExpose: "SellingExpose",
	PromotionExpose: "PromotionExpose",
	CustomizedSellingExpose: "CustomizedSellingExpose",
	SellingExposeSlip: "SellingExposeSlip",
	SellingCalculations: "SellingCalculations",
	SellingCalculationsSlip: "SellingCalculationsSlip",
	SellingContractDraft: "SellingContractDraft",
	SellingContractSummary: "SellingContractSummary",
	SellingContractNotarized: "SellingContractNotarized",
	SellingPaymentNotice: "SellingPaymentNotice",
	SellingRenovationAcceptanceProtocol: "SellingRenovationAcceptanceProtocol",
	SellingRegistrationNotice: "SellingRegistrationNotice",
	SellingNotaryCorrespondence: "SellingNotaryCorrespondence",
	SellingAdministrationCorrespondence: "SellingAdministrationCorrespondence",
	SellingDataSheet: "SellingDataSheet",
	SellingNotaryRegistrationReservation: "SellingNotaryRegistrationReservation",
	SellingHandoverProtocol: "SellingHandoverProtocol",
	SellingExpertReportWithCapEx: "SellingExpertReportWithCapEx",
	SellingExpertReport: "SellingExpertReport",
	SellingResidualValueCertificate: "SellingResidualValueCertificate",
	BuildingModernizationMeasures: "BuildingModernizationMeasures",
	SellingExposeLocation: "SellingExposeLocation",
	SellingAbstractOfTitle: "SellingAbstractOfTitle",
	NotaryCertification: "NotaryCertification",
	SellingProofOfPayment: "SellingProofOfPayment",
	LandRegisterParkingSpace: "LandRegisterParkingSpace",
	BuildingAcceptancePowerOfAttorney: "BuildingAcceptancePowerOfAttorney",
	LocationProfile: "LocationProfile",
	BuildingInformationModel: "BuildingInformationModel",
	FloorPlanSketch: "FloorPlanSketch",
	DimensionedFloorPlan: "DimensionedFloorPlan",
	DimensionedFloorPlanPlanned: "DimensionedFloorPlanPlanned",
	CadFile: "CadFile",
	CadFilePlanned: "CadFilePlanned",
	LV: "LV",
	LongLV: "LongLV",
	Kitchen: "Kitchen",
	KitchenContracted: "KitchenContracted",
	Inspection: "Inspection",
	ConstructionContract: "ConstructionContract",
	ContractorOffer: "ContractorOffer",
	RevisionDocumentation: "RevisionDocumentation",
	ReportsCalculationsAppraisals: "ReportsCalculationsAppraisals",
	ConstructionGuarantee: "ConstructionGuarantee",
	BathPlan: "BathPlan",
	StructuredLvSheet: "StructuredLvSheet",
	RenovationCostTrackingSheet: "RenovationCostTrackingSheet",
	MfhConstructionPlan: "MfhConstructionPlan",
	ConstructionDescriptionRenovation: "ConstructionDescriptionRenovation",
	PostRenovationDimensionedFloorPlan: "PostRenovationDimensionedFloorPlan",
	SalesPartnerFloorPlan: "SalesPartnerFloorPlan",
	LivingSpaceCalculations: "LivingSpaceCalculations",
	BeforeAfterPictures: "BeforeAfterPictures",
	PostRenovationAcceptanceProtocol: "PostRenovationAcceptanceProtocol",
	RoomVolumeCalculation: "RoomVolumeCalculation",
	RentContract: "RentContract",
	RentIncrease: "RentIncrease",
	AcceptanceProtocol: "AcceptanceProtocol",
	HeatingBill: "HeatingBill",
	Correspondence: "Correspondence",
	SelfAssessmentSheet: "SelfAssessmentSheet",
	ID: "ID",
	SalaryInformation: "SalaryInformation",
	SchufaReport: "SchufaReport",
	Deposit: "Deposit",
	HousingProviderConfirmation: "HousingProviderConfirmation",
	SEVContract: "SEVContract",
	SEVContractWithFee: "SEVContractWithFee",
	SEVContractWithoutFee: "SEVContractWithoutFee",
	SEVPoA: "SEVPoA",
	DkbInvestorVerification: "DkbInvestorVerification",
	SEVCoverLetter: "SEVCoverLetter",
	GDPRTenant: "GDPRTenant",
	GDPROwner: "GDPROwner",
	PersonalIDOwner: "PersonalIDOwner",
	SEPAManadateHouseGeld: "SEPAManadateHouseGeld",
	SEPATenant: "SEPATenant",
	WithdrawlInstructionTenant: "WithdrawlInstructionTenant",
	WithdrawlInstructionOwner: "WithdrawlInstructionOwner",
	TenantCorrespondence: "TenantCorrespondence",
	OwnerCorrespondence: "OwnerCorrespondence",
	UtilitiesCorrespondence: "UtilitiesCorrespondence",
	CancellationLease: "CancellationLease",
	CancellationLeaseConfirmation: "CancellationLeaseConfirmation",
	CancellationSEVContract: "CancellationSEVContract",
	CancellationSEVContractConfirmation: "CancellationSEVContractConfirmation",
	CondoTerminationAgreement: "CondoTerminationAgreement",
	LegalDisputes: "LegalDisputes",
	EstateInvestorShare: "EstateInvestorShare",
	EstateAggregatedInvestorShare: "EstateAggregatedInvestorShare",
	WEGAnnualStatement: "WEGAnnualStatement",
	InvoicesPropertyManagement: "InvoicesPropertyManagement",
	EstateRentReport: "EstateRentReport",
	CorrespondencePropertyManagement: "CorrespondencePropertyManagement",
	SalutationWEG: "SalutationWEG",
	InvestorPayout: "InvestorPayout",
	InvestorYearlyPayout: "InvestorYearlyPayout",
	InvestorYearlyPayoutLegacy: "InvestorYearlyPayoutLegacy",
	RentArrearNotice: "RentArrearNotice",
	RentGuarantee: "RentGuarantee",
	DunningNotice: "DunningNotice",
	EnforcementNotice: "EnforcementNotice",
	BKAStatement: "BKAStatement",
	BKAHeatingStatement: "BKAHeatingStatement",
	BKAAllocationCalculation: "BKAAllocationCalculation",
	BKAHouseholdCosts: "BKAHouseholdCosts",
	BKADeposit: "BKADeposit",
	SelfDeclarationTenant: "SelfDeclarationTenant",
	QuestionnaireTenant: "QuestionnaireTenant",
	RentalContractDraft: "RentalContractDraft",
	SalaryRecordPropesctiveTenant: "SalaryRecordPropesctiveTenant",
	SchufaProspectiveTenant: "SchufaProspectiveTenant",
	AnnualServiceChargeCalculation: "AnnualServiceChargeCalculation",
	PersonalIDProspectiveTenant: "PersonalIDProspectiveTenant",
	Safe: "Safe",
	Estate: "Estate",
	BasementRoom: "BasementRoom",
	AtticRoom: "AtticRoom",
	CommonRoom: "CommonRoom",
	Parking: "Parking",
	FurniturePlanPdf: "FurniturePlanPdf",
	FurniturePlanDwg: "FurniturePlanDwg",
	RequestedOrderLists: "RequestedOrderLists",
	ContractedOrderLists: "ContractedOrderLists",
	PartnerBrochure: "PartnerBrochure",
	InvoicesFittings: "InvoicesFittings",
	InvoicesServiceProvider: "InvoicesServiceProvider",
	Internet: "Internet",
	LivingsAcceptanceProtocol: "LivingsAcceptanceProtocol",
	PortfolioInspectionSheet: "PortfolioInspectionSheet",
	CreditLineCashflowPredictions: "CreditLineCashflowPredictions",
	CreditLineBudgetCosts: "CreditLineBudgetCosts",
	EstateInvestorCashflow: "EstateInvestorCashflow",
	SalesPackageFinalSheet: "SalesPackageFinalSheet",
	SalesPackageDataSheet: "SalesPackageDataSheet",
	SalesPackageNotarySheet: "SalesPackageNotarySheet",
	SalesPackageChecklist: "SalesPackageChecklist",
	SalesPackageSellingCompanies: "SalesPackageSellingCompanies",
	PurchasingDocumentsSheet: "PurchasingDocumentsSheet",
	SellingDocumentsSheet: "SellingDocumentsSheet",
	SellingDataChecklist: "SellingDataChecklist",
	SellingEstatesDataSheet: "SellingEstatesDataSheet",
	CashflowStatementSheet: "CashflowStatementSheet",
	InvestorPaymentSlip: "InvestorPaymentSlip",
	InvestorPayoutStatement: "InvestorPayoutStatement",
	DefectReport: "DefectReport",
	SalesPackageUserUploadedPriceList: "SalesPackageUserUploadedPriceList",
	SalesPackageUserUploadedDataSheet: "SalesPackageUserUploadedDataSheet",
	SalesPackageUserUploadedChecklist: "SalesPackageUserUploadedChecklist",
	SalesPackageUserUploadedPhotoAlbum: "SalesPackageUserUploadedPhotoAlbum",
	SellingRegionBrochure: "SellingRegionBrochure",
	TransferRecurrentPaymentsSEPAXmlList: "TransferRecurrentPaymentsSEPAXmlList",
	CondoSellingPresentation: "CondoSellingPresentation",
	SalesPartnerFlyer: "SalesPartnerFlyer",
	PropertyManagementOwnerBrochure: "PropertyManagementOwnerBrochure",
	ModelPurchaseContract: "ModelPurchaseContract",
	ModelRentalContract: "ModelRentalContract",
	ModelPropertyManagementContractWithFee: "ModelPropertyManagementContractWithFee",
	ModelPropertyManagementLawOfAttorney: "ModelPropertyManagementLawOfAttorney",
	ModelPropertyManagementGDPR: "ModelPropertyManagementGDPR",
	CurrentLandRegisterExtract: "CurrentLandRegisterExtract",
	EncumbranceBasisInDeptII: "EncumbranceBasisInDeptII",
	CurrentParcelMap: "CurrentParcelMap",
	CurrentPlanningRights: "CurrentPlanningRights",
	InformationUrbanRenewalArea: "InformationUrbanRenewalArea",
	InformationUrbanConservationArea: "InformationUrbanConservationArea",
	InformationMonumentProtection: "InformationMonumentProtection",
	SocialPreservationOrdinance: "SocialPreservationOrdinance",
	InformationBuildingChargeRegister: "InformationBuildingChargeRegister",
	ExtractContaminatedSitesRegister: "ExtractContaminatedSitesRegister",
	ExtractDevelopmentAndExpansionContributions: "ExtractDevelopmentAndExpansionContributions",
	UrbanDevelopmentContracts: "UrbanDevelopmentContracts",
	SoilReportOrContaminatedSites: "SoilReportOrContaminatedSites",
	GroundLease: "GroundLease",
	VerificationOfExplosiveOrdnance: "VerificationOfExplosiveOrdnance",
	OngoingLegalDisputesRegardingProperty: "OngoingLegalDisputesRegardingProperty",
	BuildingEnergyCertificate: "BuildingEnergyCertificate",
	SectionDrawingsBuildingElevations: "SectionDrawingsBuildingElevations",
	FloorPlansIncludingAreaCalculation: "FloorPlansIncludingAreaCalculation",
	BuildingApplicationOrBuildingPermit: "BuildingApplicationOrBuildingPermit",
	WarrantyGuarantees: "WarrantyGuarantees",
	OverviewOfPastOngoingAndPlannedModernization: "OverviewOfPastOngoingAndPlannedModernization",
	InsuranceClaimsLast5Years: "InsuranceClaimsLast5Years",
	ModernizationsOfIndividualApartments: "ModernizationsOfIndividualApartments",
	DeclarationOfDivisionIfDivided: "DeclarationOfDivisionIfDivided",
	OngoingLegalDisputesRegardingObject: "OngoingLegalDisputesRegardingObject",
	TenantList: "TenantList",
	RentIncreaseLetters: "RentIncreaseLetters",
	RentalAgreements: "RentalAgreements",
	ListOfExistingRentalDeposits: "ListOfExistingRentalDeposits",
	OperatingCostStatement: "OperatingCostStatement",
	TenantHandoverProtocols: "TenantHandoverProtocols",
	ListOfCurrentDefectComplaintsReductionsArrears: "ListOfCurrentDefectComplaintsReductionsArrears",
	OngoingLegalDisputesWithTenants: "OngoingLegalDisputesWithTenants",
	ManagementContracts: "ManagementContracts",
	MaintenanceProtocols: "MaintenanceProtocols",
	ListOfAgeOfInstallations: "ListOfAgeOfInstallations",
	InsurancesMainlyCurrentBuildingInsurance: "InsurancesMainlyCurrentBuildingInsurance",
	PropertyTaxAssessmentAndUnitValueNotice: "PropertyTaxAssessmentAndUnitValueNotice",
	ListOfCraftsmen: "ListOfCraftsmen",
	PurchaseContractDraft: "PurchaseContractDraft",
	AttachmentsToPurchaseContract: "AttachmentsToPurchaseContract",
	PowersOfAttorney: "PowersOfAttorney",
	MfhExpose: "MfhExpose",
	SuperStructures: "SuperStructures",
	LandValueMap: "LandValueMap",
	CommercialOwnerRegisterExtract: "CommercialOwnerRegisterExtract",
	NeighbourhoodAgreements: "NeighbourhoodAgreements",
	LandUsePlan: "LandUsePlan",
	OtherPermits: "OtherPermits",
	OfficialCertificates: "OfficialCertificates",
	BuildingInventoryPlans: "BuildingInventoryPlans",
	BuildingSections: "BuildingSections",
	BuildingStatics: "BuildingStatics",
	BuildingHeating: "BuildingHeating",
	BuildingVentilation: "BuildingVentilation",
	BuildingAirConditioning: "BuildingAirConditioning",
	BuildingSanitary: "BuildingSanitary",
	BuildingElectrical: "BuildingElectrical",
	FireProtection: "FireProtection",
	SpecialistPlannerContracts: "SpecialistPlannerContracts",
	SpecialRealEstateAdditionalInformation: "SpecialRealEstateAdditionalInformation",
	BuildingAdditonalInformation: "BuildingAdditonalInformation",
	Terminations: "Terminations",
	TaxAssessmentNotices: "TaxAssessmentNotices",
	TaxOtherMunicipalCharges: "TaxOtherMunicipalCharges",
	TaxCorrectionBalancesAndPeriods: "TaxCorrectionBalancesAndPeriods",
	TaxValueAddTenants: "TaxValueAddTenants",
	TaxValueAddSellers: "TaxValueAddSellers",
	TaxOptionRatesAndAreaKeys: "TaxOptionRatesAndAreaKeys",
	CompanyOverview: "CompanyOverview",
	CommercialRegisterExtract: "CommercialRegisterExtract",
	TransferOfShares: "TransferOfShares",
	RegisterExcerpts: "RegisterExcerpts",
	ShareRegister: "ShareRegister",
	ListOfShareholders: "ListOfShareholders",
	ArticlesOfAssociation: "ArticlesOfAssociation",
	ArticlesOfAssociationResolutionAmmendments: "ArticlesOfAssociationResolutionAmmendments",
	ArticlesOfAssociationResolutions: "ArticlesOfAssociationResolutions",
	DistributionOfProfitsResolutions: "DistributionOfProfitsResolutions",
	CapitalEndowmentResolutions: "CapitalEndowmentResolutions",
	OtherResolutions: "OtherResolutions",
	ManagingDirectorResolutions: "ManagingDirectorResolutions",
	Minutes: "Minutes",
	AgreementsWithManagement: "AgreementsWithManagement",
	CompanyAccountant: "CompanyAccountant",
	CompanyAuditor: "CompanyAuditor",
	CompanyTaxConsultant: "CompanyTaxConsultant",
	CompanyOtherContracts: "CompanyOtherContracts",
	LoanAgreement: "LoanAgreement",
	LandChargeDeed: "LandChargeDeed",
	DeclarationOfSecurityPurpose: "DeclarationOfSecurityPurpose",
	DeclarationOfAssignment: "DeclarationOfAssignment",
	Pledges: "Pledges",
	PurchasingTerminationDocuments: "PurchasingTerminationDocuments",
	FinancialAnnualStatements: "FinancialAnnualStatements",
	FinancialTaxes: "FinancialTaxes",
	FinancialManagementReporting: "FinancialManagementReporting",
	FinancialLiabilities: "FinancialLiabilities",
	FinancialCurrentBalances: "FinancialCurrentBalances",
	FinancialOtherInformation: "FinancialOtherInformation",
	FoundationReport: "FoundationReport",
	ImportantCorrespondence: "ImportantCorrespondence",
	AdditionalCostsInvoice: "AdditionalCostsInvoice",
	MFHSummary: "MFHSummary",
	MFHInvestmentCaseExportableSheet: "MFHInvestmentCaseExportableSheet",
	AssetPipelineSheet: "AssetPipelineSheet",
	ExternalInvoiceExport: "ExternalInvoiceExport",
	AssetTenderingProcess: "AssetTenderingProcess",
	DueDiligenceOnSiteInspection: "DueDiligenceOnSiteInspection",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	CommercialDD: "CommercialDD",
	EnergyConsultation: "EnergyConsultation",
	Vicinity: "Vicinity",
	PurchasingOffer: "PurchasingOffer",
	CourtageAgreement: "CourtageAgreement",
	ExclusivityAgreement: "ExclusivityAgreement",
	BillingOrInvoices: "BillingOrInvoices",
	InvestmentProposal: "InvestmentProposal",
	KYCDraft: "KYCDraft",
	IDSeller: "IDSeller",
	AddendumContractDraft: "AddendumContractDraft",
	AddendumContract: "AddendumContract",
	Auftragsempfehlung: "Auftragsempfehlung",
	Entscheidungsvorlage: "Entscheidungsvorlage",
	Werkvertrag: "Werkvertrag",
	Planervertrag: "Planervertrag"
};
//#endregion
//#region src/external-api/gen/models/DocumentSignature.ts
const DocumentSignatureStatus = { Pending: "Pending" };
const DocumentSignatureStatus2 = { InProgress: "InProgress" };
const DocumentSignatureStatus3 = { Signed: "Signed" };
const DocumentSignatureStatus4 = { Rejected: "Rejected" };
//#endregion
//#region src/external-api/gen/models/ExternalAttendeeArray.ts
const ExternalAttendeeArrayResponseStatus = { needsAction: "needsAction" };
const ExternalAttendeeArrayResponseStatus2 = { declined: "declined" };
const ExternalAttendeeArrayResponseStatus3 = { tentative: "tentative" };
const ExternalAttendeeArrayResponseStatus4 = { accepted: "accepted" };
//#endregion
//#region src/external-api/gen/models/ExternalAttendeeSchema.ts
const ExternalAttendeeSchemaResponseStatus = { needsAction: "needsAction" };
const ExternalAttendeeSchemaResponseStatus2 = { declined: "declined" };
const ExternalAttendeeSchemaResponseStatus3 = { tentative: "tentative" };
const ExternalAttendeeSchemaResponseStatus4 = { accepted: "accepted" };
//#endregion
//#region src/external-api/gen/models/ExternalCalendarEvent.ts
const ExternalCalendarEventCalendarType = { General: "General" };
const ExternalCalendarEventCalendarType2 = { Sourcing: "Sourcing" };
const ExternalCalendarEventCalendarType3 = { Purchasing: "Purchasing" };
const ExternalCalendarEventCalendarType4 = { Renovation: "Renovation" };
const ExternalCalendarEventCalendarType5 = { Renting: "Renting" };
const ExternalCalendarEventCalendarType6 = { Selling: "Selling" };
const ExternalCalendarEventCalendarType7 = { PropertyManagement: "PropertyManagement" };
const ExternalCalendarEventCalendarType8 = { RentableUnit: "RentableUnit" };
const AttendeesResponseStatus = { needsAction: "needsAction" };
const AttendeesResponseStatus2 = { declined: "declined" };
const AttendeesResponseStatus3 = { tentative: "tentative" };
const AttendeesResponseStatus4 = { accepted: "accepted" };
const ExternalAttendeesResponseStatus = { needsAction: "needsAction" };
const ExternalAttendeesResponseStatus2 = { declined: "declined" };
const ExternalAttendeesResponseStatus3 = { tentative: "tentative" };
const ExternalAttendeesResponseStatus4 = { accepted: "accepted" };
//#endregion
//#region src/external-api/gen/models/ExternalInvoice.ts
const ExternalInvoiceVatClass = {
	StandardRate: "StandardRate",
	LuxembourgStandardRate: "LuxembourgStandardRate",
	ReducedRate: "ReducedRate",
	ReverseCharge: "ReverseCharge",
	ImportTax: "ImportTax",
	ThirdCountriesOutsideEU: "ThirdCountriesOutsideEU",
	TaxFreeEEUPurchases: "TaxFreeEEUPurchases",
	EUPurchases: "EUPurchases",
	Exempt: "Exempt",
	VATZero: "VATZero"
};
const ExternalInvoiceInvoiceType = {
	Normal: "Normal",
	PaymentReminder: "PaymentReminder",
	CreditNote: "CreditNote",
	RenovationGuarantee: "RenovationGuarantee",
	RecurrentPayment: "RecurrentPayment",
	MasterTemplate: "MasterTemplate",
	Consolidated: "Consolidated",
	Other: "Other"
};
const ExternalInvoiceCostType = {
	Notary: "Notary",
	LandTransferTaxes: "LandTransferTaxes",
	AgencyFee: "AgencyFee",
	PropertyRegistration: "PropertyRegistration",
	ReferralFee: "ReferralFee",
	OtherAncillaryCost: "OtherAncillaryCost",
	AgencyFeeSelling: "AgencyFeeSelling",
	OtherAncillaryCostSelling: "OtherAncillaryCostSelling",
	GeneralRenovationCost: "GeneralRenovationCost",
	KitchenCost: "KitchenCost",
	OtherRenovationCost: "OtherRenovationCost",
	HomeOwnersFee: "HomeOwnersFee",
	Utilities: "Utilities",
	PropertyTax: "PropertyTax",
	Internal: "Internal",
	HomeSpecialFee: "HomeSpecialFee",
	PropertyRelatedExpenses: "PropertyRelatedExpenses",
	PropertyValuation: "PropertyValuation",
	RecruitingExpenses: "RecruitingExpenses",
	OfficeExpenses: "OfficeExpenses",
	MarketingExpenses: "MarketingExpenses",
	EquipmentExpensesAndDA: "EquipmentExpensesAndDA",
	TechnologyAndAnalytics: "TechnologyAndAnalytics",
	TravelExpenses: "TravelExpenses",
	OtherAdministrativeCosts: "OtherAdministrativeCosts",
	ExternalLabourCosts: "ExternalLabourCosts",
	Training: "Training",
	TeamEvent: "TeamEvent",
	OtherLabourRelatedCosts: "OtherLabourRelatedCosts",
	OfficeRent: "OfficeRent",
	CarAndLeasingCosts: "CarAndLeasingCosts",
	LegalCosts: "LegalCosts",
	ConsultancyCosts: "ConsultancyCosts",
	AdvertisingCosts: "AdvertisingCosts",
	SplitInvoice: "SplitInvoice",
	CarRelatedCosts: "CarRelatedCosts",
	AuditAndTax: "AuditAndTax",
	Payroll: "Payroll",
	VoluntarySocialExpenses: "VoluntarySocialExpenses",
	RepairAndMaintenance: "RepairAndMaintenance",
	RepairAndMaintenanceRecoverable: "RepairAndMaintenanceRecoverable",
	RentReduction: "RentReduction",
	DepositRefund: "DepositRefund",
	UtilitiesRefund: "UtilitiesRefund",
	UtilitiesAdditionalPayment: "UtilitiesAdditionalPayment",
	RepairCosts: "RepairCosts",
	RentGuarantee: "RentGuarantee",
	Livings: "Livings",
	LivingsEquipment: "LivingsEquipment",
	LivingsCleaningCosts: "LivingsCleaningCosts",
	LivingsTelephoneCosts: "LivingsTelephoneCosts",
	LivingsUtilities: "LivingsUtilities",
	LivingsOther: "LivingsOther",
	NonRecsMaintenance: "NonRecsMaintenance",
	RenovationCostsEnergyEfficiency: "RenovationCostsEnergyEfficiency",
	RenovationCostsInteriorResidential: "RenovationCostsInteriorResidential",
	RenovationCostsInteriorCommercial: "RenovationCostsInteriorCommercial",
	RenovationCostsGeneralCapex: "RenovationCostsGeneralCapex",
	RenovationCostsExpansion: "RenovationCostsExpansion",
	RenovationCostsRoofConversionCapex: "RenovationCostsRoofConversionCapex",
	RenovationCostsRoofExtensionCapex: "RenovationCostsRoofExtensionCapex",
	RenovationCostsSeparateNewBuildingCapex: "RenovationCostsSeparateNewBuildingCapex",
	LettingFees: "LettingFees",
	OperatingPartnerFee: "OperatingPartnerFee",
	OperatingPartnerFeeAcquisition: "OperatingPartnerFeeAcquisition",
	OperatingPartnerFeeCapexTIManagement: "OperatingPartnerFeeCapexTIManagement",
	OperatingPartnerFeePropertyManagement: "OperatingPartnerFeePropertyManagement",
	OperatingPartnerFeeAssetManagement: "OperatingPartnerFeeAssetManagement",
	OperatingPartnerFeeDisposition: "OperatingPartnerFeeDisposition",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	OperationalRecs: "OperationalRecs",
	ExternalServiceProvider: "ExternalServiceProvider",
	ExternalServiceProviderReneo: "ExternalServiceProviderReneo",
	EnergyConsultancyCosts: "EnergyConsultancyCosts",
	PlanningCosts: "PlanningCosts",
	InstiLandTransferTaxes: "InstiLandTransferTaxes",
	InstiNotary: "InstiNotary",
	InstiPropertyRegistration: "InstiPropertyRegistration",
	InstiAgencyFeePurchasing: "InstiAgencyFeePurchasing",
	InstiAgencyFeeSelling: "InstiAgencyFeeSelling",
	InstiOtherCostSelling: "InstiOtherCostSelling",
	OutsourcedPropertyManagementCost: "OutsourcedPropertyManagementCost",
	OutsourcedPlanningCosts: "OutsourcedPlanningCosts",
	DueDiligenceCosts: "DueDiligenceCosts",
	GERAccountingFees: "GERAccountingFees",
	GERLegalFees: "GERLegalFees",
	GERTaxAdvisoryFees: "GERTaxAdvisoryFees",
	GEROtherStructureCosts: "GEROtherStructureCosts",
	GEROtherExtraordinaryIncome: "GEROtherExtraordinaryIncome",
	GEROtherExtraordinaryExpenses: "GEROtherExtraordinaryExpenses",
	LUXAccountingFees: "LUXAccountingFees",
	LUXLegalFees: "LUXLegalFees",
	LUXTaxAdvisoryFees: "LUXTaxAdvisoryFees",
	LUXPeaksideFees: "LUXPeaksideFees",
	LUXAuditFees: "LUXAuditFees",
	LUXOtherStructureCosts: "LUXOtherStructureCosts",
	LUXOtherExtraordinaryIncome: "LUXOtherExtraordinaryIncome",
	LUXOtherExtraordinaryExpenses: "LUXOtherExtraordinaryExpenses"
};
const ExternalInvoiceState = {
	New: "New",
	Assigned: "Assigned",
	WaitingForAuthorization: "WaitingForAuthorization",
	ManualReview: "ManualReview",
	Approved: "Approved",
	ReadyForPayment: "ReadyForPayment",
	FailedToExport: "FailedToExport",
	Paid: "Paid",
	PartiallyPaid: "PartiallyPaid",
	ManuallyPaid: "ManuallyPaid",
	ReadyForDrawdown: "ReadyForDrawdown",
	DrawdownCompleted: "DrawdownCompleted",
	InDispute: "InDispute",
	Rejected: "Rejected",
	Reimbursed: "Reimbursed",
	Duplicated: "Duplicated",
	ReadyForBooking: "ReadyForBooking",
	Authorized: "Authorized",
	WaitingForDrawdown: "WaitingForDrawdown",
	WaitingForExternalReview: "WaitingForExternalReview"
};
const ExternalInvoiceSource = {
	Upload: "Upload",
	Email: "Email"
};
const ReviewProcessReviewProcessState = {
	Requested: "Requested",
	Cancelled: "Cancelled",
	Approved: "Approved",
	Rejected: "Rejected"
};
//#endregion
//#region src/external-api/gen/models/ExternalLinkDto.ts
const ExternalLinkDtoStatus = { ACTIVE: "ACTIVE" };
const ExternalLinkDtoStatus2 = { OUTDATED: "OUTDATED" };
//#endregion
//#region src/external-api/gen/models/ExternalMfh.ts
const ExternalMfhEstateType = { Apartment: "Apartment" };
const ExternalMfhEstateType2 = { House: "House" };
const ExternalMfhEstateType3 = { Office: "Office" };
const ExternalMfhChannelName = { OTHER_ONLINE_PORTAL: "OTHER_ONLINE_PORTAL" };
const ExternalMfhChannelName2 = { BROKER_OPEN_MANDATE: "BROKER_OPEN_MANDATE" };
const ExternalMfhChannelName3 = { BROKER_EXCLUSIVE_ACCESS: "BROKER_EXCLUSIVE_ACCESS" };
const ExternalMfhChannelName4 = { DIRECT_OWNER_APPROACH: "DIRECT_OWNER_APPROACH" };
const ExternalMfhChannelName5 = { NETWORK_REFERRAL: "NETWORK_REFERRAL" };
const ExternalMfhChannelName6 = { M_AND_A_PROCESS: "M_AND_A_PROCESS" };
const ExternalMfhChannelName7 = { INSOLVENCY_PROCESS: "INSOLVENCY_PROCESS" };
const ExternalMfhChannelName8 = { OTHER: "OTHER" };
const ExternalMfhChannelName9 = { IMMO24: "IMMO24" };
const ExternalMfhChannelName10 = { GEOMAP: "GEOMAP" };
const ExternalMfhChannelName11 = { PRICEHUBBLE: "PRICEHUBBLE" };
const ExternalMfhSource = { PAPI: "PAPI" };
const ExternalMfhSource2 = { COCKPIT: "COCKPIT" };
const ExternalMfhSource3 = { DISCOVERER: "DISCOVERER" };
const ExternalMfhSource4 = { IMPORT: "IMPORT" };
const ExternalMfhSource5 = { EXTERNAL: "EXTERNAL" };
const ExternalLinksStatus = { ACTIVE: "ACTIVE" };
const ExternalLinksStatus2 = { OUTDATED: "OUTDATED" };
//#endregion
//#region src/external-api/gen/models/ExternalMfhAttributes.ts
const ExternalMfhAttributesBuildingEnergyRating = { NO_INFORMATION: "NO_INFORMATION" };
const ExternalMfhAttributesBuildingEnergyRating2 = { ENERGY_REQUIRED: "ENERGY_REQUIRED" };
const ExternalMfhAttributesBuildingEnergyRating3 = { ENERGY_CONSUMPTION: "ENERGY_CONSUMPTION" };
const ExternalMfhAttributesAdjoiningBuilding = { OneSide: "OneSide" };
const ExternalMfhAttributesAdjoiningBuilding2 = { TwoSide: "TwoSide" };
const ExternalMfhAttributesAdjoiningBuilding3 = { Absent: "Absent" };
const ExternalMfhAttributesWaterHeating = { Boiler: "Boiler" };
const ExternalMfhAttributesWaterHeating2 = { ViaHeating: "ViaHeating" };
const ExternalMfhAttributesRoofShape = { Hipped: "Hipped" };
const ExternalMfhAttributesRoofShape2 = { Saddle: "Saddle" };
const ExternalMfhAttributesRoofShape3 = { Pitched: "Pitched" };
const ExternalMfhAttributesRoofShape4 = { Flat: "Flat" };
const ExternalMfhAttributesRoofShape5 = { Mansard: "Mansard" };
const ExternalMfhAttributesRoofOrientation = { N: "N" };
const ExternalMfhAttributesRoofOrientation2 = { NE: "NE" };
const ExternalMfhAttributesRoofOrientation3 = { E: "E" };
const ExternalMfhAttributesRoofOrientation4 = { SE: "SE" };
const ExternalMfhAttributesRoofOrientation5 = { S: "S" };
const ExternalMfhAttributesRoofOrientation6 = { SW: "SW" };
const ExternalMfhAttributesRoofOrientation7 = { W: "W" };
const ExternalMfhAttributesRoofOrientation8 = { NW: "NW" };
const ExternalMfhAttributesRoofUse = { FacadeWorthPreserving: "FacadeWorthPreserving" };
const ExternalMfhAttributesRoofUse2 = { SingleSkinMasonry: "SingleSkinMasonry" };
const ExternalMfhAttributesRoofUse3 = { DoubleSkinMasonry: "DoubleSkinMasonry" };
const ExternalMfhAttributesWindowGlazing = { One: "One" };
const ExternalMfhAttributesWindowGlazing2 = { Two: "Two" };
const ExternalMfhAttributesWindowGlazing3 = { Three: "Three" };
const ExternalMfhAttributesWindowGlazing4 = { BoxWindows: "BoxWindows" };
const ExternalMfhAttributesCellarHeating = { Heated: "Heated" };
const ExternalMfhAttributesCellarHeating2 = { PartiallyHeated: "PartiallyHeated" };
const ExternalMfhAttributesCellarHeating3 = { NotHeated: "NotHeated" };
const ExternalMfhAttributesExitType = { MFH: "MFH" };
const ExternalMfhAttributesExitType2 = { SingleUnit: "SingleUnit" };
const ExternalMfhAttributesExitType3 = { MFHSingleUnit: "MFHSingleUnit" };
const ExternalMfhAttributesSplitStatus = { ToBeSplit: "ToBeSplit" };
const ExternalMfhAttributesSplitStatus2 = { AlreadySplit: "AlreadySplit" };
const ExternalMfhAttributesSplitStatus3 = { PleaseFillOut: "PleaseFillOut" };
const ExternalMfhAttributesSplitStatus4 = { NoInputNeeded: "NoInputNeeded" };
const ExternalMfhAttributesRiwisLocation = { Simple: "Simple" };
const ExternalMfhAttributesRiwisLocation2 = { SimpleToAverage: "SimpleToAverage" };
const ExternalMfhAttributesRiwisLocation3 = { Average: "Average" };
const ExternalMfhAttributesRiwisLocation4 = { AverageToGood: "AverageToGood" };
const ExternalMfhAttributesRiwisLocation5 = { Good: "Good" };
const ExternalMfhAttributesRiwisLocation6 = { GoodToVeryGood: "GoodToVeryGood" };
const ExternalMfhAttributesRiwisLocation7 = { VeryGood: "VeryGood" };
const ExternalMfhAttributesRiwisLocation8 = { NoInputNeeded: "NoInputNeeded" };
const ExternalMfhAttributesRiwisLocation9 = { PleaseFillOut: "PleaseFillOut" };
const ExternalMfhAttributesRestrictions = { UrbanisticQuirk: "UrbanisticQuirk" };
const ExternalMfhAttributesRestrictions2 = { CompositionOfTheResidentPopulation: "CompositionOfTheResidentPopulation" };
const ExternalMfhAttributesRestrictions3 = { RedevelopmentArea: "RedevelopmentArea" };
const ExternalMfhAttributesRestrictions4 = { HeritageBuilding: "HeritageBuilding" };
const ExternalMfhAttributesRestrictions5 = { GroundLease: "GroundLease" };
const ExternalMfhAttributesRestrictions6 = { RentControlOrRentSubsidy: "RentControlOrRentSubsidy" };
const ExternalMfhAttributesRestrictions7 = { Other: "Other" };
const ExternalMfhAttributesRestrictions8 = { None: "None" };
const ExternalMfhAttributesInvestmentRiskProfile = {
	CorePlus: "CorePlus",
	ValueAdd: "ValueAdd"
};
//#endregion
//#region src/external-api/gen/models/ExternalMfhSheetEmbedding.ts
const EmbeddingConfigPrecacheStatus = { none: "none" };
const EmbeddingConfigPrecacheStatus2 = { pending: "pending" };
const EmbeddingConfigPrecacheStatus3 = { deferred: "deferred" };
const EmbeddingConfigPrecacheStatus4 = { ready: "ready" };
const EmbeddingConfigPrecacheStatus5 = { failed: "failed" };
const EmbeddingConfigPrecacheFailureReason = { rendered_with_errors: "rendered_with_errors" };
const EmbeddingConfigPrecacheFailureReason2 = { unreachable: "unreachable" };
const EmbeddingConfigPrecacheFailureReason3 = { timeout: "timeout" };
const EmbeddingConfigPrecacheFailureReason4 = { render_failed: "render_failed" };
//#endregion
//#region src/external-api/gen/models/Media.ts
const MediaCategory = { Listing: "Listing" };
const MediaCategory2 = { Inspection: "Inspection" };
const MediaCategory3 = { PreRenovation: "PreRenovation" };
const MediaCategory4 = { PostRenovation: "PostRenovation" };
const MediaCategory5 = { Renovation: "Renovation" };
const MediaCategory6 = { Avatar: "Avatar" };
const MediaCategory7 = { Other: "Other" };
const MediaCategory8 = { PropertyManagement: "PropertyManagement" };
const MediaCategory9 = { Livings: "Livings" };
const MediaCategory10 = { TechnicalDDInspection: "TechnicalDDInspection" };
const MediaInternalTags = { "listing-title": "listing-title" };
const MediaInternalTags2 = { "floor-plan": "floor-plan" };
const MediaTags = { defect: "defect" };
const MediaTags2 = { publish: "publish" };
const MediaTags3 = { "construction-plan": "construction-plan" };
const MediaTags4 = { inspection: "inspection" };
const MediaTags5 = { "before-after": "before-after" };
const MediaTags6 = { "expose-building": "expose-building" };
const MediaTags7 = { "expose-kitchen": "expose-kitchen" };
const MediaTags8 = { "expose-living-room": "expose-living-room" };
const MediaTags9 = { "expose-bathroom": "expose-bathroom" };
const MediaTags10 = { summary: "summary" };
const MediaTags11 = { "expose-room-1": "expose-room-1" };
const MediaTags12 = { "expose-room-2": "expose-room-2" };
const MediaTags13 = { "expose-room-3": "expose-room-3" };
const MediaTags14 = { parking: "parking" };
const MediaTags15 = { "key-locker": "key-locker" };
const MediaTags16 = { "building-entrance": "building-entrance" };
const MediaTags17 = { "apartment-door": "apartment-door" };
const MediaTags18 = { "template-expose-bathroom": "template-expose-bathroom" };
const MediaTags19 = { "template-expose-kitchen": "template-expose-kitchen" };
const MediaTags20 = { "template-expose-living-room": "template-expose-living-room" };
const MediaTags21 = { "template-expose-room-1": "template-expose-room-1" };
const MediaTags22 = { "template-expose-room-2": "template-expose-room-2" };
const MediaTags23 = { "template-expose-room-3": "template-expose-room-3" };
const MediaTags24 = { "renting-management": "renting-management" };
const MediaTags25 = { "exterior-views": "exterior-views" };
const MediaTags26 = { apartments: "apartments" };
const MediaTags27 = { "commercial-properties": "commercial-properties" };
const MediaTags28 = { marketing: "marketing" };
//#endregion
//#region src/external-api/gen/models/MediaFileVariant.ts
const MediaFileVariantVariant = { Thumb: "Thumb" };
const MediaFileVariantVariant2 = { Listing: "Listing" };
//#endregion
//#region src/external-api/gen/models/MfhDdQuestion.ts
const CommentsConstructionCraft2 = {
	Demolition: "Demolition",
	HSE: "HSE",
	Bricklayer: "Bricklayer",
	Drywall: "Drywall",
	Painting: "Painting",
	Tiling: "Tiling",
	Flooring: "Flooring",
	Carpenter: "Carpenter",
	Kitchen: "Kitchen",
	Finishing: "Finishing",
	Electrical: "Electrical",
	Other: "Other"
};
const CommentsType2 = {
	"estate-details": "estate-details",
	"estate-defects": "estate-defects",
	"estate-investment-cases": "estate-investment-cases",
	"estate-selling-notary": "estate-selling-notary",
	"mfh-details": "mfh-details",
	"mfh-renovation-projects": "mfh-renovation-projects",
	"mfh-dd-overview": "mfh-dd-overview",
	"mfh-building": "mfh-building",
	"rent-tenancy": "rent-tenancy",
	"investor-info": "investor-info",
	"owner-management": "owner-management",
	"tenant-management": "tenant-management",
	"estate-management": "estate-management",
	"annual-service-charge-statement": "annual-service-charge-statement",
	"monthly-investor-share": "monthly-investor-share",
	"addendum-internal": "addendum-internal",
	"addendum-external": "addendum-external",
	"mfh-construction-plan": "mfh-construction-plan",
	"mfh-construction-plan-version": "mfh-construction-plan-version",
	"mfh-construction-plan-version-internal": "mfh-construction-plan-version-internal",
	"contract-internal": "contract-internal",
	"contract-external": "contract-external"
};
//#endregion
//#region src/external-api/gen/models/MfhDdQuestionRead.ts
const CommentsConstructionCraft = {
	Demolition: "Demolition",
	HSE: "HSE",
	Bricklayer: "Bricklayer",
	Drywall: "Drywall",
	Painting: "Painting",
	Tiling: "Tiling",
	Flooring: "Flooring",
	Carpenter: "Carpenter",
	Kitchen: "Kitchen",
	Finishing: "Finishing",
	Electrical: "Electrical",
	Other: "Other"
};
const CommentsType = {
	"estate-details": "estate-details",
	"estate-defects": "estate-defects",
	"estate-investment-cases": "estate-investment-cases",
	"estate-selling-notary": "estate-selling-notary",
	"mfh-details": "mfh-details",
	"mfh-renovation-projects": "mfh-renovation-projects",
	"mfh-dd-overview": "mfh-dd-overview",
	"mfh-building": "mfh-building",
	"rent-tenancy": "rent-tenancy",
	"investor-info": "investor-info",
	"owner-management": "owner-management",
	"tenant-management": "tenant-management",
	"estate-management": "estate-management",
	"annual-service-charge-statement": "annual-service-charge-statement",
	"monthly-investor-share": "monthly-investor-share",
	"addendum-internal": "addendum-internal",
	"addendum-external": "addendum-external",
	"mfh-construction-plan": "mfh-construction-plan",
	"mfh-construction-plan-version": "mfh-construction-plan-version",
	"mfh-construction-plan-version-internal": "mfh-construction-plan-version-internal",
	"contract-internal": "contract-internal",
	"contract-external": "contract-external"
};
//#endregion
//#region src/external-api/gen/models/OpenQuestion.ts
const OpenQuestionTopic = {
	LandSituation: "LandSituation",
	BuildingDocuments: "BuildingDocuments",
	RentalContractDocuments: "RentalContractDocuments",
	ObjectManagement: "ObjectManagement",
	Litigation: "Litigation",
	Authorities: "Authorities",
	Tax: "Tax",
	PurchasingContract: "PurchasingContract",
	Other: "Other"
};
const OpenQuestionStatus = {
	Open: "Open",
	Asked: "Asked",
	AnswerReceived: "AnswerReceived",
	AnswerReviewed: "AnswerReviewed",
	ReviewedCritical: "ReviewedCritical",
	ReviewedPendingClarification: "ReviewedPendingClarification"
};
const OpenQuestionPriority = {
	Low: "Low",
	Medium: "Medium",
	High: "High"
};
const CommentsConstructionCraft3 = {
	Demolition: "Demolition",
	HSE: "HSE",
	Bricklayer: "Bricklayer",
	Drywall: "Drywall",
	Painting: "Painting",
	Tiling: "Tiling",
	Flooring: "Flooring",
	Carpenter: "Carpenter",
	Kitchen: "Kitchen",
	Finishing: "Finishing",
	Electrical: "Electrical",
	Other: "Other"
};
const CommentsType3 = {
	"estate-details": "estate-details",
	"estate-defects": "estate-defects",
	"estate-investment-cases": "estate-investment-cases",
	"estate-selling-notary": "estate-selling-notary",
	"mfh-details": "mfh-details",
	"mfh-renovation-projects": "mfh-renovation-projects",
	"mfh-dd-overview": "mfh-dd-overview",
	"mfh-building": "mfh-building",
	"rent-tenancy": "rent-tenancy",
	"investor-info": "investor-info",
	"owner-management": "owner-management",
	"tenant-management": "tenant-management",
	"estate-management": "estate-management",
	"annual-service-charge-statement": "annual-service-charge-statement",
	"monthly-investor-share": "monthly-investor-share",
	"addendum-internal": "addendum-internal",
	"addendum-external": "addendum-external",
	"mfh-construction-plan": "mfh-construction-plan",
	"mfh-construction-plan-version": "mfh-construction-plan-version",
	"mfh-construction-plan-version-internal": "mfh-construction-plan-version-internal",
	"contract-internal": "contract-internal",
	"contract-external": "contract-external"
};
//#endregion
//#region src/external-api/gen/models/ParkingSpace.ts
const ParkingSpaceParkingSpaceType = {
	UndergroundGarage: "UndergroundGarage",
	Garage: "Garage",
	NoInformation: "NoInformation",
	StreetParking: "StreetParking",
	CarPark: "CarPark",
	NA: "NA",
	Carport: "Carport",
	Duplex: "Duplex",
	Outside: "Outside"
};
//#endregion
//#region src/external-api/gen/models/RentalContractSchema.ts
const RentalContractSchemaRentIncreaseType = {
	NO_INCREASE: "NO_INCREASE",
	MANUAL: "MANUAL",
	IRI: "IRI",
	FRI: "FRI"
};
const RentalContractSchemaApartmentCondition = {
	Refurbished: "Refurbished",
	Old: "Old",
	Rentable: "Rentable"
};
const RentalContractSchemaCondoSalesCondition = {
	EEOnly: "EEOnly",
	EEOnlyPlusTI: "EEOnlyPlusTI",
	EEOnlyPlusTIGuarantee: "EEOnlyPlusTIGuarantee"
};
//#endregion
//#region src/external-api/gen/models/ReviewRequest.ts
const ReviewProcessReviewProcessState2 = {
	Requested: "Requested",
	Cancelled: "Cancelled",
	Approved: "Approved",
	Rejected: "Rejected"
};
//#endregion
//#region src/external-api/gen/models/SignOffDocument.ts
const SignOffDocumentStatus = { PendingInternalApproval: "PendingInternalApproval" };
const SignOffDocumentStatus2 = { PendingInternalSignature: "PendingInternalSignature" };
const SignOffDocumentStatus3 = { InternallySigned: "InternallySigned" };
const SignOffDocumentStatus4 = { PendingApproval: "PendingApproval" };
const SignOffDocumentStatus5 = { Approved: "Approved" };
const SignOffDocumentStatus6 = { PendingSignature: "PendingSignature" };
const SignOffDocumentStatus7 = { Completed: "Completed" };
const SignOffDocumentStatus8 = { Voided: "Voided" };
const SignOffDocumentStatus9 = { Rejected: "Rejected" };
const SignOffDocumentSignatureProvider = { docuseal: "docuseal" };
//#endregion
//#region src/external-api/gen/models/SignOffEnvelope.ts
const SignOffEnvelopeStatus = { PendingInternalApproval: "PendingInternalApproval" };
const SignOffEnvelopeStatus2 = { PendingInternalSignature: "PendingInternalSignature" };
const SignOffEnvelopeStatus3 = { Pending: "Pending" };
const SignOffEnvelopeStatus4 = { Approved: "Approved" };
const SignOffEnvelopeStatus5 = { PendingSignature: "PendingSignature" };
const SignOffEnvelopeStatus6 = { Completed: "Completed" };
const SignOffEnvelopeStatus7 = { Rejected: "Rejected" };
const SignOffEnvelopeStatus8 = { Cancelled: "Cancelled" };
const SignOffEnvelopePriority = { Normal: "Normal" };
const SignOffEnvelopePriority2 = { Urgent: "Urgent" };
const MfhEstateType = { Apartment: "Apartment" };
const MfhEstateType2 = { House: "House" };
const MfhEstateType3 = { Office: "Office" };
const MfhChannelName = { OTHER_ONLINE_PORTAL: "OTHER_ONLINE_PORTAL" };
const MfhChannelName2 = { BROKER_OPEN_MANDATE: "BROKER_OPEN_MANDATE" };
const MfhChannelName3 = { BROKER_EXCLUSIVE_ACCESS: "BROKER_EXCLUSIVE_ACCESS" };
const MfhChannelName4 = { DIRECT_OWNER_APPROACH: "DIRECT_OWNER_APPROACH" };
const MfhChannelName5 = { NETWORK_REFERRAL: "NETWORK_REFERRAL" };
const MfhChannelName6 = { M_AND_A_PROCESS: "M_AND_A_PROCESS" };
const MfhChannelName7 = { INSOLVENCY_PROCESS: "INSOLVENCY_PROCESS" };
const MfhChannelName8 = { OTHER: "OTHER" };
const MfhChannelName9 = { IMMO24: "IMMO24" };
const MfhChannelName10 = { GEOMAP: "GEOMAP" };
const MfhChannelName11 = { PRICEHUBBLE: "PRICEHUBBLE" };
const MfhSource = { PAPI: "PAPI" };
const MfhSource2 = { COCKPIT: "COCKPIT" };
const MfhSource3 = { DISCOVERER: "DISCOVERER" };
const MfhSource4 = { IMPORT: "IMPORT" };
const MfhSource5 = { EXTERNAL: "EXTERNAL" };
const ExternalLinksStatus3 = { ACTIVE: "ACTIVE" };
const ExternalLinksStatus4 = { OUTDATED: "OUTDATED" };
//#endregion
//#region src/external-api/gen/models/SignOffTemplate.ts
const SignOffTemplateTemplateType = { System: "System" };
const SignOffTemplateTemplateType2 = { Custom: "Custom" };
//#endregion
//#region src/external-api/gen/models/UpdateReviewRequestParams.ts
const ReviewRequestReviewRequestState = {
	Pending: "Pending",
	Requested: "Requested",
	Rejected: "Rejected",
	Approved: "Approved",
	Cancelled: "Cancelled"
};
//#endregion
//#region src/external-api/gen/models/companiesModels/GetCompanies.ts
const QueryType = {
	Bank: "Bank",
	Realtor: "Realtor",
	DistributionPartner: "DistributionPartner",
	Notary: "Notary",
	PurchasingEntity: "PurchasingEntity",
	General: "General",
	KitchenSupplier: "KitchenSupplier",
	MeasurementsProvider: "MeasurementsProvider",
	ContractorGeneral: "ContractorGeneral",
	ContractorCleaning: "ContractorCleaning",
	ContractorElectricity: "ContractorElectricity",
	GeneralPropertyManagement: "GeneralPropertyManagement",
	IndividualPropertyManager: "IndividualPropertyManager",
	DistrictCourt: "DistrictCourt",
	ConstructionAuthority: "ConstructionAuthority",
	WaterProvier: "WaterProvier",
	ElectricityProvider: "ElectricityProvider",
	GasProvider: "GasProvider",
	FacilityManagement: "FacilityManagement",
	ServiceProvider: "ServiceProvider",
	SellingNotary: "SellingNotary",
	MaterialSupplier: "MaterialSupplier",
	TaxOffice: "TaxOffice",
	AssetManagement: "AssetManagement",
	HrCompany: "HrCompany",
	OfficeSupplier: "OfficeSupplier",
	TravelProvider: "TravelProvider",
	RentalCarCompany: "RentalCarCompany",
	MarketingCompany: "MarketingCompany",
	HardwareProvider: "HardwareProvider",
	SoftwareCompany: "SoftwareCompany",
	Seller: "Seller",
	Buyer: "Buyer",
	AssetPartner: "AssetPartner",
	Tenant: "Tenant",
	RentingLead: "RentingLead",
	AuditingFirm: "AuditingFirm",
	Planning: "Planning",
	PlanningAndConstructions: "PlanningAndConstructions",
	Proptech: "Proptech"
};
//#endregion
//#region src/external-api/gen/models/contactsModels/GetContacts.ts
const QueryCompanyType = { Bank: "Bank" };
const QueryCompanyType2 = { Realtor: "Realtor" };
const QueryCompanyType3 = { DistributionPartner: "DistributionPartner" };
const QueryCompanyType4 = { Notary: "Notary" };
const QueryCompanyType5 = { PurchasingEntity: "PurchasingEntity" };
const QueryCompanyType6 = { General: "General" };
const QueryCompanyType7 = { KitchenSupplier: "KitchenSupplier" };
const QueryCompanyType8 = { MeasurementsProvider: "MeasurementsProvider" };
const QueryCompanyType9 = { ContractorGeneral: "ContractorGeneral" };
const QueryCompanyType10 = { ContractorCleaning: "ContractorCleaning" };
const QueryCompanyType11 = { ContractorElectricity: "ContractorElectricity" };
const QueryCompanyType12 = { GeneralPropertyManagement: "GeneralPropertyManagement" };
const QueryCompanyType13 = { IndividualPropertyManager: "IndividualPropertyManager" };
const QueryCompanyType14 = { DistrictCourt: "DistrictCourt" };
const QueryCompanyType15 = { ConstructionAuthority: "ConstructionAuthority" };
const QueryCompanyType16 = { WaterProvier: "WaterProvier" };
const QueryCompanyType17 = { ElectricityProvider: "ElectricityProvider" };
const QueryCompanyType18 = { GasProvider: "GasProvider" };
const QueryCompanyType19 = { FacilityManagement: "FacilityManagement" };
const QueryCompanyType20 = { ServiceProvider: "ServiceProvider" };
const QueryCompanyType21 = { SellingNotary: "SellingNotary" };
const QueryCompanyType22 = { MaterialSupplier: "MaterialSupplier" };
const QueryCompanyType23 = { TaxOffice: "TaxOffice" };
const QueryCompanyType24 = { AssetManagement: "AssetManagement" };
const QueryCompanyType25 = { HrCompany: "HrCompany" };
const QueryCompanyType26 = { OfficeSupplier: "OfficeSupplier" };
const QueryCompanyType27 = { TravelProvider: "TravelProvider" };
const QueryCompanyType28 = { RentalCarCompany: "RentalCarCompany" };
const QueryCompanyType29 = { MarketingCompany: "MarketingCompany" };
const QueryCompanyType30 = { HardwareProvider: "HardwareProvider" };
const QueryCompanyType31 = { SoftwareCompany: "SoftwareCompany" };
const QueryCompanyType32 = { Seller: "Seller" };
const QueryCompanyType33 = { Buyer: "Buyer" };
const QueryCompanyType34 = { AssetPartner: "AssetPartner" };
const QueryCompanyType35 = { Tenant: "Tenant" };
const QueryCompanyType36 = { RentingLead: "RentingLead" };
const QueryCompanyType37 = { AuditingFirm: "AuditingFirm" };
const QueryCompanyType38 = { Planning: "Planning" };
const QueryCompanyType39 = { PlanningAndConstructions: "PlanningAndConstructions" };
const QueryCompanyType40 = { Proptech: "Proptech" };
const QueryContactType = { User: "User" };
const QueryContactType2 = { PurchasingEntityDirector: "PurchasingEntityDirector" };
const QueryContactType3 = { Seller: "Seller" };
const QueryContactType4 = { Buyer: "Buyer" };
const QueryContactType5 = { RealEstateAgent: "RealEstateAgent" };
const QueryContactType6 = { Banker: "Banker" };
const QueryContactType7 = { Notary: "Notary" };
const QueryContactType8 = { GeneralContractor: "GeneralContractor" };
const QueryContactType9 = { KitchenSupplier: "KitchenSupplier" };
const QueryContactType10 = { MeasurementProvider: "MeasurementProvider" };
const QueryContactType11 = { WEGVerwaltung: "WEGVerwaltung" };
const QueryContactType12 = { IndividualPropertyManagement: "IndividualPropertyManagement" };
const QueryContactType13 = { Tenant: "Tenant" };
const QueryContactType14 = { RentingLead: "RentingLead" };
const QueryContactType15 = { Generic: "Generic" };
const QueryContactType16 = { Neighbor: "Neighbor" };
const QueryContactType17 = { Craftsman: "Craftsman" };
const QueryContactType18 = { SellingNotary: "SellingNotary" };
const QueryContactType19 = { SalesRepresentative: "SalesRepresentative" };
const QueryContactType20 = { BankAccountOwner: "BankAccountOwner" };
const QueryContactType21 = { MaterialSupplier: "MaterialSupplier" };
const QueryContactType22 = { EnergyEfficiencyConsultant: "EnergyEfficiencyConsultant" };
const QueryContactType23 = { TechnicalDDExpert: "TechnicalDDExpert" };
const QueryContactType24 = { LegalDDExpert: "LegalDDExpert" };
const QueryContactType25 = { RentingPartner: "RentingPartner" };
const QueryContactType26 = { AssetPartner: "AssetPartner" };
const QueryContactType27 = { TaxDDConsultant: "TaxDDConsultant" };
const QueryContactType28 = { ExternalAuditor: "ExternalAuditor" };
const QueryCompanyFunction = { Admin: "Admin" };
const QueryCompanyFunction2 = { BusinessDevelopment: "BusinessDevelopment" };
const QueryCompanyFunction3 = { HR: "HR" };
const QueryCompanyFunction4 = { CTO: "CTO" };
const QueryCompanyFunction5 = { PM: "PM" };
const QueryCompanyFunction6 = { SoftwareEngineer: "SoftwareEngineer" };
const QueryCompanyFunction7 = { DataScientist: "DataScientist" };
const QueryCompanyFunction8 = { CDO: "CDO" };
const QueryCompanyFunction9 = { TechnicalProjectLead: "TechnicalProjectLead" };
const QueryCompanyFunction10 = { ProjectLeadConstruction: "ProjectLeadConstruction" };
const QueryCompanyFunction11 = { TLRenovation: "TLRenovation" };
const QueryCompanyFunction12 = { PLRenovation: "PLRenovation" };
const QueryCompanyFunction13 = { RenovationPlanner: "RenovationPlanner" };
const QueryCompanyFunction14 = { Architect: "Architect" };
const QueryCompanyFunction15 = { CFO: "CFO" };
const QueryCompanyFunction16 = { FinanceManager: "FinanceManager" };
const QueryCompanyFunction17 = { Accountant: "Accountant" };
const QueryCompanyFunction18 = { COO: "COO" };
const QueryCompanyFunction19 = { HOTGermany: "HOTGermany" };
const QueryCompanyFunction20 = { HOTCity: "HOTCity" };
const QueryCompanyFunction21 = { TransactionManager: "TransactionManager" };
const QueryCompanyFunction22 = { TransactionBackoffice: "TransactionBackoffice" };
const QueryCompanyFunction23 = { RentingManager: "RentingManager" };
const QueryCompanyFunction24 = { PropertyManager: "PropertyManager" };
const QueryCompanyFunction25 = { InvestmentManager: "InvestmentManager" };
const QueryCompanyFunction26 = { InvestmentBackoffice: "InvestmentBackoffice" };
const QueryCompanyFunction27 = { AssetManager: "AssetManager" };
const QueryCompanyFunction28 = { AssetManagementBackoffice: "AssetManagementBackoffice" };
const QueryCompanyFunction29 = { ManagingDirector: "ManagingDirector" };
const QueryCompanyFunction30 = { EnergyEfficiencyConsultant: "EnergyEfficiencyConsultant" };
const QueryRelationName = { Seller: "Seller" };
const QueryRelationName2 = { Realtor: "Realtor" };
const QueryRelationName3 = { Notary: "Notary" };
const QueryRelationName4 = { Bank: "Bank" };
const QueryRelationName5 = { DistrictCourt: "DistrictCourt" };
const QueryRelationName6 = { ConstructionAuthority: "ConstructionAuthority" };
const QueryRelationName7 = { ExecutionNotary: "ExecutionNotary" };
const QueryRelationName8 = { DocumentingNotary: "DocumentingNotary" };
const QueryRelationName9 = { MeasurementProvider: "MeasurementProvider" };
const QueryRelationName10 = { GeneralContractor: "GeneralContractor" };
const QueryRelationName11 = { KitchenSupplier: "KitchenSupplier" };
const QueryRelationName12 = { DistributionPartner: "DistributionPartner" };
const QueryRelationName13 = { SellingNotary: "SellingNotary" };
const QueryRelationName14 = { Buyer: "Buyer" };
const QueryRelationName15 = { SellingExecutionNotary: "SellingExecutionNotary" };
const QueryRelationName16 = { SellingDocumentingNotary: "SellingDocumentingNotary" };
const QueryRelationName17 = { ServiceProvider: "ServiceProvider" };
const QueryRelationName18 = { FacilityManagement: "FacilityManagement" };
const QueryRelationName19 = { GasProvider: "GasProvider" };
const QueryRelationName20 = { ElectricityProvider: "ElectricityProvider" };
const QueryRelationName21 = { WaterProvider: "WaterProvider" };
const QueryRelationName22 = { GeneralPropertyManagement: "GeneralPropertyManagement" };
const QueryRelationName23 = { Tenant: "Tenant" };
const QueryRelationName24 = { SalesRepresentative: "SalesRepresentative" };
const QueryRelationName25 = { FinancingAdvisor: "FinancingAdvisor" };
const QueryRelationName26 = { Craftsman: "Craftsman" };
const QueryRelationName27 = { Neighbor: "Neighbor" };
const QueryRelationName28 = { EnergyEfficiencyConsultant: "EnergyEfficiencyConsultant" };
const QueryRelationName29 = { TechnicalDDExpert: "TechnicalDDExpert" };
const QueryRelationName30 = { LegalDDExpert: "LegalDDExpert" };
const QueryRelationName31 = { RentingPartner: "RentingPartner" };
const QueryRelationName32 = { TaxDDConsultant: "TaxDDConsultant" };
const QueryRelationName33 = { AssetPartner: "AssetPartner" };
const QueryRelationName34 = { CandidateAssetPartner: "CandidateAssetPartner" };
const QueryRelationName35 = { TechnicalProjectLead: "TechnicalProjectLead" };
const QueryRelationName36 = { PurchasingEntity: "PurchasingEntity" };
const QueryRelationName37 = { General: "General" };
const QueryRelationName38 = { ContractorGeneral: "ContractorGeneral" };
const QueryRelationName39 = { ContractorCleaning: "ContractorCleaning" };
const QueryRelationName40 = { ContractorElectricity: "ContractorElectricity" };
const QueryRelationName41 = { IndividualPropertyManager: "IndividualPropertyManager" };
const QueryRelationName42 = { MaterialSupplier: "MaterialSupplier" };
const QueryRelationName43 = { TaxOffice: "TaxOffice" };
const QueryRelationName44 = { AssetManagement: "AssetManagement" };
const QueryRelationName45 = { HrCompany: "HrCompany" };
const QueryRelationName46 = { OfficeSupplier: "OfficeSupplier" };
const QueryRelationName47 = { TravelProvider: "TravelProvider" };
const QueryRelationName48 = { RentalCarCompany: "RentalCarCompany" };
const QueryRelationName49 = { MarketingCompany: "MarketingCompany" };
const QueryRelationName50 = { HardwareProvider: "HardwareProvider" };
const QueryRelationName51 = { SoftwareCompany: "SoftwareCompany" };
const QueryRelationName52 = { RentingLead: "RentingLead" };
const QueryRelationName53 = { AuditingFirm: "AuditingFirm" };
const QueryRelationName54 = { Planning: "Planning" };
const QueryRelationName55 = { PlanningAndConstructions: "PlanningAndConstructions" };
const QueryRelationName56 = { Proptech: "Proptech" };
//#endregion
//#region src/external-api/gen/models/durableJobModels/FindDurableJobs.ts
const FindDurableJobsQueryParamsStatus = { pending: "pending" };
const FindDurableJobsQueryParamsStatus2 = { scheduled: "scheduled" };
const FindDurableJobsQueryParamsStatus3 = { cancelled: "cancelled" };
const FindDurableJobsQueryParamsStatus4 = { success: "success" };
const FindDurableJobsQueryParamsStatus5 = { fail: "fail" };
const FindDurableJobsQueryParamsStatus6 = { action_taken: "action_taken" };
//#endregion
//#region src/external-api/gen/models/filesModels/GetSignedUrl.ts
const GetSignedUrlQueryParamsVersion = { v2: "v2" };
const GetSignedUrlQueryParamsVersion2 = { v4: "v4" };
const GetSignedUrlQueryParamsAction = { read: "read" };
const GetSignedUrlQueryParamsAction2 = { write: "write" };
const GetSignedUrlQueryParamsAction3 = { delete: "delete" };
const GetSignedUrlQueryParamsAction4 = { resumable: "resumable" };
//#endregion
//#region src/external-api/gen/models/filesModels/LinkMediaFile.ts
const LinkMediaFileMutationRequestCategory = { Listing: "Listing" };
const LinkMediaFileMutationRequestCategory2 = { Inspection: "Inspection" };
const LinkMediaFileMutationRequestCategory3 = { PreRenovation: "PreRenovation" };
const LinkMediaFileMutationRequestCategory4 = { PostRenovation: "PostRenovation" };
const LinkMediaFileMutationRequestCategory5 = { Renovation: "Renovation" };
const LinkMediaFileMutationRequestCategory6 = { Avatar: "Avatar" };
const LinkMediaFileMutationRequestCategory7 = { Other: "Other" };
const LinkMediaFileMutationRequestCategory8 = { PropertyManagement: "PropertyManagement" };
const LinkMediaFileMutationRequestCategory9 = { Livings: "Livings" };
const LinkMediaFileMutationRequestCategory10 = { TechnicalDDInspection: "TechnicalDDInspection" };
//#endregion
//#region src/external-api/gen/models/invoiceModels/GetInvoicesList.ts
const GetInvoicesListQueryParamsState = {
	New: "New",
	Assigned: "Assigned",
	WaitingForAuthorization: "WaitingForAuthorization",
	ManualReview: "ManualReview",
	Approved: "Approved",
	ReadyForPayment: "ReadyForPayment",
	FailedToExport: "FailedToExport",
	Paid: "Paid",
	PartiallyPaid: "PartiallyPaid",
	ManuallyPaid: "ManuallyPaid",
	ReadyForDrawdown: "ReadyForDrawdown",
	DrawdownCompleted: "DrawdownCompleted",
	InDispute: "InDispute",
	Rejected: "Rejected",
	Reimbursed: "Reimbursed",
	Duplicated: "Duplicated",
	ReadyForBooking: "ReadyForBooking",
	Authorized: "Authorized",
	WaitingForDrawdown: "WaitingForDrawdown",
	WaitingForExternalReview: "WaitingForExternalReview"
};
const GetInvoicesListQueryParamsCostType = {
	Notary: "Notary",
	LandTransferTaxes: "LandTransferTaxes",
	AgencyFee: "AgencyFee",
	PropertyRegistration: "PropertyRegistration",
	ReferralFee: "ReferralFee",
	OtherAncillaryCost: "OtherAncillaryCost",
	AgencyFeeSelling: "AgencyFeeSelling",
	OtherAncillaryCostSelling: "OtherAncillaryCostSelling",
	GeneralRenovationCost: "GeneralRenovationCost",
	KitchenCost: "KitchenCost",
	OtherRenovationCost: "OtherRenovationCost",
	HomeOwnersFee: "HomeOwnersFee",
	Utilities: "Utilities",
	PropertyTax: "PropertyTax",
	Internal: "Internal",
	HomeSpecialFee: "HomeSpecialFee",
	PropertyRelatedExpenses: "PropertyRelatedExpenses",
	PropertyValuation: "PropertyValuation",
	RecruitingExpenses: "RecruitingExpenses",
	OfficeExpenses: "OfficeExpenses",
	MarketingExpenses: "MarketingExpenses",
	EquipmentExpensesAndDA: "EquipmentExpensesAndDA",
	TechnologyAndAnalytics: "TechnologyAndAnalytics",
	TravelExpenses: "TravelExpenses",
	OtherAdministrativeCosts: "OtherAdministrativeCosts",
	ExternalLabourCosts: "ExternalLabourCosts",
	Training: "Training",
	TeamEvent: "TeamEvent",
	OtherLabourRelatedCosts: "OtherLabourRelatedCosts",
	OfficeRent: "OfficeRent",
	CarAndLeasingCosts: "CarAndLeasingCosts",
	LegalCosts: "LegalCosts",
	ConsultancyCosts: "ConsultancyCosts",
	AdvertisingCosts: "AdvertisingCosts",
	SplitInvoice: "SplitInvoice",
	CarRelatedCosts: "CarRelatedCosts",
	AuditAndTax: "AuditAndTax",
	Payroll: "Payroll",
	VoluntarySocialExpenses: "VoluntarySocialExpenses",
	RepairAndMaintenance: "RepairAndMaintenance",
	RepairAndMaintenanceRecoverable: "RepairAndMaintenanceRecoverable",
	RentReduction: "RentReduction",
	DepositRefund: "DepositRefund",
	UtilitiesRefund: "UtilitiesRefund",
	UtilitiesAdditionalPayment: "UtilitiesAdditionalPayment",
	RepairCosts: "RepairCosts",
	RentGuarantee: "RentGuarantee",
	Livings: "Livings",
	LivingsEquipment: "LivingsEquipment",
	LivingsCleaningCosts: "LivingsCleaningCosts",
	LivingsTelephoneCosts: "LivingsTelephoneCosts",
	LivingsUtilities: "LivingsUtilities",
	LivingsOther: "LivingsOther",
	NonRecsMaintenance: "NonRecsMaintenance",
	RenovationCostsEnergyEfficiency: "RenovationCostsEnergyEfficiency",
	RenovationCostsInteriorResidential: "RenovationCostsInteriorResidential",
	RenovationCostsInteriorCommercial: "RenovationCostsInteriorCommercial",
	RenovationCostsGeneralCapex: "RenovationCostsGeneralCapex",
	RenovationCostsExpansion: "RenovationCostsExpansion",
	RenovationCostsRoofConversionCapex: "RenovationCostsRoofConversionCapex",
	RenovationCostsRoofExtensionCapex: "RenovationCostsRoofExtensionCapex",
	RenovationCostsSeparateNewBuildingCapex: "RenovationCostsSeparateNewBuildingCapex",
	LettingFees: "LettingFees",
	OperatingPartnerFee: "OperatingPartnerFee",
	OperatingPartnerFeeAcquisition: "OperatingPartnerFeeAcquisition",
	OperatingPartnerFeeCapexTIManagement: "OperatingPartnerFeeCapexTIManagement",
	OperatingPartnerFeePropertyManagement: "OperatingPartnerFeePropertyManagement",
	OperatingPartnerFeeAssetManagement: "OperatingPartnerFeeAssetManagement",
	OperatingPartnerFeeDisposition: "OperatingPartnerFeeDisposition",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	OperationalRecs: "OperationalRecs",
	ExternalServiceProvider: "ExternalServiceProvider",
	ExternalServiceProviderReneo: "ExternalServiceProviderReneo",
	EnergyConsultancyCosts: "EnergyConsultancyCosts",
	PlanningCosts: "PlanningCosts",
	InstiLandTransferTaxes: "InstiLandTransferTaxes",
	InstiNotary: "InstiNotary",
	InstiPropertyRegistration: "InstiPropertyRegistration",
	InstiAgencyFeePurchasing: "InstiAgencyFeePurchasing",
	InstiAgencyFeeSelling: "InstiAgencyFeeSelling",
	InstiOtherCostSelling: "InstiOtherCostSelling",
	OutsourcedPropertyManagementCost: "OutsourcedPropertyManagementCost",
	OutsourcedPlanningCosts: "OutsourcedPlanningCosts",
	DueDiligenceCosts: "DueDiligenceCosts",
	GERAccountingFees: "GERAccountingFees",
	GERLegalFees: "GERLegalFees",
	GERTaxAdvisoryFees: "GERTaxAdvisoryFees",
	GEROtherStructureCosts: "GEROtherStructureCosts",
	GEROtherExtraordinaryIncome: "GEROtherExtraordinaryIncome",
	GEROtherExtraordinaryExpenses: "GEROtherExtraordinaryExpenses",
	LUXAccountingFees: "LUXAccountingFees",
	LUXLegalFees: "LUXLegalFees",
	LUXTaxAdvisoryFees: "LUXTaxAdvisoryFees",
	LUXPeaksideFees: "LUXPeaksideFees",
	LUXAuditFees: "LUXAuditFees",
	LUXOtherStructureCosts: "LUXOtherStructureCosts",
	LUXOtherExtraordinaryIncome: "LUXOtherExtraordinaryIncome",
	LUXOtherExtraordinaryExpenses: "LUXOtherExtraordinaryExpenses"
};
const GetInvoicesListQueryParamsOrder = { ASC: "ASC" };
const GetInvoicesListQueryParamsOrder2 = { DESC: "DESC" };
//#endregion
//#region src/external-api/gen/models/invoiceModels/GetInvoicesListFilterOptions.ts
const GetInvoicesListFilterOptionsQueryParamsState = {
	New: "New",
	Assigned: "Assigned",
	WaitingForAuthorization: "WaitingForAuthorization",
	ManualReview: "ManualReview",
	Approved: "Approved",
	ReadyForPayment: "ReadyForPayment",
	FailedToExport: "FailedToExport",
	Paid: "Paid",
	PartiallyPaid: "PartiallyPaid",
	ManuallyPaid: "ManuallyPaid",
	ReadyForDrawdown: "ReadyForDrawdown",
	DrawdownCompleted: "DrawdownCompleted",
	InDispute: "InDispute",
	Rejected: "Rejected",
	Reimbursed: "Reimbursed",
	Duplicated: "Duplicated",
	ReadyForBooking: "ReadyForBooking",
	Authorized: "Authorized",
	WaitingForDrawdown: "WaitingForDrawdown",
	WaitingForExternalReview: "WaitingForExternalReview"
};
const GetInvoicesListFilterOptionsQueryParamsCostType = {
	Notary: "Notary",
	LandTransferTaxes: "LandTransferTaxes",
	AgencyFee: "AgencyFee",
	PropertyRegistration: "PropertyRegistration",
	ReferralFee: "ReferralFee",
	OtherAncillaryCost: "OtherAncillaryCost",
	AgencyFeeSelling: "AgencyFeeSelling",
	OtherAncillaryCostSelling: "OtherAncillaryCostSelling",
	GeneralRenovationCost: "GeneralRenovationCost",
	KitchenCost: "KitchenCost",
	OtherRenovationCost: "OtherRenovationCost",
	HomeOwnersFee: "HomeOwnersFee",
	Utilities: "Utilities",
	PropertyTax: "PropertyTax",
	Internal: "Internal",
	HomeSpecialFee: "HomeSpecialFee",
	PropertyRelatedExpenses: "PropertyRelatedExpenses",
	PropertyValuation: "PropertyValuation",
	RecruitingExpenses: "RecruitingExpenses",
	OfficeExpenses: "OfficeExpenses",
	MarketingExpenses: "MarketingExpenses",
	EquipmentExpensesAndDA: "EquipmentExpensesAndDA",
	TechnologyAndAnalytics: "TechnologyAndAnalytics",
	TravelExpenses: "TravelExpenses",
	OtherAdministrativeCosts: "OtherAdministrativeCosts",
	ExternalLabourCosts: "ExternalLabourCosts",
	Training: "Training",
	TeamEvent: "TeamEvent",
	OtherLabourRelatedCosts: "OtherLabourRelatedCosts",
	OfficeRent: "OfficeRent",
	CarAndLeasingCosts: "CarAndLeasingCosts",
	LegalCosts: "LegalCosts",
	ConsultancyCosts: "ConsultancyCosts",
	AdvertisingCosts: "AdvertisingCosts",
	SplitInvoice: "SplitInvoice",
	CarRelatedCosts: "CarRelatedCosts",
	AuditAndTax: "AuditAndTax",
	Payroll: "Payroll",
	VoluntarySocialExpenses: "VoluntarySocialExpenses",
	RepairAndMaintenance: "RepairAndMaintenance",
	RepairAndMaintenanceRecoverable: "RepairAndMaintenanceRecoverable",
	RentReduction: "RentReduction",
	DepositRefund: "DepositRefund",
	UtilitiesRefund: "UtilitiesRefund",
	UtilitiesAdditionalPayment: "UtilitiesAdditionalPayment",
	RepairCosts: "RepairCosts",
	RentGuarantee: "RentGuarantee",
	Livings: "Livings",
	LivingsEquipment: "LivingsEquipment",
	LivingsCleaningCosts: "LivingsCleaningCosts",
	LivingsTelephoneCosts: "LivingsTelephoneCosts",
	LivingsUtilities: "LivingsUtilities",
	LivingsOther: "LivingsOther",
	NonRecsMaintenance: "NonRecsMaintenance",
	RenovationCostsEnergyEfficiency: "RenovationCostsEnergyEfficiency",
	RenovationCostsInteriorResidential: "RenovationCostsInteriorResidential",
	RenovationCostsInteriorCommercial: "RenovationCostsInteriorCommercial",
	RenovationCostsGeneralCapex: "RenovationCostsGeneralCapex",
	RenovationCostsExpansion: "RenovationCostsExpansion",
	RenovationCostsRoofConversionCapex: "RenovationCostsRoofConversionCapex",
	RenovationCostsRoofExtensionCapex: "RenovationCostsRoofExtensionCapex",
	RenovationCostsSeparateNewBuildingCapex: "RenovationCostsSeparateNewBuildingCapex",
	LettingFees: "LettingFees",
	OperatingPartnerFee: "OperatingPartnerFee",
	OperatingPartnerFeeAcquisition: "OperatingPartnerFeeAcquisition",
	OperatingPartnerFeeCapexTIManagement: "OperatingPartnerFeeCapexTIManagement",
	OperatingPartnerFeePropertyManagement: "OperatingPartnerFeePropertyManagement",
	OperatingPartnerFeeAssetManagement: "OperatingPartnerFeeAssetManagement",
	OperatingPartnerFeeDisposition: "OperatingPartnerFeeDisposition",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	OperationalRecs: "OperationalRecs",
	ExternalServiceProvider: "ExternalServiceProvider",
	ExternalServiceProviderReneo: "ExternalServiceProviderReneo",
	EnergyConsultancyCosts: "EnergyConsultancyCosts",
	PlanningCosts: "PlanningCosts",
	InstiLandTransferTaxes: "InstiLandTransferTaxes",
	InstiNotary: "InstiNotary",
	InstiPropertyRegistration: "InstiPropertyRegistration",
	InstiAgencyFeePurchasing: "InstiAgencyFeePurchasing",
	InstiAgencyFeeSelling: "InstiAgencyFeeSelling",
	InstiOtherCostSelling: "InstiOtherCostSelling",
	OutsourcedPropertyManagementCost: "OutsourcedPropertyManagementCost",
	OutsourcedPlanningCosts: "OutsourcedPlanningCosts",
	DueDiligenceCosts: "DueDiligenceCosts",
	GERAccountingFees: "GERAccountingFees",
	GERLegalFees: "GERLegalFees",
	GERTaxAdvisoryFees: "GERTaxAdvisoryFees",
	GEROtherStructureCosts: "GEROtherStructureCosts",
	GEROtherExtraordinaryIncome: "GEROtherExtraordinaryIncome",
	GEROtherExtraordinaryExpenses: "GEROtherExtraordinaryExpenses",
	LUXAccountingFees: "LUXAccountingFees",
	LUXLegalFees: "LUXLegalFees",
	LUXTaxAdvisoryFees: "LUXTaxAdvisoryFees",
	LUXPeaksideFees: "LUXPeaksideFees",
	LUXAuditFees: "LUXAuditFees",
	LUXOtherStructureCosts: "LUXOtherStructureCosts",
	LUXOtherExtraordinaryIncome: "LUXOtherExtraordinaryIncome",
	LUXOtherExtraordinaryExpenses: "LUXOtherExtraordinaryExpenses"
};
const GetInvoicesListFilterOptionsQueryParamsOrder = { ASC: "ASC" };
const GetInvoicesListFilterOptionsQueryParamsOrder2 = { DESC: "DESC" };
//#endregion
//#region src/external-api/gen/models/mfhInvestmentCaseModels/DownloadExternalMfhInvestmentCase.ts
const DownloadExternalMfhInvestmentCase200Status = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction = { update_mfh: "update_mfh" };
const DecisionAction2 = { create_mfh: "create_mfh" };
const DecisionAction3 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction4 = { create_mfh_estate: "create_mfh_estate" };
const DownloadExternalMfhInvestmentCaseQueryResponseStatus = {
	pending: "pending",
	scheduled: "scheduled",
	cancelled: "cancelled",
	success: "success",
	fail: "fail",
	action_taken: "action_taken"
};
const DecisionAction5 = { update_mfh: "update_mfh" };
const DecisionAction6 = { create_mfh: "create_mfh" };
const DecisionAction7 = { update_mfh_estate: "update_mfh_estate" };
const DecisionAction8 = { create_mfh_estate: "create_mfh_estate" };
//#endregion
//#region src/external-api/gen/models/mfhModels/GetExternalMfhPipelineConfig.ts
const GetExternalMfhPipelineConfigQueryParamsSourcingState = {
	New: "New",
	Validation: "Validation",
	NotInScope: "NotInScope",
	Duplicate: "Duplicate",
	Unpublished: "Unpublished",
	Screening: "Screening",
	Evaluation: "Evaluation",
	Placement: "Placement",
	DueDiligence: "DueDiligence",
	Closing: "Closing",
	Closed: "Closed",
	Rejected: "Rejected"
};
//#endregion
//#region src/external-api/gen/models/mfhModels/GetMfhEstateMedias.ts
const GetMfhEstateMediasQueryParamsCategories = {
	Listing: "Listing",
	Inspection: "Inspection",
	PreRenovation: "PreRenovation",
	PostRenovation: "PostRenovation",
	Renovation: "Renovation",
	Avatar: "Avatar",
	Other: "Other",
	PropertyManagement: "PropertyManagement",
	Livings: "Livings",
	TechnicalDDInspection: "TechnicalDDInspection"
};
//#endregion
//#region src/external-api/gen/models/mfhModels/GetMfhMedias.ts
const GetMfhMediasQueryParamsCategories = {
	Listing: "Listing",
	Inspection: "Inspection",
	PreRenovation: "PreRenovation",
	PostRenovation: "PostRenovation",
	Renovation: "Renovation",
	Avatar: "Avatar",
	Other: "Other",
	PropertyManagement: "PropertyManagement",
	Livings: "Livings",
	TechnicalDDInspection: "TechnicalDDInspection"
};
//#endregion
//#region src/external-api/gen/models/mfhModels/GetMfhPipelineList.ts
const GetMfhPipelineListQueryParamsOrder = { ASC: "ASC" };
const GetMfhPipelineListQueryParamsOrder2 = { DESC: "DESC" };
const GetMfhPipelineListQueryParamsSourcingState = {
	Placement: "Placement",
	DueDiligence: "DueDiligence",
	Closing: "Closing",
	Closed: "Closed",
	Rejected: "Rejected"
};
const GetMfhPipelineListQueryParamsInvestmentRiskProfile = {
	CorePlus: "CorePlus",
	ValueAdd: "ValueAdd"
};
//#endregion
//#region src/external-api/gen/models/mfhModels/GetMfhRentRoll.ts
const DataRentalContractReviewProcessState = { Requested: "Requested" };
const DataRentalContractReviewProcessState2 = { Cancelled: "Cancelled" };
const DataRentalContractReviewProcessState3 = { Approved: "Approved" };
const DataRentalContractReviewProcessState4 = { Rejected: "Rejected" };
const DataRentalContractReviewProcessState5 = { Requested: "Requested" };
const DataRentalContractReviewProcessState6 = { Cancelled: "Cancelled" };
const DataRentalContractReviewProcessState7 = { Approved: "Approved" };
const DataRentalContractReviewProcessState8 = { Rejected: "Rejected" };
//#endregion
//#region src/external-api/gen/models/mfhModels/GetMfhddQuestions.ts
const GetMfhddQuestionsQueryParamsType = {
	DDOverview: "DDOverview",
	MfhDocumentChecklist: "MfhDocumentChecklist",
	SourcingTasksDD: "SourcingTasksDD",
	ObjectExaminationDD: "ObjectExaminationDD",
	VicinityExaminationDD: "VicinityExaminationDD",
	RentDD: "RentDD",
	TechnicalDD: "TechnicalDD",
	TechnicalOnSiteDD: "TechnicalOnSiteDD",
	LegalDD: "LegalDD",
	CommercialDD: "CommercialDD",
	DealClosingDD: "DealClosingDD",
	MfhDDv2: "MfhDDv2"
};
//#endregion
//#region src/external-api/gen/models/mfhModels/UpdateMfhDocument.ts
const DataDocumentType = {
	EbicsAuthorizationLetter: "EbicsAuthorizationLetter",
	PaymentOrder: "PaymentOrder",
	LoanOfferTermSheet: "LoanOfferTermSheet",
	LoanContract: "LoanContract",
	PortfolioInvestmentPlan: "PortfolioInvestmentPlan",
	PurchasingDrawdownRequest: "PurchasingDrawdownRequest",
	InvoicesDrawdownRequest: "InvoicesDrawdownRequest",
	RenovationAcceptanceReport: "RenovationAcceptanceReport",
	ConstructionSiteReport: "ConstructionSiteReport",
	GeneratedInvoiceSubscriptionInvoice: "GeneratedInvoiceSubscriptionInvoice",
	InvoiceApprovalSlip: "InvoiceApprovalSlip",
	InvoiceInXML: "InvoiceInXML",
	InvoiceInPDF: "InvoiceInPDF",
	InvoiceOutPDF: "InvoiceOutPDF",
	Invoice: "Invoice",
	SubscriptionContract: "SubscriptionContract",
	ProtocolArchived: "ProtocolArchived",
	Protocol2024: "Protocol2024",
	Protocol2025: "Protocol2025",
	Protocol2026: "Protocol2026",
	ArchiveOfResolutions: "ArchiveOfResolutions",
	InvitationETV: "InvitationETV",
	AnnualStatement: "AnnualStatement",
	EconomicPlan: "EconomicPlan",
	HomeOwnerFeeStatement: "HomeOwnerFeeStatement",
	BuildingInsurance: "BuildingInsurance",
	EnergyCertificate: "EnergyCertificate",
	PropertyTaxNotice: "PropertyTaxNotice",
	ConstructionBurdenStatement: "ConstructionBurdenStatement",
	AbstractOfTitle: "AbstractOfTitle",
	DeclarationOfCondominium: "DeclarationOfCondominium",
	AmendmentToDeclarationOfDivision: "AmendmentToDeclarationOfDivision",
	AllowanceOfEntrySectionII: "AllowanceOfEntrySectionII",
	SeparationDeclaration: "SeparationDeclaration",
	PartitionPlan: "PartitionPlan",
	Floorplans: "Floorplans",
	ViewsAndSections: "ViewsAndSections",
	LivingSpaceCalculation: "LivingSpaceCalculation",
	ConstructionDescriptionBuilding: "ConstructionDescriptionBuilding",
	HouseRules: "HouseRules",
	LandRegisterMap: "LandRegisterMap",
	ManagementAgreement: "ManagementAgreement",
	SpecialAssessments: "SpecialAssessments",
	Other: "Other",
	EstateMedia: "EstateMedia",
	BuildingPermit: "BuildingPermit",
	Expose: "Expose",
	ExposeExternal: "ExposeExternal",
	ContractDraft: "ContractDraft",
	ContractNotarized: "ContractNotarized",
	LandCharge: "LandCharge",
	PaymentNotice: "PaymentNotice",
	RegistrationNotice: "RegistrationNotice",
	NotaryCorrespondence: "NotaryCorrespondence",
	AdministrationCorrespondence: "AdministrationCorrespondence",
	NotaryRegistrationReservation: "NotaryRegistrationReservation",
	SEPAMandateHomeOwnersFee: "SEPAMandateHomeOwnersFee",
	PurchasingHandoverProtocol: "PurchasingHandoverProtocol",
	ProofOfPayment: "ProofOfPayment",
	SellingExpose: "SellingExpose",
	PromotionExpose: "PromotionExpose",
	CustomizedSellingExpose: "CustomizedSellingExpose",
	SellingExposeSlip: "SellingExposeSlip",
	SellingCalculations: "SellingCalculations",
	SellingCalculationsSlip: "SellingCalculationsSlip",
	SellingContractDraft: "SellingContractDraft",
	SellingContractSummary: "SellingContractSummary",
	SellingContractNotarized: "SellingContractNotarized",
	SellingPaymentNotice: "SellingPaymentNotice",
	SellingRenovationAcceptanceProtocol: "SellingRenovationAcceptanceProtocol",
	SellingRegistrationNotice: "SellingRegistrationNotice",
	SellingNotaryCorrespondence: "SellingNotaryCorrespondence",
	SellingAdministrationCorrespondence: "SellingAdministrationCorrespondence",
	SellingDataSheet: "SellingDataSheet",
	SellingNotaryRegistrationReservation: "SellingNotaryRegistrationReservation",
	SellingHandoverProtocol: "SellingHandoverProtocol",
	SellingExpertReportWithCapEx: "SellingExpertReportWithCapEx",
	SellingExpertReport: "SellingExpertReport",
	SellingResidualValueCertificate: "SellingResidualValueCertificate",
	BuildingModernizationMeasures: "BuildingModernizationMeasures",
	SellingExposeLocation: "SellingExposeLocation",
	SellingAbstractOfTitle: "SellingAbstractOfTitle",
	NotaryCertification: "NotaryCertification",
	SellingProofOfPayment: "SellingProofOfPayment",
	LandRegisterParkingSpace: "LandRegisterParkingSpace",
	BuildingAcceptancePowerOfAttorney: "BuildingAcceptancePowerOfAttorney",
	LocationProfile: "LocationProfile",
	BuildingInformationModel: "BuildingInformationModel",
	FloorPlanSketch: "FloorPlanSketch",
	DimensionedFloorPlan: "DimensionedFloorPlan",
	DimensionedFloorPlanPlanned: "DimensionedFloorPlanPlanned",
	CadFile: "CadFile",
	CadFilePlanned: "CadFilePlanned",
	LV: "LV",
	LongLV: "LongLV",
	Kitchen: "Kitchen",
	KitchenContracted: "KitchenContracted",
	Inspection: "Inspection",
	ConstructionContract: "ConstructionContract",
	ContractorOffer: "ContractorOffer",
	RevisionDocumentation: "RevisionDocumentation",
	ReportsCalculationsAppraisals: "ReportsCalculationsAppraisals",
	ConstructionGuarantee: "ConstructionGuarantee",
	BathPlan: "BathPlan",
	StructuredLvSheet: "StructuredLvSheet",
	RenovationCostTrackingSheet: "RenovationCostTrackingSheet",
	MfhConstructionPlan: "MfhConstructionPlan",
	ConstructionDescriptionRenovation: "ConstructionDescriptionRenovation",
	PostRenovationDimensionedFloorPlan: "PostRenovationDimensionedFloorPlan",
	SalesPartnerFloorPlan: "SalesPartnerFloorPlan",
	LivingSpaceCalculations: "LivingSpaceCalculations",
	BeforeAfterPictures: "BeforeAfterPictures",
	PostRenovationAcceptanceProtocol: "PostRenovationAcceptanceProtocol",
	RoomVolumeCalculation: "RoomVolumeCalculation",
	RentContract: "RentContract",
	RentIncrease: "RentIncrease",
	AcceptanceProtocol: "AcceptanceProtocol",
	HeatingBill: "HeatingBill",
	Correspondence: "Correspondence",
	SelfAssessmentSheet: "SelfAssessmentSheet",
	ID: "ID",
	SalaryInformation: "SalaryInformation",
	SchufaReport: "SchufaReport",
	Deposit: "Deposit",
	HousingProviderConfirmation: "HousingProviderConfirmation",
	SEVContract: "SEVContract",
	SEVContractWithFee: "SEVContractWithFee",
	SEVContractWithoutFee: "SEVContractWithoutFee",
	SEVPoA: "SEVPoA",
	DkbInvestorVerification: "DkbInvestorVerification",
	SEVCoverLetter: "SEVCoverLetter",
	GDPRTenant: "GDPRTenant",
	GDPROwner: "GDPROwner",
	PersonalIDOwner: "PersonalIDOwner",
	SEPAManadateHouseGeld: "SEPAManadateHouseGeld",
	SEPATenant: "SEPATenant",
	WithdrawlInstructionTenant: "WithdrawlInstructionTenant",
	WithdrawlInstructionOwner: "WithdrawlInstructionOwner",
	TenantCorrespondence: "TenantCorrespondence",
	OwnerCorrespondence: "OwnerCorrespondence",
	UtilitiesCorrespondence: "UtilitiesCorrespondence",
	CancellationLease: "CancellationLease",
	CancellationLeaseConfirmation: "CancellationLeaseConfirmation",
	CancellationSEVContract: "CancellationSEVContract",
	CancellationSEVContractConfirmation: "CancellationSEVContractConfirmation",
	CondoTerminationAgreement: "CondoTerminationAgreement",
	LegalDisputes: "LegalDisputes",
	EstateInvestorShare: "EstateInvestorShare",
	EstateAggregatedInvestorShare: "EstateAggregatedInvestorShare",
	WEGAnnualStatement: "WEGAnnualStatement",
	InvoicesPropertyManagement: "InvoicesPropertyManagement",
	EstateRentReport: "EstateRentReport",
	CorrespondencePropertyManagement: "CorrespondencePropertyManagement",
	SalutationWEG: "SalutationWEG",
	InvestorPayout: "InvestorPayout",
	InvestorYearlyPayout: "InvestorYearlyPayout",
	InvestorYearlyPayoutLegacy: "InvestorYearlyPayoutLegacy",
	RentArrearNotice: "RentArrearNotice",
	RentGuarantee: "RentGuarantee",
	DunningNotice: "DunningNotice",
	EnforcementNotice: "EnforcementNotice",
	BKAStatement: "BKAStatement",
	BKAHeatingStatement: "BKAHeatingStatement",
	BKAAllocationCalculation: "BKAAllocationCalculation",
	BKAHouseholdCosts: "BKAHouseholdCosts",
	BKADeposit: "BKADeposit",
	SelfDeclarationTenant: "SelfDeclarationTenant",
	QuestionnaireTenant: "QuestionnaireTenant",
	RentalContractDraft: "RentalContractDraft",
	SalaryRecordPropesctiveTenant: "SalaryRecordPropesctiveTenant",
	SchufaProspectiveTenant: "SchufaProspectiveTenant",
	AnnualServiceChargeCalculation: "AnnualServiceChargeCalculation",
	PersonalIDProspectiveTenant: "PersonalIDProspectiveTenant",
	Safe: "Safe",
	Estate: "Estate",
	BasementRoom: "BasementRoom",
	AtticRoom: "AtticRoom",
	CommonRoom: "CommonRoom",
	Parking: "Parking",
	FurniturePlanPdf: "FurniturePlanPdf",
	FurniturePlanDwg: "FurniturePlanDwg",
	RequestedOrderLists: "RequestedOrderLists",
	ContractedOrderLists: "ContractedOrderLists",
	PartnerBrochure: "PartnerBrochure",
	InvoicesFittings: "InvoicesFittings",
	InvoicesServiceProvider: "InvoicesServiceProvider",
	Internet: "Internet",
	LivingsAcceptanceProtocol: "LivingsAcceptanceProtocol",
	PortfolioInspectionSheet: "PortfolioInspectionSheet",
	CreditLineCashflowPredictions: "CreditLineCashflowPredictions",
	CreditLineBudgetCosts: "CreditLineBudgetCosts",
	EstateInvestorCashflow: "EstateInvestorCashflow",
	SalesPackageFinalSheet: "SalesPackageFinalSheet",
	SalesPackageDataSheet: "SalesPackageDataSheet",
	SalesPackageNotarySheet: "SalesPackageNotarySheet",
	SalesPackageChecklist: "SalesPackageChecklist",
	SalesPackageSellingCompanies: "SalesPackageSellingCompanies",
	PurchasingDocumentsSheet: "PurchasingDocumentsSheet",
	SellingDocumentsSheet: "SellingDocumentsSheet",
	SellingDataChecklist: "SellingDataChecklist",
	SellingEstatesDataSheet: "SellingEstatesDataSheet",
	CashflowStatementSheet: "CashflowStatementSheet",
	InvestorPaymentSlip: "InvestorPaymentSlip",
	InvestorPayoutStatement: "InvestorPayoutStatement",
	DefectReport: "DefectReport",
	SalesPackageUserUploadedPriceList: "SalesPackageUserUploadedPriceList",
	SalesPackageUserUploadedDataSheet: "SalesPackageUserUploadedDataSheet",
	SalesPackageUserUploadedChecklist: "SalesPackageUserUploadedChecklist",
	SalesPackageUserUploadedPhotoAlbum: "SalesPackageUserUploadedPhotoAlbum",
	SellingRegionBrochure: "SellingRegionBrochure",
	TransferRecurrentPaymentsSEPAXmlList: "TransferRecurrentPaymentsSEPAXmlList",
	CondoSellingPresentation: "CondoSellingPresentation",
	SalesPartnerFlyer: "SalesPartnerFlyer",
	PropertyManagementOwnerBrochure: "PropertyManagementOwnerBrochure",
	ModelPurchaseContract: "ModelPurchaseContract",
	ModelRentalContract: "ModelRentalContract",
	ModelPropertyManagementContractWithFee: "ModelPropertyManagementContractWithFee",
	ModelPropertyManagementLawOfAttorney: "ModelPropertyManagementLawOfAttorney",
	ModelPropertyManagementGDPR: "ModelPropertyManagementGDPR",
	CurrentLandRegisterExtract: "CurrentLandRegisterExtract",
	EncumbranceBasisInDeptII: "EncumbranceBasisInDeptII",
	CurrentParcelMap: "CurrentParcelMap",
	CurrentPlanningRights: "CurrentPlanningRights",
	InformationUrbanRenewalArea: "InformationUrbanRenewalArea",
	InformationUrbanConservationArea: "InformationUrbanConservationArea",
	InformationMonumentProtection: "InformationMonumentProtection",
	SocialPreservationOrdinance: "SocialPreservationOrdinance",
	InformationBuildingChargeRegister: "InformationBuildingChargeRegister",
	ExtractContaminatedSitesRegister: "ExtractContaminatedSitesRegister",
	ExtractDevelopmentAndExpansionContributions: "ExtractDevelopmentAndExpansionContributions",
	UrbanDevelopmentContracts: "UrbanDevelopmentContracts",
	SoilReportOrContaminatedSites: "SoilReportOrContaminatedSites",
	GroundLease: "GroundLease",
	VerificationOfExplosiveOrdnance: "VerificationOfExplosiveOrdnance",
	OngoingLegalDisputesRegardingProperty: "OngoingLegalDisputesRegardingProperty",
	BuildingEnergyCertificate: "BuildingEnergyCertificate",
	SectionDrawingsBuildingElevations: "SectionDrawingsBuildingElevations",
	FloorPlansIncludingAreaCalculation: "FloorPlansIncludingAreaCalculation",
	BuildingApplicationOrBuildingPermit: "BuildingApplicationOrBuildingPermit",
	WarrantyGuarantees: "WarrantyGuarantees",
	OverviewOfPastOngoingAndPlannedModernization: "OverviewOfPastOngoingAndPlannedModernization",
	InsuranceClaimsLast5Years: "InsuranceClaimsLast5Years",
	ModernizationsOfIndividualApartments: "ModernizationsOfIndividualApartments",
	DeclarationOfDivisionIfDivided: "DeclarationOfDivisionIfDivided",
	OngoingLegalDisputesRegardingObject: "OngoingLegalDisputesRegardingObject",
	TenantList: "TenantList",
	RentIncreaseLetters: "RentIncreaseLetters",
	RentalAgreements: "RentalAgreements",
	ListOfExistingRentalDeposits: "ListOfExistingRentalDeposits",
	OperatingCostStatement: "OperatingCostStatement",
	TenantHandoverProtocols: "TenantHandoverProtocols",
	ListOfCurrentDefectComplaintsReductionsArrears: "ListOfCurrentDefectComplaintsReductionsArrears",
	OngoingLegalDisputesWithTenants: "OngoingLegalDisputesWithTenants",
	ManagementContracts: "ManagementContracts",
	MaintenanceProtocols: "MaintenanceProtocols",
	ListOfAgeOfInstallations: "ListOfAgeOfInstallations",
	InsurancesMainlyCurrentBuildingInsurance: "InsurancesMainlyCurrentBuildingInsurance",
	PropertyTaxAssessmentAndUnitValueNotice: "PropertyTaxAssessmentAndUnitValueNotice",
	ListOfCraftsmen: "ListOfCraftsmen",
	PurchaseContractDraft: "PurchaseContractDraft",
	AttachmentsToPurchaseContract: "AttachmentsToPurchaseContract",
	PowersOfAttorney: "PowersOfAttorney",
	MfhExpose: "MfhExpose",
	SuperStructures: "SuperStructures",
	LandValueMap: "LandValueMap",
	CommercialOwnerRegisterExtract: "CommercialOwnerRegisterExtract",
	NeighbourhoodAgreements: "NeighbourhoodAgreements",
	LandUsePlan: "LandUsePlan",
	OtherPermits: "OtherPermits",
	OfficialCertificates: "OfficialCertificates",
	BuildingInventoryPlans: "BuildingInventoryPlans",
	BuildingSections: "BuildingSections",
	BuildingStatics: "BuildingStatics",
	BuildingHeating: "BuildingHeating",
	BuildingVentilation: "BuildingVentilation",
	BuildingAirConditioning: "BuildingAirConditioning",
	BuildingSanitary: "BuildingSanitary",
	BuildingElectrical: "BuildingElectrical",
	FireProtection: "FireProtection",
	SpecialistPlannerContracts: "SpecialistPlannerContracts",
	SpecialRealEstateAdditionalInformation: "SpecialRealEstateAdditionalInformation",
	BuildingAdditonalInformation: "BuildingAdditonalInformation",
	Terminations: "Terminations",
	TaxAssessmentNotices: "TaxAssessmentNotices",
	TaxOtherMunicipalCharges: "TaxOtherMunicipalCharges",
	TaxCorrectionBalancesAndPeriods: "TaxCorrectionBalancesAndPeriods",
	TaxValueAddTenants: "TaxValueAddTenants",
	TaxValueAddSellers: "TaxValueAddSellers",
	TaxOptionRatesAndAreaKeys: "TaxOptionRatesAndAreaKeys",
	CompanyOverview: "CompanyOverview",
	CommercialRegisterExtract: "CommercialRegisterExtract",
	TransferOfShares: "TransferOfShares",
	RegisterExcerpts: "RegisterExcerpts",
	ShareRegister: "ShareRegister",
	ListOfShareholders: "ListOfShareholders",
	ArticlesOfAssociation: "ArticlesOfAssociation",
	ArticlesOfAssociationResolutionAmmendments: "ArticlesOfAssociationResolutionAmmendments",
	ArticlesOfAssociationResolutions: "ArticlesOfAssociationResolutions",
	DistributionOfProfitsResolutions: "DistributionOfProfitsResolutions",
	CapitalEndowmentResolutions: "CapitalEndowmentResolutions",
	OtherResolutions: "OtherResolutions",
	ManagingDirectorResolutions: "ManagingDirectorResolutions",
	Minutes: "Minutes",
	AgreementsWithManagement: "AgreementsWithManagement",
	CompanyAccountant: "CompanyAccountant",
	CompanyAuditor: "CompanyAuditor",
	CompanyTaxConsultant: "CompanyTaxConsultant",
	CompanyOtherContracts: "CompanyOtherContracts",
	LoanAgreement: "LoanAgreement",
	LandChargeDeed: "LandChargeDeed",
	DeclarationOfSecurityPurpose: "DeclarationOfSecurityPurpose",
	DeclarationOfAssignment: "DeclarationOfAssignment",
	Pledges: "Pledges",
	PurchasingTerminationDocuments: "PurchasingTerminationDocuments",
	FinancialAnnualStatements: "FinancialAnnualStatements",
	FinancialTaxes: "FinancialTaxes",
	FinancialManagementReporting: "FinancialManagementReporting",
	FinancialLiabilities: "FinancialLiabilities",
	FinancialCurrentBalances: "FinancialCurrentBalances",
	FinancialOtherInformation: "FinancialOtherInformation",
	FoundationReport: "FoundationReport",
	ImportantCorrespondence: "ImportantCorrespondence",
	AdditionalCostsInvoice: "AdditionalCostsInvoice",
	MFHSummary: "MFHSummary",
	MFHInvestmentCaseExportableSheet: "MFHInvestmentCaseExportableSheet",
	AssetPipelineSheet: "AssetPipelineSheet",
	ExternalInvoiceExport: "ExternalInvoiceExport",
	AssetTenderingProcess: "AssetTenderingProcess",
	DueDiligenceOnSiteInspection: "DueDiligenceOnSiteInspection",
	TechnicalDD: "TechnicalDD",
	LegalDD: "LegalDD",
	CommercialDD: "CommercialDD",
	EnergyConsultation: "EnergyConsultation",
	Vicinity: "Vicinity",
	PurchasingOffer: "PurchasingOffer",
	CourtageAgreement: "CourtageAgreement",
	ExclusivityAgreement: "ExclusivityAgreement",
	BillingOrInvoices: "BillingOrInvoices",
	InvestmentProposal: "InvestmentProposal",
	KYCDraft: "KYCDraft",
	IDSeller: "IDSeller",
	AddendumContractDraft: "AddendumContractDraft",
	AddendumContract: "AddendumContract",
	Auftragsempfehlung: "Auftragsempfehlung",
	Entscheidungsvorlage: "Entscheidungsvorlage",
	Werkvertrag: "Werkvertrag",
	Planervertrag: "Planervertrag"
};
const DataDocumentCategory = {
	General: "General",
	Sourcing: "Sourcing",
	Purchasing: "Purchasing",
	Renovation: "Renovation",
	Marketing: "Marketing",
	PortfolioManagement: "PortfolioManagement",
	PropertyManagement: "PropertyManagement",
	Accounting: "Accounting",
	PostRenovation: "PostRenovation",
	Renting: "Renting",
	Selling: "Selling",
	Orientation: "Orientation",
	Livings: "Livings",
	SalesPackage: "SalesPackage",
	SellingRegion: "SellingRegion",
	Land: "Land",
	Building: "Building",
	RentalContract: "RentalContract",
	ObjectManagement: "ObjectManagement",
	PurchasingContract: "PurchasingContract",
	DueDiligence: "DueDiligence",
	MfhOther: "MfhOther",
	Taxes: "Taxes",
	GeneralCompany: "GeneralCompany",
	ShareholderAndStatutes: "ShareholderAndStatutes",
	CompanyContracts: "CompanyContracts",
	Financing: "Financing",
	KYC: "KYC"
};
//#endregion
//#region src/external-api/gen/models/mfhModels/UpdateMfhMediaCategory.ts
const UpdateMfhMediaCategoryMutationRequestCategory = { Listing: "Listing" };
const UpdateMfhMediaCategoryMutationRequestCategory2 = { Inspection: "Inspection" };
const UpdateMfhMediaCategoryMutationRequestCategory3 = { PreRenovation: "PreRenovation" };
const UpdateMfhMediaCategoryMutationRequestCategory4 = { PostRenovation: "PostRenovation" };
const UpdateMfhMediaCategoryMutationRequestCategory5 = { Renovation: "Renovation" };
const UpdateMfhMediaCategoryMutationRequestCategory6 = { Avatar: "Avatar" };
const UpdateMfhMediaCategoryMutationRequestCategory7 = { Other: "Other" };
const UpdateMfhMediaCategoryMutationRequestCategory8 = { PropertyManagement: "PropertyManagement" };
const UpdateMfhMediaCategoryMutationRequestCategory9 = { Livings: "Livings" };
const UpdateMfhMediaCategoryMutationRequestCategory10 = { TechnicalDDInspection: "TechnicalDDInspection" };
//#endregion
//#region src/external-api/gen/models/notesModels/CreateNote.ts
const NoteConstructionCraft = {
	Demolition: "Demolition",
	HSE: "HSE",
	Bricklayer: "Bricklayer",
	Drywall: "Drywall",
	Painting: "Painting",
	Tiling: "Tiling",
	Flooring: "Flooring",
	Carpenter: "Carpenter",
	Kitchen: "Kitchen",
	Finishing: "Finishing",
	Electrical: "Electrical",
	Other: "Other"
};
const NoteType = {
	"estate-details": "estate-details",
	"estate-defects": "estate-defects",
	"estate-investment-cases": "estate-investment-cases",
	"estate-selling-notary": "estate-selling-notary",
	"mfh-details": "mfh-details",
	"mfh-renovation-projects": "mfh-renovation-projects",
	"mfh-dd-overview": "mfh-dd-overview",
	"mfh-building": "mfh-building",
	"rent-tenancy": "rent-tenancy",
	"investor-info": "investor-info",
	"owner-management": "owner-management",
	"tenant-management": "tenant-management",
	"estate-management": "estate-management",
	"annual-service-charge-statement": "annual-service-charge-statement",
	"monthly-investor-share": "monthly-investor-share",
	"addendum-internal": "addendum-internal",
	"addendum-external": "addendum-external",
	"mfh-construction-plan": "mfh-construction-plan",
	"mfh-construction-plan-version": "mfh-construction-plan-version",
	"mfh-construction-plan-version-internal": "mfh-construction-plan-version-internal",
	"contract-internal": "contract-internal",
	"contract-external": "contract-external"
};
const CreateNoteMutationRequestType = {
	"estate-details": "estate-details",
	"estate-defects": "estate-defects",
	"estate-investment-cases": "estate-investment-cases",
	"estate-selling-notary": "estate-selling-notary",
	"mfh-details": "mfh-details",
	"mfh-renovation-projects": "mfh-renovation-projects",
	"mfh-dd-overview": "mfh-dd-overview",
	"mfh-building": "mfh-building",
	"rent-tenancy": "rent-tenancy",
	"investor-info": "investor-info",
	"owner-management": "owner-management",
	"tenant-management": "tenant-management",
	"estate-management": "estate-management",
	"annual-service-charge-statement": "annual-service-charge-statement",
	"monthly-investor-share": "monthly-investor-share",
	"addendum-internal": "addendum-internal",
	"addendum-external": "addendum-external",
	"mfh-construction-plan": "mfh-construction-plan",
	"mfh-construction-plan-version": "mfh-construction-plan-version",
	"mfh-construction-plan-version-internal": "mfh-construction-plan-version-internal",
	"contract-internal": "contract-internal",
	"contract-external": "contract-external"
};
const NoteConstructionCraft2 = {
	Demolition: "Demolition",
	HSE: "HSE",
	Bricklayer: "Bricklayer",
	Drywall: "Drywall",
	Painting: "Painting",
	Tiling: "Tiling",
	Flooring: "Flooring",
	Carpenter: "Carpenter",
	Kitchen: "Kitchen",
	Finishing: "Finishing",
	Electrical: "Electrical",
	Other: "Other"
};
const NoteType2 = {
	"estate-details": "estate-details",
	"estate-defects": "estate-defects",
	"estate-investment-cases": "estate-investment-cases",
	"estate-selling-notary": "estate-selling-notary",
	"mfh-details": "mfh-details",
	"mfh-renovation-projects": "mfh-renovation-projects",
	"mfh-dd-overview": "mfh-dd-overview",
	"mfh-building": "mfh-building",
	"rent-tenancy": "rent-tenancy",
	"investor-info": "investor-info",
	"owner-management": "owner-management",
	"tenant-management": "tenant-management",
	"estate-management": "estate-management",
	"annual-service-charge-statement": "annual-service-charge-statement",
	"monthly-investor-share": "monthly-investor-share",
	"addendum-internal": "addendum-internal",
	"addendum-external": "addendum-external",
	"mfh-construction-plan": "mfh-construction-plan",
	"mfh-construction-plan-version": "mfh-construction-plan-version",
	"mfh-construction-plan-version-internal": "mfh-construction-plan-version-internal",
	"contract-internal": "contract-internal",
	"contract-external": "contract-external"
};
//#endregion
//#region src/external-api/gen/models/notesModels/GetNotes.ts
const NotesConstructionCraft = {
	Demolition: "Demolition",
	HSE: "HSE",
	Bricklayer: "Bricklayer",
	Drywall: "Drywall",
	Painting: "Painting",
	Tiling: "Tiling",
	Flooring: "Flooring",
	Carpenter: "Carpenter",
	Kitchen: "Kitchen",
	Finishing: "Finishing",
	Electrical: "Electrical",
	Other: "Other"
};
const NotesType = {
	"estate-details": "estate-details",
	"estate-defects": "estate-defects",
	"estate-investment-cases": "estate-investment-cases",
	"estate-selling-notary": "estate-selling-notary",
	"mfh-details": "mfh-details",
	"mfh-renovation-projects": "mfh-renovation-projects",
	"mfh-dd-overview": "mfh-dd-overview",
	"mfh-building": "mfh-building",
	"rent-tenancy": "rent-tenancy",
	"investor-info": "investor-info",
	"owner-management": "owner-management",
	"tenant-management": "tenant-management",
	"estate-management": "estate-management",
	"annual-service-charge-statement": "annual-service-charge-statement",
	"monthly-investor-share": "monthly-investor-share",
	"addendum-internal": "addendum-internal",
	"addendum-external": "addendum-external",
	"mfh-construction-plan": "mfh-construction-plan",
	"mfh-construction-plan-version": "mfh-construction-plan-version",
	"mfh-construction-plan-version-internal": "mfh-construction-plan-version-internal",
	"contract-internal": "contract-internal",
	"contract-external": "contract-external"
};
const NotesConstructionCraft2 = {
	Demolition: "Demolition",
	HSE: "HSE",
	Bricklayer: "Bricklayer",
	Drywall: "Drywall",
	Painting: "Painting",
	Tiling: "Tiling",
	Flooring: "Flooring",
	Carpenter: "Carpenter",
	Kitchen: "Kitchen",
	Finishing: "Finishing",
	Electrical: "Electrical",
	Other: "Other"
};
const NotesType2 = {
	"estate-details": "estate-details",
	"estate-defects": "estate-defects",
	"estate-investment-cases": "estate-investment-cases",
	"estate-selling-notary": "estate-selling-notary",
	"mfh-details": "mfh-details",
	"mfh-renovation-projects": "mfh-renovation-projects",
	"mfh-dd-overview": "mfh-dd-overview",
	"mfh-building": "mfh-building",
	"rent-tenancy": "rent-tenancy",
	"investor-info": "investor-info",
	"owner-management": "owner-management",
	"tenant-management": "tenant-management",
	"estate-management": "estate-management",
	"annual-service-charge-statement": "annual-service-charge-statement",
	"monthly-investor-share": "monthly-investor-share",
	"addendum-internal": "addendum-internal",
	"addendum-external": "addendum-external",
	"mfh-construction-plan": "mfh-construction-plan",
	"mfh-construction-plan-version": "mfh-construction-plan-version",
	"mfh-construction-plan-version-internal": "mfh-construction-plan-version-internal",
	"contract-internal": "contract-internal",
	"contract-external": "contract-external"
};
//#endregion
//#region src/external-api/gen/models/notesModels/UpdateNote.ts
const NoteConstructionCraft3 = {
	Demolition: "Demolition",
	HSE: "HSE",
	Bricklayer: "Bricklayer",
	Drywall: "Drywall",
	Painting: "Painting",
	Tiling: "Tiling",
	Flooring: "Flooring",
	Carpenter: "Carpenter",
	Kitchen: "Kitchen",
	Finishing: "Finishing",
	Electrical: "Electrical",
	Other: "Other"
};
const NoteType3 = {
	"estate-details": "estate-details",
	"estate-defects": "estate-defects",
	"estate-investment-cases": "estate-investment-cases",
	"estate-selling-notary": "estate-selling-notary",
	"mfh-details": "mfh-details",
	"mfh-renovation-projects": "mfh-renovation-projects",
	"mfh-dd-overview": "mfh-dd-overview",
	"mfh-building": "mfh-building",
	"rent-tenancy": "rent-tenancy",
	"investor-info": "investor-info",
	"owner-management": "owner-management",
	"tenant-management": "tenant-management",
	"estate-management": "estate-management",
	"annual-service-charge-statement": "annual-service-charge-statement",
	"monthly-investor-share": "monthly-investor-share",
	"addendum-internal": "addendum-internal",
	"addendum-external": "addendum-external",
	"mfh-construction-plan": "mfh-construction-plan",
	"mfh-construction-plan-version": "mfh-construction-plan-version",
	"mfh-construction-plan-version-internal": "mfh-construction-plan-version-internal",
	"contract-internal": "contract-internal",
	"contract-external": "contract-external"
};
const NoteConstructionCraft4 = {
	Demolition: "Demolition",
	HSE: "HSE",
	Bricklayer: "Bricklayer",
	Drywall: "Drywall",
	Painting: "Painting",
	Tiling: "Tiling",
	Flooring: "Flooring",
	Carpenter: "Carpenter",
	Kitchen: "Kitchen",
	Finishing: "Finishing",
	Electrical: "Electrical",
	Other: "Other"
};
const NoteType4 = {
	"estate-details": "estate-details",
	"estate-defects": "estate-defects",
	"estate-investment-cases": "estate-investment-cases",
	"estate-selling-notary": "estate-selling-notary",
	"mfh-details": "mfh-details",
	"mfh-renovation-projects": "mfh-renovation-projects",
	"mfh-dd-overview": "mfh-dd-overview",
	"mfh-building": "mfh-building",
	"rent-tenancy": "rent-tenancy",
	"investor-info": "investor-info",
	"owner-management": "owner-management",
	"tenant-management": "tenant-management",
	"estate-management": "estate-management",
	"annual-service-charge-statement": "annual-service-charge-statement",
	"monthly-investor-share": "monthly-investor-share",
	"addendum-internal": "addendum-internal",
	"addendum-external": "addendum-external",
	"mfh-construction-plan": "mfh-construction-plan",
	"mfh-construction-plan-version": "mfh-construction-plan-version",
	"mfh-construction-plan-version-internal": "mfh-construction-plan-version-internal",
	"contract-internal": "contract-internal",
	"contract-external": "contract-external"
};
//#endregion
//#region src/external-api/gen/models/signOffModels/GetSignOffEnvelopes.ts
const GetSignOffEnvelopesQueryParamsStatus = { PendingInternalApproval: "PendingInternalApproval" };
const GetSignOffEnvelopesQueryParamsStatus2 = { PendingInternalSignature: "PendingInternalSignature" };
const GetSignOffEnvelopesQueryParamsStatus3 = { Pending: "Pending" };
const GetSignOffEnvelopesQueryParamsStatus4 = { Approved: "Approved" };
const GetSignOffEnvelopesQueryParamsStatus5 = { PendingSignature: "PendingSignature" };
const GetSignOffEnvelopesQueryParamsStatus6 = { Completed: "Completed" };
const GetSignOffEnvelopesQueryParamsStatus7 = { Rejected: "Rejected" };
const GetSignOffEnvelopesQueryParamsStatus8 = { Cancelled: "Cancelled" };
const GetSignOffEnvelopesQueryParamsStatus9 = { PendingInternalApproval: "PendingInternalApproval" };
const GetSignOffEnvelopesQueryParamsStatus10 = { PendingInternalSignature: "PendingInternalSignature" };
const GetSignOffEnvelopesQueryParamsStatus11 = { Pending: "Pending" };
const GetSignOffEnvelopesQueryParamsStatus12 = { Approved: "Approved" };
const GetSignOffEnvelopesQueryParamsStatus13 = { PendingSignature: "PendingSignature" };
const GetSignOffEnvelopesQueryParamsStatus14 = { Completed: "Completed" };
const GetSignOffEnvelopesQueryParamsStatus15 = { Rejected: "Rejected" };
const GetSignOffEnvelopesQueryParamsStatus16 = { Cancelled: "Cancelled" };
const GetSignOffEnvelopesQueryParamsPriority = { Normal: "Normal" };
const GetSignOffEnvelopesQueryParamsPriority2 = { Urgent: "Urgent" };
const GetSignOffEnvelopesQueryParamsPriority3 = { Normal: "Normal" };
const GetSignOffEnvelopesQueryParamsPriority4 = { Urgent: "Urgent" };
const GetSignOffEnvelopesQueryParamsOrder = { ASC: "ASC" };
const GetSignOffEnvelopesQueryParamsOrder2 = { DESC: "DESC" };
//#endregion
//#region src/external-api/gen/models/signOffModels/ProcessExternalSignatureEvent.ts
const ProcessExternalSignatureEventMutationRequestEvent = { Signed: "Signed" };
const ProcessExternalSignatureEventMutationRequestEvent2 = { Rejected: "Rejected" };
//#endregion
//#region src/external-api/gen/models/signOffModels/ProcessSignOffDocumentApproval.ts
const ProcessSignOffDocumentApprovalMutationRequestEvent = { Pending: "Pending" };
const ProcessSignOffDocumentApprovalMutationRequestEvent2 = { Approved: "Approved" };
const ProcessSignOffDocumentApprovalMutationRequestEvent3 = { Rejected: "Rejected" };
//#endregion
//#region src/external-api/gen/models/signOffModels/ProcessSignOffDocumentSignature.ts
const ProcessSignOffDocumentSignatureMutationRequestEvent = { Pending: "Pending" };
const ProcessSignOffDocumentSignatureMutationRequestEvent2 = { InProgress: "InProgress" };
const ProcessSignOffDocumentSignatureMutationRequestEvent3 = { Signed: "Signed" };
const ProcessSignOffDocumentSignatureMutationRequestEvent4 = { Rejected: "Rejected" };
//#endregion
//#region src/external-api/gen/models/userConfirmationModels/SettleUserConfirmation.ts
const SettleUserConfirmationMutationRequestStatus = {
	CREATED: "CREATED",
	APPROVED: "APPROVED",
	TIMEOUT: "TIMEOUT",
	ERROR: "ERROR",
	REJECTED: "REJECTED"
};
//#endregion
//#region src/external-api/client.ts
const axiosInstance = axios.create({ paramsSerializer: { serialize: (params) => stringify(params, { arrayFormat: "repeat" }) } });
function initHTTPClient(baseURL, onRequest, onRejectedResponse) {
	axiosInstance.defaults.baseURL = baseURL;
	if (onRequest) axiosInstance.interceptors.request.use(onRequest);
	if (onRejectedResponse) axiosInstance.interceptors.response.use((response) => response, onRejectedResponse);
	return axiosInstance;
}
const axiosClient = async (config) => {
	return axiosInstance.request({ ...config }).catch((e) => {
		throw e;
	});
};
//#endregion
//#region src/external-api/gen/clients/axios.ts
var axios_exports = /* @__PURE__ */ __exportAll({
	batchScheduleDurableJob: () => batchScheduleDurableJob,
	cancelDurableJob: () => cancelDurableJob,
	changeUserPassword: () => changeUserPassword,
	createMfhOpenQuestion: () => createMfhOpenQuestion,
	createNote: () => createNote,
	createSignOffComment: () => createSignOffComment,
	deleteDocument: () => deleteDocument,
	deleteMfhDdQuestion: () => deleteMfhDdQuestion,
	deleteMfhOpenQuestion: () => deleteMfhOpenQuestion,
	deleteNote: () => deleteNote,
	deleteSignOffComment: () => deleteSignOffComment,
	downloadExternalMfhInvestmentCase: () => downloadExternalMfhInvestmentCase,
	fetchUserConfirmations: () => fetchUserConfirmations,
	findDurableJob: () => findDurableJob,
	findDurableJobs: () => findDurableJobs,
	findUnseenDurableJobs: () => findUnseenDurableJobs,
	get: () => get,
	getAssetRentRoll: () => getAssetRentRoll,
	getCompanies: () => getCompanies,
	getContacts: () => getContacts,
	getCurrentUserProfile: () => getCurrentUserProfile,
	getDataRoom: () => getDataRoom,
	getDataRooms: () => getDataRooms,
	getExternalEnvelopeByToken: () => getExternalEnvelopeByToken,
	getExternalMfhPipelineConfig: () => getExternalMfhPipelineConfig,
	getInvoiceDetails: () => getInvoiceDetails,
	getInvoiceReviewProcess: () => getInvoiceReviewProcess,
	getInvoicesList: () => getInvoicesList,
	getInvoicesListFilterOptions: () => getInvoicesListFilterOptions,
	getLookerEmbedUrl: () => getLookerEmbedUrl,
	getMentionableContacts: () => getMentionableContacts,
	getMfh: () => getMfh,
	getMfhCalendarEvents: () => getMfhCalendarEvents,
	getMfhDdv1Answers: () => getMfhDdv1Answers,
	getMfhDocuments: () => getMfhDocuments,
	getMfhEstate: () => getMfhEstate,
	getMfhEstateConstructionPlanBudget: () => getMfhEstateConstructionPlanBudget,
	getMfhEstateMedias: () => getMfhEstateMedias,
	getMfhEstateRenovationCostTracking: () => getMfhEstateRenovationCostTracking,
	getMfhEstateRenovationInspections: () => getMfhEstateRenovationInspections,
	getMfhEstateRenovationSummary: () => getMfhEstateRenovationSummary,
	getMfhInvestmentCases: () => getMfhInvestmentCases,
	getMfhList: () => getMfhList,
	getMfhMedias: () => getMfhMedias,
	getMfhOpenQuestions: () => getMfhOpenQuestions,
	getMfhPipelineList: () => getMfhPipelineList,
	getMfhPortfolio: () => getMfhPortfolio,
	getMfhRentRoll: () => getMfhRentRoll,
	getMfhSheetEmbedding: () => getMfhSheetEmbedding,
	getMfhSheetEmbeddings: () => getMfhSheetEmbeddings,
	getMfhStats: () => getMfhStats,
	getMfhSummary: () => getMfhSummary,
	getMfhddQuestions: () => getMfhddQuestions,
	getNotes: () => getNotes,
	getOneMfhInvestmentCase: () => getOneMfhInvestmentCase,
	getPipelineMfhPortfolios: () => getPipelineMfhPortfolios,
	getSignOffEnvelope: () => getSignOffEnvelope,
	getSignOffEnvelopes: () => getSignOffEnvelopes,
	getSignOffTemplates: () => getSignOffTemplates,
	getSignedReadUrl: () => getSignedReadUrl,
	getSignedUrl: () => getSignedUrl,
	invokeDurableJob: () => invokeDurableJob,
	linkMediaFile: () => linkMediaFile,
	listDurableJobs: () => listDurableJobs,
	markDurableJobsSeen: () => markDurableJobsSeen,
	moveFileToFolder: () => moveFileToFolder,
	operations: () => operations,
	processExternalSignatureEvent: () => processExternalSignatureEvent,
	processSignOffDocumentApproval: () => processSignOffDocumentApproval,
	processSignOffDocumentSignature: () => processSignOffDocumentSignature,
	reRunDurableJob: () => reRunDurableJob,
	renameMfhMediaFile: () => renameMfhMediaFile,
	resetCache: () => resetCache,
	saveDocumentsFolder: () => saveDocumentsFolder,
	scheduleDurableJob: () => scheduleDurableJob,
	settleUserConfirmation: () => settleUserConfirmation,
	updateMfhDocument: () => updateMfhDocument,
	updateMfhMediaCategory: () => updateMfhMediaCategory,
	updateMfhMediaTags: () => updateMfhMediaTags,
	updateMfhOpenQuestion: () => updateMfhOpenQuestion,
	updateMfhRentRoll: () => updateMfhRentRoll,
	updateMfhddAnswer: () => updateMfhddAnswer,
	updateNote: () => updateNote,
	updateReviewRequest: () => updateReviewRequest,
	updateSignOffComment: () => updateSignOffComment,
	updateUserProfile: () => updateUserProfile,
	upsertMfhDdQuestion: () => upsertMfhDdQuestion
});
/**
* @link /
*/
async function get(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/`,
		...options
	})).data;
}
/**
* @description Get list of mfhs
* @link /api/mfhs
*/
async function getMfhList(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs`,
		params,
		...options
	})).data;
}
/**
* @description Get list of pipeline mfhs
* @link /api/pipeline-mfhs
*/
async function getMfhPipelineList(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/pipeline-mfhs`,
		params,
		...options
	})).data;
}
/**
* @description Get pipeline MFH portfolios
* @link /api/pipeline-mfh-portfolios
*/
async function getPipelineMfhPortfolios(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/pipeline-mfh-portfolios`,
		params,
		...options
	})).data;
}
/**
* @description Get external MFH pipeline filter configuration
* @link /api/pipeline-mfhs/config
*/
async function getExternalMfhPipelineConfig(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/pipeline-mfhs/config`,
		params,
		...options
	})).data;
}
/**
* @description Get single mfh portfolio by ID
* @link /api/mfh-portfolios/:mfhPortfolioId
*/
async function getMfhPortfolio({ mfhPortfolioId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfh-portfolios/${mfhPortfolioId}`,
		...options
	})).data;
}
/**
* @description Get MFH sheet embedding
* @link /api/mfh-sheet-embedding
*/
async function getMfhSheetEmbedding(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfh-sheet-embedding`,
		params,
		...options
	})).data;
}
/**
* @description List MFH sheet embeddings for a portfolio (asset-partner shared slices only)
* @link /api/mfh-sheet-embeddings
*/
async function getMfhSheetEmbeddings(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfh-sheet-embeddings`,
		params,
		...options
	})).data;
}
/**
* @description Get mfh summary
* @link /api/mfhs/:mfhId/summary
*/
async function getMfhSummary({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/summary`,
		...options
	})).data;
}
/**
* @description Get MFH
* @link /api/mfhs/:mfhId
*/
async function getMfh({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}`,
		params,
		...options
	})).data;
}
/**
* @description Get MFH estate
* @link /api/mfhs/:mfhId/estates/:estateId
*/
async function getMfhEstate({ mfhId, estateId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/estates/${estateId}`,
		...options
	})).data;
}
/**
* @description Get MFH estate medias with optional filtering
* @link /api/mfhs/:mfhId/estates/:estateId/medias
*/
async function getMfhEstateMedias({ mfhId, estateId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/estates/${estateId}/medias`,
		params,
		...options
	})).data;
}
/**
* @description Get MFH estate renovation process summary
* @link /api/mfhs/:mfhId/estates/:estateId/renovation-summary
*/
async function getMfhEstateRenovationSummary({ mfhId, estateId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/estates/${estateId}/renovation-summary`,
		...options
	})).data;
}
/**
* @description Get MFH estate construction plan budget (for Interior/Other budget)
* @link /api/mfhs/:mfhId/estates/:estateId/construction-plan-budget
*/
async function getMfhEstateConstructionPlanBudget({ mfhId, estateId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/estates/${estateId}/construction-plan-budget`,
		...options
	})).data;
}
/**
* @description Get MFH estate renovation cost tracking
* @link /api/mfhs/:mfhId/estates/:estateId/renovation-cost-tracking
*/
async function getMfhEstateRenovationCostTracking({ mfhId, estateId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/estates/${estateId}/renovation-cost-tracking`,
		...options
	})).data;
}
/**
* @description Get MFH estate renovation inspections
* @link /api/mfhs/:mfhId/estates/:estateId/renovation-inspections
*/
async function getMfhEstateRenovationInspections({ mfhId, estateId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/estates/${estateId}/renovation-inspections`,
		...options
	})).data;
}
/**
* @description Get MFH Documents
* @link /api/mfhs/:mfhId/documents
*/
async function getMfhDocuments({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/documents`,
		...options
	})).data;
}
/**
* @description Update MFH Document
* @link /api/mfhs/:mfhId/documents/:documentId
*/
async function updateMfhDocument({ mfhId, documentId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/api/mfhs/${mfhId}/documents/${documentId}`,
		data,
		...options
	})).data;
}
/**
* @description Get MFH Medias with optional filtering
* @link /api/mfhs/:mfhId/medias
*/
async function getMfhMedias({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/medias`,
		params,
		...options
	})).data;
}
/**
* @description Update MFH Media Categories
* @link /api/mfhs/:mfhId/medias/category
*/
async function updateMfhMediaCategory({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/mfhs/${mfhId}/medias/category`,
		data,
		...options
	})).data;
}
/**
* @description Update MFH Media Tags
* @link /api/mfhs/:mfhId/medias/tags
*/
async function updateMfhMediaTags({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/mfhs/${mfhId}/medias/tags`,
		data,
		...options
	})).data;
}
/**
* @description Rename MFH Media File
* @link /api/mfhs/:mfhId/medias/rename
*/
async function renameMfhMediaFile({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/mfhs/${mfhId}/medias/rename`,
		data,
		...options
	})).data;
}
/**
* @description Get MFH DD Questions
* @link /api/mfhs/:mfhId/dd/questions
*/
async function getMfhddQuestions({ mfhId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/dd/questions`,
		params,
		...options
	})).data;
}
/**
* @description Upsert MFH DD Question
* @link /api/mfhs/:mfhId/dd/questions
*/
async function upsertMfhDdQuestion({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/mfhs/${mfhId}/dd/questions`,
		data,
		...options
	})).data;
}
/**
* @description Whether the MFH has answers on the v1 DD checklists
* @link /api/mfhs/:mfhId/dd/v1-answers
*/
async function getMfhDdv1Answers({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/dd/v1-answers`,
		...options
	})).data;
}
/**
* @description Delete MFH DD Question
* @link /api/mfhs/:mfhId/dd/questions/:questionId
*/
async function deleteMfhDdQuestion({ questionId, mfhId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/mfhs/${mfhId}/dd/questions/${questionId}`,
		...options
	})).data;
}
/**
* @description Update MFH DD Answer
* @link /api/mfhs/:mfhId/dd/answers
*/
async function updateMfhddAnswer({ mfhId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/mfhs/${mfhId}/dd/answers`,
		data,
		...options
	})).data;
}
/**
* @description Update MFH Rent Roll
* @link /api/mfhs/:mfhId/:estateId/rent-roll
*/
async function updateMfhRentRoll({ mfhId, estateId }, data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/api/mfhs/${mfhId}/${estateId}/rent-roll`,
		data,
		...options
	})).data;
}
/**
* @description Get MFH Open Questions
* @link /api/mfhs/:mfhId/open-questions
*/
async function getMfhOpenQuestions({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/open-questions`,
		...options
	})).data;
}
/**
* @description Get MFH Rent Roll
* @link /api/mfhs/:mfhId/rent-roll
*/
async function getMfhRentRoll({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/rent-roll`,
		...options
	})).data;
}
/**
* @description Create MFH Open Questions
* @link /api/mfhs/open-questions
*/
async function createMfhOpenQuestion(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/mfhs/open-questions`,
		data,
		...options
	})).data;
}
/**
* @description Update MFH Open Questions
* @link /api/mfhs/open-questions/:openQuestionId
*/
async function updateMfhOpenQuestion({ openQuestionId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/mfhs/open-questions/${openQuestionId}`,
		data,
		...options
	})).data;
}
/**
* @description Delete MFH Open Questions
* @link /api/mfhs/open-questions/:openQuestionId
*/
async function deleteMfhOpenQuestion({ openQuestionId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/mfhs/open-questions/${openQuestionId}`,
		...options
	})).data;
}
/**
* @description Get list of mfhs calendar events where current user is attendee
* @link /api/mfhs/calendar-events
*/
async function getMfhCalendarEvents(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/calendar-events`,
		params,
		...options
	})).data;
}
/**
* @description Get asset rent roll for MFH
* @link /api/mfhs/:mfhId/asset-rent-roll
*/
async function getAssetRentRoll({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/asset-rent-roll`,
		...options
	})).data;
}
/**
* @description Get MFH KPIs / stats
* @link /api/mfhs/:mfhId/stats
*/
async function getMfhStats({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfhs/${mfhId}/stats`,
		...options
	})).data;
}
/**
* @description Save an mfh document folder
* @link /api/documents-folder
*/
async function saveDocumentsFolder(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/documents-folder`,
		data,
		...options
	})).data;
}
/**
* @description Moves document files/folders
* @link /api/documents-folder/move
*/
async function moveFileToFolder(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/documents-folder/move`,
		data,
		...options
	})).data;
}
/**
* @description Get all data rooms
* @link /api/data-room
*/
async function getDataRooms(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/data-room`,
		params,
		...options
	})).data;
}
/**
* @description Get a data room
* @link /api/data-room/:dataRoomId
*/
async function getDataRoom({ dataRoomId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/data-room/${dataRoomId}`,
		...options
	})).data;
}
/**
* @description Delete a document
* @link /api/document/:documentId
*/
async function deleteDocument({ documentId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/document/${documentId}`,
		...options
	})).data;
}
/**
* @description Get Companies
* @link /api/companies
*/
async function getCompanies(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/companies`,
		params,
		...options
	})).data;
}
/**
* @description Get Contacts
* @link /api/contacts
*/
async function getContacts(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/contacts`,
		params,
		...options
	})).data;
}
/**
* @description Get list of invoices
* @link /api/invoices
*/
async function getInvoicesList(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/invoices`,
		params,
		...options
	})).data;
}
/**
* @description Get filter options for invoices list
* @link /api/invoices/filter-options
*/
async function getInvoicesListFilterOptions(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/invoices/filter-options`,
		params,
		...options
	})).data;
}
/**
* @description Get specific invoice
* @link /api/invoices/:invoiceId
*/
async function getInvoiceDetails({ invoiceId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/invoices/${invoiceId}`,
		...options
	})).data;
}
/**
* @description Get invoice review processes
* @link /api/invoices/:invoiceId/review-process
*/
async function getInvoiceReviewProcess({ invoiceId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/invoices/${invoiceId}/review-process`,
		...options
	})).data;
}
/**
* @description Update review request
* @link /api/review-request
*/
async function updateReviewRequest(data, options = {}) {
	return (await axiosClient({
		method: "patch",
		url: `/api/review-request`,
		data,
		...options
	})).data;
}
/**
* @description Reset Cache
* @link /api/maintenance/reset-cache
*/
async function resetCache(options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/maintenance/reset-cache`,
		...options
	})).data;
}
/**
* @description Save an mfh document folder
* @link /api/looker-dashboards
*/
async function getLookerEmbedUrl(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/looker-dashboards`,
		params,
		...options
	})).data;
}
/**
* @description Get list of mfh investment-cases
* @link /api/mfh/:mfhId/investment-cases
*/
async function getMfhInvestmentCases({ mfhId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfh/${mfhId}/investment-cases`,
		...options
	})).data;
}
/**
* @description Download mfh investment-case as excel
* @link /api/mfh/:mfhId/investment-cases/:mfhInvestmentCaseId/download
*/
async function downloadExternalMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfh/${mfhId}/investment-cases/${mfhInvestmentCaseId}/download`,
		...options
	})).data;
}
/**
* @description Get one mfh investment-case by id
* @link /api/mfh/:mfhId/investment-cases/:mfhInvestmentCaseId
*/
async function getOneMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/mfh/${mfhId}/investment-cases/${mfhInvestmentCaseId}`,
		...options
	})).data;
}
/**
* @description Get Notes
* @link /api/notes
*/
async function getNotes(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/notes`,
		params,
		...options
	})).data;
}
/**
* @description Create Note
* @link /api/notes
*/
async function createNote(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/notes`,
		data,
		...options
	})).data;
}
/**
* @description Update Note
* @link /api/notes/:noteId
*/
async function updateNote({ noteId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/notes/${noteId}`,
		data,
		...options
	})).data;
}
/**
* @description Delete Note
* @link /api/notes/:noteId
*/
async function deleteNote({ noteId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/notes/${noteId}`,
		...options
	})).data;
}
/**
* @description Get Mentionable Contacts
* @link /api/notes/mentionable-contacts
*/
async function getMentionableContacts(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/notes/mentionable-contacts`,
		params,
		...options
	})).data;
}
/**
* @description Get Sign-Off Templates
* @link /api/sign-off-templates
*/
async function getSignOffTemplates(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/sign-off-templates`,
		params,
		...options
	})).data;
}
/**
* @description Get Sign-Off Envelopes
* @link /api/sign-off-envelopes
*/
async function getSignOffEnvelopes(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/sign-off-envelopes`,
		params,
		...options
	})).data;
}
/**
* @description Get Sign-Off Envelope by ID
* @link /api/sign-off-envelopes/:signOffEnvelopeId
*/
async function getSignOffEnvelope({ signOffEnvelopeId }, params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/sign-off-envelopes/${signOffEnvelopeId}`,
		params,
		...options
	})).data;
}
/**
* @description Process Sign-Off Document Approval
* @link /api/sign-off-documents/:signOffDocumentId/approval
*/
async function processSignOffDocumentApproval({ signOffDocumentId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/sign-off-documents/${signOffDocumentId}/approval`,
		data,
		...options
	})).data;
}
/**
* @description Process Sign-Off Document Signature
* @link /api/sign-off-documents/:signOffDocumentId/signature
*/
async function processSignOffDocumentSignature({ signOffDocumentId }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/sign-off-documents/${signOffDocumentId}/signature`,
		data,
		...options
	})).data;
}
/**
* @description Create Sign-Off Comment
* @link /api/sign-off-comments
*/
async function createSignOffComment(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/sign-off-comments`,
		data,
		...options
	})).data;
}
/**
* @description Update Sign-Off Comment
* @link /api/sign-off-comments/:signOffCommentId
*/
async function updateSignOffComment({ signOffCommentId }, data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/sign-off-comments/${signOffCommentId}`,
		data,
		...options
	})).data;
}
/**
* @description Delete Sign-Off Comment
* @link /api/sign-off-comments/:signOffCommentId
*/
async function deleteSignOffComment({ signOffCommentId }, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/api/sign-off-comments/${signOffCommentId}`,
		...options
	})).data;
}
/**
* @description Get Sign-Off Envelope by Access Token (No Auth Required)
* @link /api/external/sign-off-envelope/:accessToken
*/
async function getExternalEnvelopeByToken({ accessToken }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/external/sign-off-envelope/${accessToken}`,
		...options
	})).data;
}
/**
* @description Process External Signature Event (No Auth Required)
* @link /api/external/sign-off-signature/:accessToken/process
*/
async function processExternalSignatureEvent({ accessToken }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/external/sign-off-signature/${accessToken}/process`,
		data,
		...options
	})).data;
}
/**
* @description Gets a signed url for reading a file from google bucket
* @link /api/signed-read-url
*/
async function getSignedReadUrl(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/signed-read-url`,
		params,
		...options
	})).data;
}
/**
* @description Gets a signed url for uploading a file to google bucket
* @link /api/signed-url
*/
async function getSignedUrl(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/signed-url`,
		params,
		...options
	})).data;
}
/**
* @description Links an uploaded file to create a media file record
* @link /api/media-files/link
*/
async function linkMediaFile(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/api/media-files/link`,
		data,
		...options
	})).data;
}
/**
* @description Get current user profile
* @link /api/user/profile
*/
async function getCurrentUserProfile(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/api/user/profile`,
		...options
	})).data;
}
/**
* @description Update user profile (username, name)
* @link /api/user/profile
*/
async function updateUserProfile(data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/user/profile`,
		data,
		...options
	})).data;
}
/**
* @description Change user password
* @link /api/user/password
*/
async function changeUserPassword(data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/api/user/password`,
		data,
		...options
	})).data;
}
/**
* @description invoke durable job by name
* @link /durable-jobs/invoke/:name
*/
async function invokeDurableJob({ name }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/durable-jobs/invoke/${name}`,
		data,
		...options
	})).data;
}
/**
* @description finds durable jobs
* @link /durable-jobs
*/
async function findDurableJobs(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/durable-jobs`,
		params,
		...options
	})).data;
}
/**
* @description schedules a durable job
* @link /durable-jobs
*/
async function scheduleDurableJob(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/durable-jobs`,
		data,
		...options
	})).data;
}
/**
* @description finds a durable job
* @link /durable-jobs/:id
*/
async function findDurableJob({ id }, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/durable-jobs/${id}`,
		...options
	})).data;
}
/**
* @description cancels a durable job
* @link /durable-jobs/:id
*/
async function cancelDurableJob({ id }, params, options = {}) {
	return (await axiosClient({
		method: "delete",
		url: `/durable-jobs/${id}`,
		params,
		...options
	})).data;
}
/**
* @description finds user unseen durable jobs
* @link /durable-jobs/unseen
*/
async function findUnseenDurableJobs(params, options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/durable-jobs/unseen`,
		params,
		...options
	})).data;
}
/**
* @description lists durable jobs
* @link /durable-jobs/list
*/
async function listDurableJobs(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/durable-jobs/list`,
		...options
	})).data;
}
/**
* @description reruns a durable job
* @link /durable-jobs/:id/rerun
*/
async function reRunDurableJob({ id }, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/durable-jobs/${id}/rerun`,
		...options
	})).data;
}
/**
* @description marks durable jobs as seen
* @link /durable-jobs/seen
*/
async function markDurableJobsSeen(data, options = {}) {
	return (await axiosClient({
		method: "put",
		url: `/durable-jobs/seen`,
		data,
		...options
	})).data;
}
/**
* @description batch schedules a durable job
* @link /durable-jobs/batch
*/
async function batchScheduleDurableJob(data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/durable-jobs/batch`,
		data,
		...options
	})).data;
}
/**
* @description Settles a user-confirmation (either approved or rejected)
* @link /user-confirmations/:id
*/
async function settleUserConfirmation({ id }, data, options = {}) {
	return (await axiosClient({
		method: "post",
		url: `/user-confirmations/${id}`,
		data,
		...options
	})).data;
}
/**
* @description Fetches user-confirmations, which are not yet approved/rejected
* @link /user-confirmations
*/
async function fetchUserConfirmations(options = {}) {
	return (await axiosClient({
		method: "get",
		url: `/user-confirmations`,
		...options
	})).data;
}
const operations = {
	get_: {
		path: "/",
		method: "get"
	},
	getMFHList: {
		path: "/api/mfhs",
		method: "get"
	},
	getMFHPipelineList: {
		path: "/api/pipeline-mfhs",
		method: "get"
	},
	getPipelineMfhPortfolios: {
		path: "/api/pipeline-mfh-portfolios",
		method: "get"
	},
	getExternalMFHPipelineConfig: {
		path: "/api/pipeline-mfhs/config",
		method: "get"
	},
	getMFHPortfolio: {
		path: "/api/mfh-portfolios/:mfhPortfolioId",
		method: "get"
	},
	getMfhSheetEmbedding: {
		path: "/api/mfh-sheet-embedding",
		method: "get"
	},
	getMfhSheetEmbeddings: {
		path: "/api/mfh-sheet-embeddings",
		method: "get"
	},
	getMFHSummary: {
		path: "/api/mfhs/:mfhId/summary",
		method: "get"
	},
	getMFH: {
		path: "/api/mfhs/:mfhId",
		method: "get"
	},
	getMFHEstate: {
		path: "/api/mfhs/:mfhId/estates/:estateId",
		method: "get"
	},
	getMFHEstateMedias: {
		path: "/api/mfhs/:mfhId/estates/:estateId/medias",
		method: "get"
	},
	getMFHEstateRenovationSummary: {
		path: "/api/mfhs/:mfhId/estates/:estateId/renovation-summary",
		method: "get"
	},
	getMFHEstateConstructionPlanBudget: {
		path: "/api/mfhs/:mfhId/estates/:estateId/construction-plan-budget",
		method: "get"
	},
	getMFHEstateRenovationCostTracking: {
		path: "/api/mfhs/:mfhId/estates/:estateId/renovation-cost-tracking",
		method: "get"
	},
	getMFHEstateRenovationInspections: {
		path: "/api/mfhs/:mfhId/estates/:estateId/renovation-inspections",
		method: "get"
	},
	getMFHDocuments: {
		path: "/api/mfhs/:mfhId/documents",
		method: "get"
	},
	updateMFHDocument: {
		path: "/api/mfhs/:mfhId/documents/:documentId",
		method: "patch"
	},
	getMFHMedias: {
		path: "/api/mfhs/:mfhId/medias",
		method: "get"
	},
	updateMFHMediaCategory: {
		path: "/api/mfhs/:mfhId/medias/category",
		method: "put"
	},
	updateMFHMediaTags: {
		path: "/api/mfhs/:mfhId/medias/tags",
		method: "put"
	},
	renameMFHMediaFile: {
		path: "/api/mfhs/:mfhId/medias/rename",
		method: "put"
	},
	getMFHDDQuestions: {
		path: "/api/mfhs/:mfhId/dd/questions",
		method: "get"
	},
	upsertMfhDDQuestion: {
		path: "/api/mfhs/:mfhId/dd/questions",
		method: "post"
	},
	getMfhDDV1Answers: {
		path: "/api/mfhs/:mfhId/dd/v1-answers",
		method: "get"
	},
	deleteMfhDdQuestion: {
		path: "/api/mfhs/:mfhId/dd/questions/:questionId",
		method: "delete"
	},
	updateMFHDDAnswer: {
		path: "/api/mfhs/:mfhId/dd/answers",
		method: "put"
	},
	updateMFHRentRoll: {
		path: "/api/mfhs/:mfhId/:estateId/rent-roll",
		method: "patch"
	},
	getMFHOpenQuestions: {
		path: "/api/mfhs/:mfhId/open-questions",
		method: "get"
	},
	getMFHRentRoll: {
		path: "/api/mfhs/:mfhId/rent-roll",
		method: "get"
	},
	createMFHOpenQuestion: {
		path: "/api/mfhs/open-questions",
		method: "post"
	},
	updateMFHOpenQuestion: {
		path: "/api/mfhs/open-questions/:openQuestionId",
		method: "put"
	},
	deleteMFHOpenQuestion: {
		path: "/api/mfhs/open-questions/:openQuestionId",
		method: "delete"
	},
	getMfhCalendarEvents: {
		path: "/api/mfhs/calendar-events",
		method: "get"
	},
	getAssetRentRoll: {
		path: "/api/mfhs/:mfhId/asset-rent-roll",
		method: "get"
	},
	getMFHStats: {
		path: "/api/mfhs/:mfhId/stats",
		method: "get"
	},
	saveDocumentsFolder: {
		path: "/api/documents-folder",
		method: "post"
	},
	moveFileToFolder: {
		path: "/api/documents-folder/move",
		method: "post"
	},
	getDataRooms: {
		path: "/api/data-room",
		method: "get"
	},
	getDataRoom: {
		path: "/api/data-room/:dataRoomId",
		method: "get"
	},
	deleteDocument: {
		path: "/api/document/:documentId",
		method: "delete"
	},
	getCompanies: {
		path: "/api/companies",
		method: "get"
	},
	getContacts: {
		path: "/api/contacts",
		method: "get"
	},
	getInvoicesList: {
		path: "/api/invoices",
		method: "get"
	},
	getInvoicesListFilterOptions: {
		path: "/api/invoices/filter-options",
		method: "get"
	},
	getInvoiceDetails: {
		path: "/api/invoices/:invoiceId",
		method: "get"
	},
	getInvoiceReviewProcess: {
		path: "/api/invoices/:invoiceId/review-process",
		method: "get"
	},
	updateReviewRequest: {
		path: "/api/review-request",
		method: "patch"
	},
	resetCache: {
		path: "/api/maintenance/reset-cache",
		method: "post"
	},
	getLookerEmbedUrl: {
		path: "/api/looker-dashboards",
		method: "get"
	},
	getMFHInvestmentCases: {
		path: "/api/mfh/:mfhId/investment-cases",
		method: "get"
	},
	downloadExternalMFHInvestmentCase: {
		path: "/api/mfh/:mfhId/investment-cases/:mfhInvestmentCaseId/download",
		method: "get"
	},
	getOneMFHInvestmentCase: {
		path: "/api/mfh/:mfhId/investment-cases/:mfhInvestmentCaseId",
		method: "get"
	},
	getNotes: {
		path: "/api/notes",
		method: "get"
	},
	createNote: {
		path: "/api/notes",
		method: "post"
	},
	updateNote: {
		path: "/api/notes/:noteId",
		method: "post"
	},
	deleteNote: {
		path: "/api/notes/:noteId",
		method: "delete"
	},
	getMentionableContacts: {
		path: "/api/notes/mentionable-contacts",
		method: "get"
	},
	getSignOffTemplates: {
		path: "/api/sign-off-templates",
		method: "get"
	},
	getSignOffEnvelopes: {
		path: "/api/sign-off-envelopes",
		method: "get"
	},
	getSignOffEnvelope: {
		path: "/api/sign-off-envelopes/:signOffEnvelopeId",
		method: "get"
	},
	processSignOffDocumentApproval: {
		path: "/api/sign-off-documents/:signOffDocumentId/approval",
		method: "post"
	},
	processSignOffDocumentSignature: {
		path: "/api/sign-off-documents/:signOffDocumentId/signature",
		method: "post"
	},
	createSignOffComment: {
		path: "/api/sign-off-comments",
		method: "post"
	},
	updateSignOffComment: {
		path: "/api/sign-off-comments/:signOffCommentId",
		method: "put"
	},
	deleteSignOffComment: {
		path: "/api/sign-off-comments/:signOffCommentId",
		method: "delete"
	},
	getExternalEnvelopeByToken: {
		path: "/api/external/sign-off-envelope/:accessToken",
		method: "get"
	},
	processExternalSignatureEvent: {
		path: "/api/external/sign-off-signature/:accessToken/process",
		method: "post"
	},
	getSignedReadUrl: {
		path: "/api/signed-read-url",
		method: "get"
	},
	getSignedUrl: {
		path: "/api/signed-url",
		method: "get"
	},
	linkMediaFile: {
		path: "/api/media-files/link",
		method: "post"
	},
	getCurrentUserProfile: {
		path: "/api/user/profile",
		method: "get"
	},
	updateUserProfile: {
		path: "/api/user/profile",
		method: "put"
	},
	changeUserPassword: {
		path: "/api/user/password",
		method: "put"
	},
	invokeDurableJob: {
		path: "/durable-jobs/invoke/:name",
		method: "post"
	},
	findDurableJobs: {
		path: "/durable-jobs",
		method: "get"
	},
	scheduleDurableJob: {
		path: "/durable-jobs",
		method: "post"
	},
	findDurableJob: {
		path: "/durable-jobs/:id",
		method: "get"
	},
	cancelDurableJob: {
		path: "/durable-jobs/:id",
		method: "delete"
	},
	findUnseenDurableJobs: {
		path: "/durable-jobs/unseen",
		method: "get"
	},
	listDurableJobs: {
		path: "/durable-jobs/list",
		method: "get"
	},
	reRunDurableJob: {
		path: "/durable-jobs/:id/rerun",
		method: "post"
	},
	markDurableJobsSeen: {
		path: "/durable-jobs/seen",
		method: "put"
	},
	batchScheduleDurableJob: {
		path: "/durable-jobs/batch",
		method: "post"
	},
	settleUserConfirmation: {
		path: "/user-confirmations/:id",
		method: "post"
	},
	fetchUserConfirmations: {
		path: "/user-confirmations",
		method: "get"
	}
};
//#endregion
//#region src/external-api/gen/clients/axios-class-client.ts
var ExternalApiSdk = class {
	client;
	constructor(client) {
		this.client = client;
	}
	async axiosClient(config) {
		return this.client.request({ ...config }).catch((e) => {
			throw e;
		});
	}
	/** @link / */
	async get(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/`,
			...options
		})).data;
	}
	/**
	* @description Get list of mfhs
	* @link /api/mfhs
	*/
	async getMfhList(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get list of pipeline mfhs
	* @link /api/pipeline-mfhs
	*/
	async getMfhPipelineList(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/pipeline-mfhs`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get pipeline MFH portfolios
	* @link /api/pipeline-mfh-portfolios
	*/
	async getPipelineMfhPortfolios(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/pipeline-mfh-portfolios`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get external MFH pipeline filter configuration
	* @link /api/pipeline-mfhs/config
	*/
	async getExternalMfhPipelineConfig(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/pipeline-mfhs/config`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get single mfh portfolio by ID
	* @link /api/mfh-portfolios/:mfhPortfolioId
	*/
	async getMfhPortfolio({ mfhPortfolioId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfh-portfolios/${mfhPortfolioId}`,
			...options
		})).data;
	}
	/**
	* @description Get MFH sheet embedding
	* @link /api/mfh-sheet-embedding
	*/
	async getMfhSheetEmbedding(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfh-sheet-embedding`,
			params,
			...options
		})).data;
	}
	/**
	* @description List MFH sheet embeddings for a portfolio (asset-partner shared slices only)
	* @link /api/mfh-sheet-embeddings
	*/
	async getMfhSheetEmbeddings(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfh-sheet-embeddings`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get mfh summary
	* @link /api/mfhs/:mfhId/summary
	*/
	async getMfhSummary({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/summary`,
			...options
		})).data;
	}
	/**
	* @description Get MFH
	* @link /api/mfhs/:mfhId
	*/
	async getMfh({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get MFH estate
	* @link /api/mfhs/:mfhId/estates/:estateId
	*/
	async getMfhEstate({ mfhId, estateId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/estates/${estateId}`,
			...options
		})).data;
	}
	/**
	* @description Get MFH estate medias with optional filtering
	* @link /api/mfhs/:mfhId/estates/:estateId/medias
	*/
	async getMfhEstateMedias({ mfhId, estateId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/estates/${estateId}/medias`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get MFH estate renovation process summary
	* @link /api/mfhs/:mfhId/estates/:estateId/renovation-summary
	*/
	async getMfhEstateRenovationSummary({ mfhId, estateId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/estates/${estateId}/renovation-summary`,
			...options
		})).data;
	}
	/**
	* @description Get MFH estate construction plan budget (for Interior/Other budget)
	* @link /api/mfhs/:mfhId/estates/:estateId/construction-plan-budget
	*/
	async getMfhEstateConstructionPlanBudget({ mfhId, estateId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/estates/${estateId}/construction-plan-budget`,
			...options
		})).data;
	}
	/**
	* @description Get MFH estate renovation cost tracking
	* @link /api/mfhs/:mfhId/estates/:estateId/renovation-cost-tracking
	*/
	async getMfhEstateRenovationCostTracking({ mfhId, estateId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/estates/${estateId}/renovation-cost-tracking`,
			...options
		})).data;
	}
	/**
	* @description Get MFH estate renovation inspections
	* @link /api/mfhs/:mfhId/estates/:estateId/renovation-inspections
	*/
	async getMfhEstateRenovationInspections({ mfhId, estateId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/estates/${estateId}/renovation-inspections`,
			...options
		})).data;
	}
	/**
	* @description Get MFH Documents
	* @link /api/mfhs/:mfhId/documents
	*/
	async getMfhDocuments({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/documents`,
			...options
		})).data;
	}
	/**
	* @description Update MFH Document
	* @link /api/mfhs/:mfhId/documents/:documentId
	*/
	async updateMfhDocument({ mfhId, documentId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/api/mfhs/${mfhId}/documents/${documentId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get MFH Medias with optional filtering
	* @link /api/mfhs/:mfhId/medias
	*/
	async getMfhMedias({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/medias`,
			params,
			...options
		})).data;
	}
	/**
	* @description Update MFH Media Categories
	* @link /api/mfhs/:mfhId/medias/category
	*/
	async updateMfhMediaCategory({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/mfhs/${mfhId}/medias/category`,
			data,
			...options
		})).data;
	}
	/**
	* @description Update MFH Media Tags
	* @link /api/mfhs/:mfhId/medias/tags
	*/
	async updateMfhMediaTags({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/mfhs/${mfhId}/medias/tags`,
			data,
			...options
		})).data;
	}
	/**
	* @description Rename MFH Media File
	* @link /api/mfhs/:mfhId/medias/rename
	*/
	async renameMfhMediaFile({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/mfhs/${mfhId}/medias/rename`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get MFH DD Questions
	* @link /api/mfhs/:mfhId/dd/questions
	*/
	async getMfhddQuestions({ mfhId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/dd/questions`,
			params,
			...options
		})).data;
	}
	/**
	* @description Upsert MFH DD Question
	* @link /api/mfhs/:mfhId/dd/questions
	*/
	async upsertMfhDdQuestion({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/mfhs/${mfhId}/dd/questions`,
			data,
			...options
		})).data;
	}
	/**
	* @description Whether the MFH has answers on the v1 DD checklists
	* @link /api/mfhs/:mfhId/dd/v1-answers
	*/
	async getMfhDdv1Answers({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/dd/v1-answers`,
			...options
		})).data;
	}
	/**
	* @description Delete MFH DD Question
	* @link /api/mfhs/:mfhId/dd/questions/:questionId
	*/
	async deleteMfhDdQuestion({ questionId, mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/mfhs/${mfhId}/dd/questions/${questionId}`,
			...options
		})).data;
	}
	/**
	* @description Update MFH DD Answer
	* @link /api/mfhs/:mfhId/dd/answers
	*/
	async updateMfhddAnswer({ mfhId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/mfhs/${mfhId}/dd/answers`,
			data,
			...options
		})).data;
	}
	/**
	* @description Update MFH Rent Roll
	* @link /api/mfhs/:mfhId/:estateId/rent-roll
	*/
	async updateMfhRentRoll({ mfhId, estateId }, data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/api/mfhs/${mfhId}/${estateId}/rent-roll`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get MFH Open Questions
	* @link /api/mfhs/:mfhId/open-questions
	*/
	async getMfhOpenQuestions({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/open-questions`,
			...options
		})).data;
	}
	/**
	* @description Get MFH Rent Roll
	* @link /api/mfhs/:mfhId/rent-roll
	*/
	async getMfhRentRoll({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/rent-roll`,
			...options
		})).data;
	}
	/**
	* @description Create MFH Open Questions
	* @link /api/mfhs/open-questions
	*/
	async createMfhOpenQuestion(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/mfhs/open-questions`,
			data,
			...options
		})).data;
	}
	/**
	* @description Update MFH Open Questions
	* @link /api/mfhs/open-questions/:openQuestionId
	*/
	async updateMfhOpenQuestion({ openQuestionId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/mfhs/open-questions/${openQuestionId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Delete MFH Open Questions
	* @link /api/mfhs/open-questions/:openQuestionId
	*/
	async deleteMfhOpenQuestion({ openQuestionId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/mfhs/open-questions/${openQuestionId}`,
			...options
		})).data;
	}
	/**
	* @description Get list of mfhs calendar events where current user is attendee
	* @link /api/mfhs/calendar-events
	*/
	async getMfhCalendarEvents(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/calendar-events`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get asset rent roll for MFH
	* @link /api/mfhs/:mfhId/asset-rent-roll
	*/
	async getAssetRentRoll({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/asset-rent-roll`,
			...options
		})).data;
	}
	/**
	* @description Get MFH KPIs / stats
	* @link /api/mfhs/:mfhId/stats
	*/
	async getMfhStats({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfhs/${mfhId}/stats`,
			...options
		})).data;
	}
	/**
	* @description Save an mfh document folder
	* @link /api/documents-folder
	*/
	async saveDocumentsFolder(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/documents-folder`,
			data,
			...options
		})).data;
	}
	/**
	* @description Moves document files/folders
	* @link /api/documents-folder/move
	*/
	async moveFileToFolder(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/documents-folder/move`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get all data rooms
	* @link /api/data-room
	*/
	async getDataRooms(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/data-room`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get a data room
	* @link /api/data-room/:dataRoomId
	*/
	async getDataRoom({ dataRoomId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/data-room/${dataRoomId}`,
			...options
		})).data;
	}
	/**
	* @description Delete a document
	* @link /api/document/:documentId
	*/
	async deleteDocument({ documentId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/document/${documentId}`,
			...options
		})).data;
	}
	/**
	* @description Get Companies
	* @link /api/companies
	*/
	async getCompanies(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/companies`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get Contacts
	* @link /api/contacts
	*/
	async getContacts(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/contacts`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get list of invoices
	* @link /api/invoices
	*/
	async getInvoicesList(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/invoices`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get filter options for invoices list
	* @link /api/invoices/filter-options
	*/
	async getInvoicesListFilterOptions(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/invoices/filter-options`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get specific invoice
	* @link /api/invoices/:invoiceId
	*/
	async getInvoiceDetails({ invoiceId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/invoices/${invoiceId}`,
			...options
		})).data;
	}
	/**
	* @description Get invoice review processes
	* @link /api/invoices/:invoiceId/review-process
	*/
	async getInvoiceReviewProcess({ invoiceId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/invoices/${invoiceId}/review-process`,
			...options
		})).data;
	}
	/**
	* @description Update review request
	* @link /api/review-request
	*/
	async updateReviewRequest(data, options = {}) {
		return (await this.axiosClient({
			method: "patch",
			url: `/api/review-request`,
			data,
			...options
		})).data;
	}
	/**
	* @description Reset Cache
	* @link /api/maintenance/reset-cache
	*/
	async resetCache(options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/maintenance/reset-cache`,
			...options
		})).data;
	}
	/**
	* @description Save an mfh document folder
	* @link /api/looker-dashboards
	*/
	async getLookerEmbedUrl(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/looker-dashboards`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get list of mfh investment-cases
	* @link /api/mfh/:mfhId/investment-cases
	*/
	async getMfhInvestmentCases({ mfhId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfh/${mfhId}/investment-cases`,
			...options
		})).data;
	}
	/**
	* @description Download mfh investment-case as excel
	* @link /api/mfh/:mfhId/investment-cases/:mfhInvestmentCaseId/download
	*/
	async downloadExternalMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfh/${mfhId}/investment-cases/${mfhInvestmentCaseId}/download`,
			...options
		})).data;
	}
	/**
	* @description Get one mfh investment-case by id
	* @link /api/mfh/:mfhId/investment-cases/:mfhInvestmentCaseId
	*/
	async getOneMfhInvestmentCase({ mfhId, mfhInvestmentCaseId }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/mfh/${mfhId}/investment-cases/${mfhInvestmentCaseId}`,
			...options
		})).data;
	}
	/**
	* @description Get Notes
	* @link /api/notes
	*/
	async getNotes(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/notes`,
			params,
			...options
		})).data;
	}
	/**
	* @description Create Note
	* @link /api/notes
	*/
	async createNote(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/notes`,
			data,
			...options
		})).data;
	}
	/**
	* @description Update Note
	* @link /api/notes/:noteId
	*/
	async updateNote({ noteId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/notes/${noteId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Delete Note
	* @link /api/notes/:noteId
	*/
	async deleteNote({ noteId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/notes/${noteId}`,
			...options
		})).data;
	}
	/**
	* @description Get Mentionable Contacts
	* @link /api/notes/mentionable-contacts
	*/
	async getMentionableContacts(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/notes/mentionable-contacts`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get Sign-Off Templates
	* @link /api/sign-off-templates
	*/
	async getSignOffTemplates(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/sign-off-templates`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get Sign-Off Envelopes
	* @link /api/sign-off-envelopes
	*/
	async getSignOffEnvelopes(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/sign-off-envelopes`,
			params,
			...options
		})).data;
	}
	/**
	* @description Get Sign-Off Envelope by ID
	* @link /api/sign-off-envelopes/:signOffEnvelopeId
	*/
	async getSignOffEnvelope({ signOffEnvelopeId }, params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/sign-off-envelopes/${signOffEnvelopeId}`,
			params,
			...options
		})).data;
	}
	/**
	* @description Process Sign-Off Document Approval
	* @link /api/sign-off-documents/:signOffDocumentId/approval
	*/
	async processSignOffDocumentApproval({ signOffDocumentId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/sign-off-documents/${signOffDocumentId}/approval`,
			data,
			...options
		})).data;
	}
	/**
	* @description Process Sign-Off Document Signature
	* @link /api/sign-off-documents/:signOffDocumentId/signature
	*/
	async processSignOffDocumentSignature({ signOffDocumentId }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/sign-off-documents/${signOffDocumentId}/signature`,
			data,
			...options
		})).data;
	}
	/**
	* @description Create Sign-Off Comment
	* @link /api/sign-off-comments
	*/
	async createSignOffComment(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/sign-off-comments`,
			data,
			...options
		})).data;
	}
	/**
	* @description Update Sign-Off Comment
	* @link /api/sign-off-comments/:signOffCommentId
	*/
	async updateSignOffComment({ signOffCommentId }, data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/sign-off-comments/${signOffCommentId}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Delete Sign-Off Comment
	* @link /api/sign-off-comments/:signOffCommentId
	*/
	async deleteSignOffComment({ signOffCommentId }, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/api/sign-off-comments/${signOffCommentId}`,
			...options
		})).data;
	}
	/**
	* @description Get Sign-Off Envelope by Access Token (No Auth Required)
	* @link /api/external/sign-off-envelope/:accessToken
	*/
	async getExternalEnvelopeByToken({ accessToken }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/external/sign-off-envelope/${accessToken}`,
			...options
		})).data;
	}
	/**
	* @description Process External Signature Event (No Auth Required)
	* @link /api/external/sign-off-signature/:accessToken/process
	*/
	async processExternalSignatureEvent({ accessToken }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/external/sign-off-signature/${accessToken}/process`,
			data,
			...options
		})).data;
	}
	/**
	* @description Gets a signed url for reading a file from google bucket
	* @link /api/signed-read-url
	*/
	async getSignedReadUrl(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/signed-read-url`,
			params,
			...options
		})).data;
	}
	/**
	* @description Gets a signed url for uploading a file to google bucket
	* @link /api/signed-url
	*/
	async getSignedUrl(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/signed-url`,
			params,
			...options
		})).data;
	}
	/**
	* @description Links an uploaded file to create a media file record
	* @link /api/media-files/link
	*/
	async linkMediaFile(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/api/media-files/link`,
			data,
			...options
		})).data;
	}
	/**
	* @description Get current user profile
	* @link /api/user/profile
	*/
	async getCurrentUserProfile(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/api/user/profile`,
			...options
		})).data;
	}
	/**
	* @description Update user profile (username, name)
	* @link /api/user/profile
	*/
	async updateUserProfile(data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/user/profile`,
			data,
			...options
		})).data;
	}
	/**
	* @description Change user password
	* @link /api/user/password
	*/
	async changeUserPassword(data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/api/user/password`,
			data,
			...options
		})).data;
	}
	/**
	* @description invoke durable job by name
	* @link /durable-jobs/invoke/:name
	*/
	async invokeDurableJob({ name }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/durable-jobs/invoke/${name}`,
			data,
			...options
		})).data;
	}
	/**
	* @description finds durable jobs
	* @link /durable-jobs
	*/
	async findDurableJobs(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/durable-jobs`,
			params,
			...options
		})).data;
	}
	/**
	* @description schedules a durable job
	* @link /durable-jobs
	*/
	async scheduleDurableJob(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/durable-jobs`,
			data,
			...options
		})).data;
	}
	/**
	* @description finds a durable job
	* @link /durable-jobs/:id
	*/
	async findDurableJob({ id }, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/durable-jobs/${id}`,
			...options
		})).data;
	}
	/**
	* @description cancels a durable job
	* @link /durable-jobs/:id
	*/
	async cancelDurableJob({ id }, params, options = {}) {
		return (await this.axiosClient({
			method: "delete",
			url: `/durable-jobs/${id}`,
			params,
			...options
		})).data;
	}
	/**
	* @description finds user unseen durable jobs
	* @link /durable-jobs/unseen
	*/
	async findUnseenDurableJobs(params, options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/durable-jobs/unseen`,
			params,
			...options
		})).data;
	}
	/**
	* @description lists durable jobs
	* @link /durable-jobs/list
	*/
	async listDurableJobs(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/durable-jobs/list`,
			...options
		})).data;
	}
	/**
	* @description reruns a durable job
	* @link /durable-jobs/:id/rerun
	*/
	async reRunDurableJob({ id }, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/durable-jobs/${id}/rerun`,
			...options
		})).data;
	}
	/**
	* @description marks durable jobs as seen
	* @link /durable-jobs/seen
	*/
	async markDurableJobsSeen(data, options = {}) {
		return (await this.axiosClient({
			method: "put",
			url: `/durable-jobs/seen`,
			data,
			...options
		})).data;
	}
	/**
	* @description batch schedules a durable job
	* @link /durable-jobs/batch
	*/
	async batchScheduleDurableJob(data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/durable-jobs/batch`,
			data,
			...options
		})).data;
	}
	/**
	* @description Settles a user-confirmation (either approved or rejected)
	* @link /user-confirmations/:id
	*/
	async settleUserConfirmation({ id }, data, options = {}) {
		return (await this.axiosClient({
			method: "post",
			url: `/user-confirmations/${id}`,
			data,
			...options
		})).data;
	}
	/**
	* @description Fetches user-confirmations, which are not yet approved/rejected
	* @link /user-confirmations
	*/
	async fetchUserConfirmations(options = {}) {
		return (await this.axiosClient({
			method: "get",
			url: `/user-confirmations`,
			...options
		})).data;
	}
};
//#endregion
export { AssetRentRollRentableUnitState, AssetRentRollRentableUnitState2, AssetRentRollRentableUnitState3, AssetRentRollRentableUnitState4, AssetRentRollRentableUnitState5, AssetRentRollRentableUnitState6, AttendeeArrayResponseStatus, AttendeeArrayResponseStatus2, AttendeeArrayResponseStatus3, AttendeeArrayResponseStatus4, AttendeeResponseStatus, AttendeeResponseStatus2, AttendeeResponseStatus3, AttendeeResponseStatus4, AttendeesResponseStatus, AttendeesResponseStatus2, AttendeesResponseStatus3, AttendeesResponseStatus4, BaseCompanySellingPartner, BaseCompanyType, BaseCompanyType10, BaseCompanyType11, BaseCompanyType12, BaseCompanyType13, BaseCompanyType14, BaseCompanyType15, BaseCompanyType16, BaseCompanyType17, BaseCompanyType18, BaseCompanyType19, BaseCompanyType2, BaseCompanyType20, BaseCompanyType21, BaseCompanyType22, BaseCompanyType23, BaseCompanyType24, BaseCompanyType25, BaseCompanyType26, BaseCompanyType27, BaseCompanyType28, BaseCompanyType29, BaseCompanyType3, BaseCompanyType30, BaseCompanyType31, BaseCompanyType32, BaseCompanyType33, BaseCompanyType34, BaseCompanyType35, BaseCompanyType36, BaseCompanyType37, BaseCompanyType38, BaseCompanyType39, BaseCompanyType4, BaseCompanyType40, BaseCompanyType5, BaseCompanyType6, BaseCompanyType7, BaseCompanyType8, BaseCompanyType9, BaseInvoiceSchemaCostType, BaseInvoiceSchemaInvoiceType, BaseInvoiceSchemaSource, BaseInvoiceSchemaState, BaseInvoiceSchemaVatClass, BaseReviewProcessReviewProcessState, CommentsConstructionCraft, CommentsConstructionCraft2, CommentsConstructionCraft3, CommentsType, CommentsType2, CommentsType3, CompanyEmploymentRelationCompanyRole, ContactPersonContactType, ContactRelationRelationName, ContactRelationRelationName10, ContactRelationRelationName11, ContactRelationRelationName12, ContactRelationRelationName13, ContactRelationRelationName14, ContactRelationRelationName15, ContactRelationRelationName16, ContactRelationRelationName17, ContactRelationRelationName18, ContactRelationRelationName19, ContactRelationRelationName2, ContactRelationRelationName20, ContactRelationRelationName21, ContactRelationRelationName22, ContactRelationRelationName23, ContactRelationRelationName24, ContactRelationRelationName25, ContactRelationRelationName26, ContactRelationRelationName27, ContactRelationRelationName28, ContactRelationRelationName29, ContactRelationRelationName3, ContactRelationRelationName30, ContactRelationRelationName31, ContactRelationRelationName32, ContactRelationRelationName33, ContactRelationRelationName34, ContactRelationRelationName35, ContactRelationRelationName36, ContactRelationRelationName37, ContactRelationRelationName38, ContactRelationRelationName39, ContactRelationRelationName4, ContactRelationRelationName40, ContactRelationRelationName41, ContactRelationRelationName42, ContactRelationRelationName43, ContactRelationRelationName44, ContactRelationRelationName45, ContactRelationRelationName46, ContactRelationRelationName47, ContactRelationRelationName48, ContactRelationRelationName49, ContactRelationRelationName5, ContactRelationRelationName50, ContactRelationRelationName51, ContactRelationRelationName52, ContactRelationRelationName53, ContactRelationRelationName54, ContactRelationRelationName55, ContactRelationRelationName56, ContactRelationRelationName6, ContactRelationRelationName7, ContactRelationRelationName8, ContactRelationRelationName9, CreateNoteMutationRequestType, DataDocumentCategory, DataDocumentType, DataRentalContractReviewProcessState, DataRentalContractReviewProcessState2, DataRentalContractReviewProcessState3, DataRentalContractReviewProcessState4, DataRentalContractReviewProcessState5, DataRentalContractReviewProcessState6, DataRentalContractReviewProcessState7, DataRentalContractReviewProcessState8, DecisionAction, DecisionAction2, DecisionAction3, DecisionAction4, DecisionAction5, DecisionAction6, DecisionAction7, DecisionAction8, DocumentApprovalStatus, DocumentApprovalStatus2, DocumentApprovalStatus3, DocumentSchemaDocumentCategory, DocumentSchemaDocumentType, DocumentSignatureStatus, DocumentSignatureStatus2, DocumentSignatureStatus3, DocumentSignatureStatus4, DownloadExternalMfhInvestmentCase200Status, DownloadExternalMfhInvestmentCaseQueryResponseStatus, EmbeddingConfigPrecacheFailureReason, EmbeddingConfigPrecacheFailureReason2, EmbeddingConfigPrecacheFailureReason3, EmbeddingConfigPrecacheFailureReason4, EmbeddingConfigPrecacheStatus, EmbeddingConfigPrecacheStatus2, EmbeddingConfigPrecacheStatus3, EmbeddingConfigPrecacheStatus4, EmbeddingConfigPrecacheStatus5, ExternalApiSdk, ExternalAttendeeArrayResponseStatus, ExternalAttendeeArrayResponseStatus2, ExternalAttendeeArrayResponseStatus3, ExternalAttendeeArrayResponseStatus4, ExternalAttendeeSchemaResponseStatus, ExternalAttendeeSchemaResponseStatus2, ExternalAttendeeSchemaResponseStatus3, ExternalAttendeeSchemaResponseStatus4, ExternalAttendeesResponseStatus, ExternalAttendeesResponseStatus2, ExternalAttendeesResponseStatus3, ExternalAttendeesResponseStatus4, ExternalCalendarEventCalendarType, ExternalCalendarEventCalendarType2, ExternalCalendarEventCalendarType3, ExternalCalendarEventCalendarType4, ExternalCalendarEventCalendarType5, ExternalCalendarEventCalendarType6, ExternalCalendarEventCalendarType7, ExternalCalendarEventCalendarType8, ExternalInvoiceCostType, ExternalInvoiceInvoiceType, ExternalInvoiceSource, ExternalInvoiceState, ExternalInvoiceVatClass, ExternalLinkDtoStatus, ExternalLinkDtoStatus2, ExternalLinksStatus, ExternalLinksStatus2, ExternalLinksStatus3, ExternalLinksStatus4, ExternalMfhAttributesAdjoiningBuilding, ExternalMfhAttributesAdjoiningBuilding2, ExternalMfhAttributesAdjoiningBuilding3, ExternalMfhAttributesBuildingEnergyRating, ExternalMfhAttributesBuildingEnergyRating2, ExternalMfhAttributesBuildingEnergyRating3, ExternalMfhAttributesCellarHeating, ExternalMfhAttributesCellarHeating2, ExternalMfhAttributesCellarHeating3, ExternalMfhAttributesExitType, ExternalMfhAttributesExitType2, ExternalMfhAttributesExitType3, ExternalMfhAttributesInvestmentRiskProfile, ExternalMfhAttributesRestrictions, ExternalMfhAttributesRestrictions2, ExternalMfhAttributesRestrictions3, ExternalMfhAttributesRestrictions4, ExternalMfhAttributesRestrictions5, ExternalMfhAttributesRestrictions6, ExternalMfhAttributesRestrictions7, ExternalMfhAttributesRestrictions8, ExternalMfhAttributesRiwisLocation, ExternalMfhAttributesRiwisLocation2, ExternalMfhAttributesRiwisLocation3, ExternalMfhAttributesRiwisLocation4, ExternalMfhAttributesRiwisLocation5, ExternalMfhAttributesRiwisLocation6, ExternalMfhAttributesRiwisLocation7, ExternalMfhAttributesRiwisLocation8, ExternalMfhAttributesRiwisLocation9, ExternalMfhAttributesRoofOrientation, ExternalMfhAttributesRoofOrientation2, ExternalMfhAttributesRoofOrientation3, ExternalMfhAttributesRoofOrientation4, ExternalMfhAttributesRoofOrientation5, ExternalMfhAttributesRoofOrientation6, ExternalMfhAttributesRoofOrientation7, ExternalMfhAttributesRoofOrientation8, ExternalMfhAttributesRoofShape, ExternalMfhAttributesRoofShape2, ExternalMfhAttributesRoofShape3, ExternalMfhAttributesRoofShape4, ExternalMfhAttributesRoofShape5, ExternalMfhAttributesRoofUse, ExternalMfhAttributesRoofUse2, ExternalMfhAttributesRoofUse3, ExternalMfhAttributesSplitStatus, ExternalMfhAttributesSplitStatus2, ExternalMfhAttributesSplitStatus3, ExternalMfhAttributesSplitStatus4, ExternalMfhAttributesWaterHeating, ExternalMfhAttributesWaterHeating2, ExternalMfhAttributesWindowGlazing, ExternalMfhAttributesWindowGlazing2, ExternalMfhAttributesWindowGlazing3, ExternalMfhAttributesWindowGlazing4, ExternalMfhChannelName, ExternalMfhChannelName10, ExternalMfhChannelName11, ExternalMfhChannelName2, ExternalMfhChannelName3, ExternalMfhChannelName4, ExternalMfhChannelName5, ExternalMfhChannelName6, ExternalMfhChannelName7, ExternalMfhChannelName8, ExternalMfhChannelName9, ExternalMfhEstateType, ExternalMfhEstateType2, ExternalMfhEstateType3, ExternalMfhSource, ExternalMfhSource2, ExternalMfhSource3, ExternalMfhSource4, ExternalMfhSource5, FindDurableJobsQueryParamsStatus, FindDurableJobsQueryParamsStatus2, FindDurableJobsQueryParamsStatus3, FindDurableJobsQueryParamsStatus4, FindDurableJobsQueryParamsStatus5, FindDurableJobsQueryParamsStatus6, GetExternalMfhPipelineConfigQueryParamsSourcingState, GetInvoicesListFilterOptionsQueryParamsCostType, GetInvoicesListFilterOptionsQueryParamsOrder, GetInvoicesListFilterOptionsQueryParamsOrder2, GetInvoicesListFilterOptionsQueryParamsState, GetInvoicesListQueryParamsCostType, GetInvoicesListQueryParamsOrder, GetInvoicesListQueryParamsOrder2, GetInvoicesListQueryParamsState, GetMfhEstateMediasQueryParamsCategories, GetMfhMediasQueryParamsCategories, GetMfhPipelineListQueryParamsInvestmentRiskProfile, GetMfhPipelineListQueryParamsOrder, GetMfhPipelineListQueryParamsOrder2, GetMfhPipelineListQueryParamsSourcingState, GetMfhddQuestionsQueryParamsType, GetSignOffEnvelopesQueryParamsOrder, GetSignOffEnvelopesQueryParamsOrder2, GetSignOffEnvelopesQueryParamsPriority, GetSignOffEnvelopesQueryParamsPriority2, GetSignOffEnvelopesQueryParamsPriority3, GetSignOffEnvelopesQueryParamsPriority4, GetSignOffEnvelopesQueryParamsStatus, GetSignOffEnvelopesQueryParamsStatus10, GetSignOffEnvelopesQueryParamsStatus11, GetSignOffEnvelopesQueryParamsStatus12, GetSignOffEnvelopesQueryParamsStatus13, GetSignOffEnvelopesQueryParamsStatus14, GetSignOffEnvelopesQueryParamsStatus15, GetSignOffEnvelopesQueryParamsStatus16, GetSignOffEnvelopesQueryParamsStatus2, GetSignOffEnvelopesQueryParamsStatus3, GetSignOffEnvelopesQueryParamsStatus4, GetSignOffEnvelopesQueryParamsStatus5, GetSignOffEnvelopesQueryParamsStatus6, GetSignOffEnvelopesQueryParamsStatus7, GetSignOffEnvelopesQueryParamsStatus8, GetSignOffEnvelopesQueryParamsStatus9, GetSignedUrlQueryParamsAction, GetSignedUrlQueryParamsAction2, GetSignedUrlQueryParamsAction3, GetSignedUrlQueryParamsAction4, GetSignedUrlQueryParamsVersion, GetSignedUrlQueryParamsVersion2, LinkMediaFileMutationRequestCategory, LinkMediaFileMutationRequestCategory10, LinkMediaFileMutationRequestCategory2, LinkMediaFileMutationRequestCategory3, LinkMediaFileMutationRequestCategory4, LinkMediaFileMutationRequestCategory5, LinkMediaFileMutationRequestCategory6, LinkMediaFileMutationRequestCategory7, LinkMediaFileMutationRequestCategory8, LinkMediaFileMutationRequestCategory9, MediaCategory, MediaCategory10, MediaCategory2, MediaCategory3, MediaCategory4, MediaCategory5, MediaCategory6, MediaCategory7, MediaCategory8, MediaCategory9, MediaFileVariantVariant, MediaFileVariantVariant2, MediaInternalTags, MediaInternalTags2, MediaTags, MediaTags10, MediaTags11, MediaTags12, MediaTags13, MediaTags14, MediaTags15, MediaTags16, MediaTags17, MediaTags18, MediaTags19, MediaTags2, MediaTags20, MediaTags21, MediaTags22, MediaTags23, MediaTags24, MediaTags25, MediaTags26, MediaTags27, MediaTags28, MediaTags3, MediaTags4, MediaTags5, MediaTags6, MediaTags7, MediaTags8, MediaTags9, MfhChannelName, MfhChannelName10, MfhChannelName11, MfhChannelName2, MfhChannelName3, MfhChannelName4, MfhChannelName5, MfhChannelName6, MfhChannelName7, MfhChannelName8, MfhChannelName9, MfhEstateType, MfhEstateType2, MfhEstateType3, MfhSource, MfhSource2, MfhSource3, MfhSource4, MfhSource5, NoteConstructionCraft, NoteConstructionCraft2, NoteConstructionCraft3, NoteConstructionCraft4, NoteType, NoteType2, NoteType3, NoteType4, NotesConstructionCraft, NotesConstructionCraft2, NotesType, NotesType2, OpenQuestionPriority, OpenQuestionStatus, OpenQuestionTopic, ParkingSpaceParkingSpaceType, ProcessExternalSignatureEventMutationRequestEvent, ProcessExternalSignatureEventMutationRequestEvent2, ProcessSignOffDocumentApprovalMutationRequestEvent, ProcessSignOffDocumentApprovalMutationRequestEvent2, ProcessSignOffDocumentApprovalMutationRequestEvent3, ProcessSignOffDocumentSignatureMutationRequestEvent, ProcessSignOffDocumentSignatureMutationRequestEvent2, ProcessSignOffDocumentSignatureMutationRequestEvent3, ProcessSignOffDocumentSignatureMutationRequestEvent4, QueryCompanyFunction, QueryCompanyFunction10, QueryCompanyFunction11, QueryCompanyFunction12, QueryCompanyFunction13, QueryCompanyFunction14, QueryCompanyFunction15, QueryCompanyFunction16, QueryCompanyFunction17, QueryCompanyFunction18, QueryCompanyFunction19, QueryCompanyFunction2, QueryCompanyFunction20, QueryCompanyFunction21, QueryCompanyFunction22, QueryCompanyFunction23, QueryCompanyFunction24, QueryCompanyFunction25, QueryCompanyFunction26, QueryCompanyFunction27, QueryCompanyFunction28, QueryCompanyFunction29, QueryCompanyFunction3, QueryCompanyFunction30, QueryCompanyFunction4, QueryCompanyFunction5, QueryCompanyFunction6, QueryCompanyFunction7, QueryCompanyFunction8, QueryCompanyFunction9, QueryCompanyType, QueryCompanyType10, QueryCompanyType11, QueryCompanyType12, QueryCompanyType13, QueryCompanyType14, QueryCompanyType15, QueryCompanyType16, QueryCompanyType17, QueryCompanyType18, QueryCompanyType19, QueryCompanyType2, QueryCompanyType20, QueryCompanyType21, QueryCompanyType22, QueryCompanyType23, QueryCompanyType24, QueryCompanyType25, QueryCompanyType26, QueryCompanyType27, QueryCompanyType28, QueryCompanyType29, QueryCompanyType3, QueryCompanyType30, QueryCompanyType31, QueryCompanyType32, QueryCompanyType33, QueryCompanyType34, QueryCompanyType35, QueryCompanyType36, QueryCompanyType37, QueryCompanyType38, QueryCompanyType39, QueryCompanyType4, QueryCompanyType40, QueryCompanyType5, QueryCompanyType6, QueryCompanyType7, QueryCompanyType8, QueryCompanyType9, QueryContactType, QueryContactType10, QueryContactType11, QueryContactType12, QueryContactType13, QueryContactType14, QueryContactType15, QueryContactType16, QueryContactType17, QueryContactType18, QueryContactType19, QueryContactType2, QueryContactType20, QueryContactType21, QueryContactType22, QueryContactType23, QueryContactType24, QueryContactType25, QueryContactType26, QueryContactType27, QueryContactType28, QueryContactType3, QueryContactType4, QueryContactType5, QueryContactType6, QueryContactType7, QueryContactType8, QueryContactType9, QueryRelationName, QueryRelationName10, QueryRelationName11, QueryRelationName12, QueryRelationName13, QueryRelationName14, QueryRelationName15, QueryRelationName16, QueryRelationName17, QueryRelationName18, QueryRelationName19, QueryRelationName2, QueryRelationName20, QueryRelationName21, QueryRelationName22, QueryRelationName23, QueryRelationName24, QueryRelationName25, QueryRelationName26, QueryRelationName27, QueryRelationName28, QueryRelationName29, QueryRelationName3, QueryRelationName30, QueryRelationName31, QueryRelationName32, QueryRelationName33, QueryRelationName34, QueryRelationName35, QueryRelationName36, QueryRelationName37, QueryRelationName38, QueryRelationName39, QueryRelationName4, QueryRelationName40, QueryRelationName41, QueryRelationName42, QueryRelationName43, QueryRelationName44, QueryRelationName45, QueryRelationName46, QueryRelationName47, QueryRelationName48, QueryRelationName49, QueryRelationName5, QueryRelationName50, QueryRelationName51, QueryRelationName52, QueryRelationName53, QueryRelationName54, QueryRelationName55, QueryRelationName56, QueryRelationName6, QueryRelationName7, QueryRelationName8, QueryRelationName9, QueryType, RentalContractSchemaApartmentCondition, RentalContractSchemaCondoSalesCondition, RentalContractSchemaRentIncreaseType, ReviewProcessReviewProcessState, ReviewProcessReviewProcessState2, ReviewRequestReviewRequestState, SettleUserConfirmationMutationRequestStatus, SignOffDocumentSignatureProvider, SignOffDocumentStatus, SignOffDocumentStatus2, SignOffDocumentStatus3, SignOffDocumentStatus4, SignOffDocumentStatus5, SignOffDocumentStatus6, SignOffDocumentStatus7, SignOffDocumentStatus8, SignOffDocumentStatus9, SignOffEnvelopePriority, SignOffEnvelopePriority2, SignOffEnvelopeStatus, SignOffEnvelopeStatus2, SignOffEnvelopeStatus3, SignOffEnvelopeStatus4, SignOffEnvelopeStatus5, SignOffEnvelopeStatus6, SignOffEnvelopeStatus7, SignOffEnvelopeStatus8, SignOffTemplateTemplateType, SignOffTemplateTemplateType2, UpdateMfhMediaCategoryMutationRequestCategory, UpdateMfhMediaCategoryMutationRequestCategory10, UpdateMfhMediaCategoryMutationRequestCategory2, UpdateMfhMediaCategoryMutationRequestCategory3, UpdateMfhMediaCategoryMutationRequestCategory4, UpdateMfhMediaCategoryMutationRequestCategory5, UpdateMfhMediaCategoryMutationRequestCategory6, UpdateMfhMediaCategoryMutationRequestCategory7, UpdateMfhMediaCategoryMutationRequestCategory8, UpdateMfhMediaCategoryMutationRequestCategory9, axios_exports as externalApi, initHTTPClient as initExternalApiHTTPClient };
